// Avoid `console` errors in browsers that lack a console.
(function () {
  var method;
  var noop = function () {};
  var methods = [
    "assert",
    "clear",
    "count",
    "debug",
    "dir",
    "dirxml",
    "error",
    "exception",
    "group",
    "groupCollapsed",
    "groupEnd",
    "info",
    "log",
    "markTimeline",
    "profile",
    "profileEnd",
    "table",
    "time",
    "timeEnd",
    "timeStamp",
    "trace",
    "warn",
  ];
  var length = methods.length;
  var console = (window.console = window.console || {});

  while (length--) {
    method = methods[length];

    // Only stub undefined methods.
    if (!console[method]) {
      console[method] = noop;
    }
  }
})();

/*!
 * response.js 0.9.0+201404091831
 * https://github.com/ryanve/response.js
 * MIT License (c) 2014 Ryan Van Etten
 */
!(function (a, b, c) {
  var d = a.jQuery || a.Zepto || a.ender || a.elo;
  "undefined" != typeof module && module.exports
    ? (module.exports = c(d))
    : (a[b] = c(d));
})(this, "Response", function (a) {
  function b(a) {
    return a === +a;
  }
  function c(a, b) {
    return function () {
      return a.apply(b, arguments);
    };
  }
  function d(a, b) {
    var c = this.call();
    return c >= (a || 0) && (!b || b >= c);
  }
  function e(a, b, c) {
    for (var d = [], e = a.length, f = 0; e > f; )
      d[f] = b.call(c, a[f], f++, a);
    return d;
  }
  function f(a) {
    return a ? i("string" == typeof a ? a.split(" ") : a) : [];
  }
  function g(a, b, c) {
    if (null == a) return a;
    for (var d = a.length, e = 0; d > e; ) b.call(c || a[e], a[e], e++, a);
    return a;
  }
  function h(a, b, c) {
    null == b && (b = ""), null == c && (c = "");
    for (var d = [], e = a.length, f = 0; e > f; f++)
      null == a[f] || d.push(b + a[f] + c);
    return d;
  }
  function i(a, b, c) {
    var d,
      e,
      f,
      g = [],
      h = 0,
      i = 0,
      j = "function" == typeof b,
      k = !0 === c;
    for (e = a && a.length, c = k ? null : c; e > i; i++)
      (f = a[i]),
        (d = j ? !b.call(c, f, i, a) : b ? typeof f !== b : !f),
        d === k && (g[h++] = f);
    return g;
  }
  function j(a, c) {
    if (null == a || null == c) return a;
    if ("object" == typeof c && b(c.length)) _.apply(a, i(c, "undefined", !0));
    else for (var d in c) cb.call(c, d) && void 0 !== c[d] && (a[d] = c[d]);
    return a;
  }
  function k(a, c, d) {
    return null == a
      ? a
      : ("object" == typeof a && !a.nodeType && b(a.length)
          ? g(a, c, d)
          : c.call(d || a, a),
        a);
  }
  function l(a) {
    var b = T.devicePixelRatio;
    return null == a
      ? b || (l(2) ? 2 : l(1.5) ? 1.5 : l(1) ? 1 : 0)
      : isFinite(a)
      ? b && b > 0
        ? b >= a
        : ((a = "only all and (min--moz-device-pixel-ratio:" + a + ")"),
          zb(a) ? !0 : zb(a.replace("-moz-", "")))
      : !1;
  }
  function m(a) {
    return a.replace(tb, "$1").replace(sb, function (a, b) {
      return b.toUpperCase();
    });
  }
  function n(a) {
    return (
      "data-" + (a ? a.replace(tb, "$1").replace(rb, "$1-$2").toLowerCase() : a)
    );
  }
  function o(a) {
    var b;
    return "string" == typeof a && a
      ? "false" === a
        ? !1
        : "true" === a
        ? !0
        : "null" === a
        ? null
        : "undefined" === a || (b = +a) || 0 === b || "NaN" === a
        ? b
        : a
      : a;
  }
  function p(a) {
    return !a || a.nodeType ? a : a[0];
  }
  function q(a, b, c) {
    var d, e, f, g, h;
    if (a.attributes)
      for (
        d = "boolean" == typeof c ? /^data-/ : d,
          g = 0,
          h = a.attributes.length;
        h > g;

      )
        (f = a.attributes[g++]) &&
          ((e = "" + f.name),
          (d && d.test(e) !== c) ||
            null == f.value ||
            b.call(a, f.value, e, f));
  }
  function r(a) {
    var b;
    if (a && 1 === a.nodeType)
      return (b = Y && a.dataset)
        ? b
        : ((b = {}),
          q(
            a,
            function (a, c) {
              b[m(c)] = "" + a;
            },
            !0
          ),
          b);
  }
  function s(a, b, c) {
    for (var d in b) cb.call(b, d) && c(a, d, b[d]);
  }
  function t(a, b, c) {
    if (((a = p(a)), a && a.setAttribute)) {
      if (void 0 === b && c === b) return r(a);
      var d = db(b) && n(b[0]);
      if ("object" != typeof b || d) {
        if (((b = d || n(b)), !b)) return;
        return void 0 === c
          ? ((b = a.getAttribute(b)), null == b ? c : d ? o(b) : "" + b)
          : (a.setAttribute(b, (c = "" + c)), c);
      }
      b && s(a, b, t);
    }
  }
  function u(a, b) {
    (b = f(b)),
      k(a, function (a) {
        g(b, function (b) {
          a.removeAttribute(n(b));
        });
      });
  }
  function v(a) {
    for (var b, c = [], d = 0, e = a.length; e > d; )
      (b = a[d++]) &&
        c.push("[" + n(b.replace(qb, "").replace(".", "\\.")) + "]");
    return c.join();
  }
  function w(b) {
    return a(v(f(b)));
  }
  function x() {
    return window.pageXOffset || V.scrollLeft;
  }
  function y() {
    return window.pageYOffset || V.scrollTop;
  }
  function z(a, b) {
    var c = a.getBoundingClientRect ? a.getBoundingClientRect() : {};
    return (
      (b = "number" == typeof b ? b || 0 : 0),
      {
        top: (c.top || 0) - b,
        left: (c.left || 0) - b,
        bottom: (c.bottom || 0) + b,
        right: (c.right || 0) + b,
      }
    );
  }
  function A(a, b) {
    var c = z(p(a), b);
    return !!c && c.right >= 0 && c.left <= Ab();
  }
  function B(a, b) {
    var c = z(p(a), b);
    return !!c && c.bottom >= 0 && c.top <= Bb();
  }
  function C(a, b) {
    var c = z(p(a), b);
    return (
      !!c && c.bottom >= 0 && c.top <= Bb() && c.right >= 0 && c.left <= Ab()
    );
  }
  function D(a) {
    var b = {
        img: 1,
        input: 1,
        source: 3,
        embed: 3,
        track: 3,
        iframe: 5,
        audio: 5,
        video: 5,
        script: 5,
      },
      c = b[a.nodeName.toLowerCase()] || -1;
    return 4 > c ? c : null != a.getAttribute("src") ? 5 : -5;
  }
  function E(a, b, c) {
    var d;
    if (!a || null == b) throw new TypeError("@store");
    return (
      (c = "string" == typeof c && c),
      k(a, function (a) {
        (d = c
          ? a.getAttribute(c)
          : 0 < D(a)
          ? a.getAttribute("src")
          : a.innerHTML),
          null == d ? u(a, b) : t(a, b, d);
      }),
      N
    );
  }
  function F(a, b) {
    var c = [];
    return (
      a &&
        b &&
        g(
          f(b),
          function (b) {
            c.push(t(a, b));
          },
          a
        ),
      c
    );
  }
  function G(a, b) {
    return (
      "string" == typeof a &&
        "function" == typeof b &&
        ((fb[a] = b), (gb[a] = 1)),
      N
    );
  }
  function H(a) {
    return X.on("resize", a), N;
  }
  function I(a, b) {
    var c,
      d,
      e = wb.crossover;
    return (
      "function" == typeof a && ((c = b), (b = a), (a = c)),
      (d = a ? "" + a + e : e),
      X.on(d, b),
      N
    );
  }
  function J(a) {
    return (
      k(a, function (a) {
        W(a), H(a);
      }),
      N
    );
  }
  function K(a) {
    return (
      k(a, function (a) {
        if ("object" != typeof a) throw new TypeError("@create");
        var b,
          c = ub(O).configure(a),
          d = c.verge,
          e = c.breakpoints,
          f = vb("scroll"),
          h = vb("resize");
        e.length &&
          ((b = e[0] || e[1] || !1),
          W(function () {
            function a() {
              c.reset(),
                g(c.$e, function (a, b) {
                  c[b].decideValue().updateDOM();
                }).trigger(i);
            }
            function e() {
              g(c.$e, function (a, b) {
                C(c[b].$e, d) && c[b].updateDOM();
              });
            }
            var i = wb.allLoaded,
              j = !!c.lazy;
            g(c.target().$e, function (a, b) {
              (c[b] = ub(c).prepareData(a)),
                (!j || C(c[b].$e, d)) && c[b].updateDOM();
            }),
              c.dynamic && (c.custom || lb > b) && H(a, h),
              j &&
                (X.on(f, e),
                c.$e.one(i, function () {
                  X.off(f, e);
                }));
          }));
      }),
      N
    );
  }
  function L(a) {
    return P[Q] === N && (P[Q] = R), "function" == typeof a && a.call(P, N), N;
  }
  if ("function" != typeof a)
    try {
      return void console.warn("response.js aborted due to missing dependency");
    } catch (M) {}
  var N,
    O,
    P = this,
    Q = "Response",
    R = P[Q],
    S = "init" + Q,
    T = window,
    U = document,
    V = U.documentElement,
    W = a.domReady || a,
    X = a(T),
    Y = "undefined" != typeof DOMStringMap,
    Z = Array.prototype,
    $ = Object.prototype,
    _ = Z.push,
    ab = Z.concat,
    bb = $.toString,
    cb = $.hasOwnProperty,
    db =
      Array.isArray ||
      function (a) {
        return "[object Array]" === bb.call(a);
      },
    eb = {
      width: [0, 320, 481, 641, 961, 1025, 1281],
      height: [0, 481],
      ratio: [1, 1.5, 2],
    },
    fb = {},
    gb = {},
    hb = { all: [] },
    ib = 1,
    jb = screen.width,
    kb = screen.height,
    lb = jb > kb ? jb : kb,
    mb = jb + kb - lb,
    nb = function () {
      return jb;
    },
    ob = function () {
      return kb;
    },
    pb = /[^a-z0-9_\-\.]/gi,
    qb = /^[\W\s]+|[\W\s]+$|/g,
    rb = /([a-z])([A-Z])/g,
    sb = /-(.)/g,
    tb = /^data-(.+)$/,
    ub =
      Object.create ||
      function (a) {
        function b() {}
        return (b.prototype = a), new b();
      },
    vb = function (a, b) {
      return (b = b || Q), a.replace(qb, "") + "." + b.replace(qb, "");
    },
    wb = { allLoaded: vb("allLoaded"), crossover: vb("crossover") },
    xb = T.matchMedia || T.msMatchMedia,
    yb = xb
      ? c(xb, T)
      : function () {
          return {};
        },
    zb = xb
      ? function (a) {
          return !!xb.call(T, a);
        }
      : function () {
          return !1;
        },
    Ab = function () {
      var a = V.clientWidth,
        b = T.innerWidth;
      return b > a ? b : a;
    },
    Bb = function () {
      var a = V.clientHeight,
        b = T.innerHeight;
      return b > a ? b : a;
    },
    Cb = c(d, Ab),
    Db = c(d, Bb),
    Eb = { band: c(d, nb), wave: c(d, ob) };
  return (
    (O = (function () {
      function b(a) {
        return "string" == typeof a ? a.toLowerCase().replace(pb, "") : "";
      }
      function c(a, b) {
        return a - b;
      }
      var d = wb.crossover,
        k = Math.min;
      return {
        $e: 0,
        mode: 0,
        breakpoints: null,
        prefix: null,
        prop: "width",
        keys: [],
        dynamic: null,
        custom: 0,
        values: [],
        fn: 0,
        verge: null,
        newValue: 0,
        currValue: 1,
        aka: null,
        lazy: null,
        i: 0,
        uid: null,
        reset: function () {
          for (var a = this.breakpoints, b = a.length, c = 0; !c && b--; )
            this.fn(a[b]) && (c = b);
          return (
            c !== this.i &&
              (X.trigger(d).trigger(this.prop + d), (this.i = c || 0)),
            this
          );
        },
        configure: function (a) {
          j(this, a);
          var d,
            l,
            m,
            n,
            o,
            p = !0,
            q = this.prop;
          if (
            ((this.uid = ib++),
            null == this.verge && (this.verge = k(lb, 500)),
            !(this.fn = fb[q]))
          )
            throw new TypeError("@create");
          if (
            (null == this.dynamic &&
              (this.dynamic = "device" !== q.slice(0, 6)),
            (this.custom = gb[q]),
            (m = this.prefix ? i(e(f(this.prefix), b)) : ["min-" + q + "-"]),
            (n = 1 < m.length ? m.slice(1) : 0),
            (this.prefix = m[0]),
            (l = this.breakpoints),
            db(l))
          ) {
            if (
              (g(l, function (a) {
                if (!a && 0 !== a) throw "invalid breakpoint";
                p = p && isFinite(a);
              }),
              p && l.sort(c),
              !l.length)
            )
              throw new TypeError(".breakpoints");
          } else if (((l = eb[q] || eb[q.split("-").pop()]), !l))
            throw new TypeError(".prop");
          if (
            ((this.breakpoints = l),
            (this.keys = h(this.breakpoints, this.prefix)),
            (this.aka = null),
            n)
          ) {
            for (o = [], d = n.length; d--; ) o.push(h(this.breakpoints, n[d]));
            (this.aka = o), (this.keys = ab.apply(this.keys, o));
          }
          return (hb.all = hb.all.concat((hb[this.uid] = this.keys))), this;
        },
        target: function () {
          return (
            (this.$e = a(v(hb[this.uid]))),
            E(this.$e, S),
            this.keys.push(S),
            this
          );
        },
        decideValue: function () {
          for (
            var a = null, b = this.breakpoints, c = b.length, d = c;
            null == a && d--;

          )
            this.fn(b[d]) && (a = this.values[d]);
          return (
            (this.newValue = "string" == typeof a ? a : this.values[c]), this
          );
        },
        prepareData: function (b) {
          if (
            ((this.$e = a(b)),
            (this.mode = D(b)),
            (this.values = F(this.$e, this.keys)),
            this.aka)
          )
            for (var c = this.aka.length; c--; )
              this.values = j(this.values, F(this.$e, this.aka[c]));
          return this.decideValue();
        },
        updateDOM: function () {
          return this.currValue === this.newValue
            ? this
            : ((this.currValue = this.newValue),
              0 < this.mode
                ? this.$e[0].setAttribute("src", this.newValue)
                : null == this.newValue
                ? this.$e.empty && this.$e.empty()
                : this.$e.html
                ? this.$e.html(this.newValue)
                : (this.$e.empty && this.$e.empty(),
                  (this.$e[0].innerHTML = this.newValue)),
              this);
        },
      };
    })()),
    (fb.width = Cb),
    (fb.height = Db),
    (fb["device-width"] = Eb.band),
    (fb["device-height"] = Eb.wave),
    (fb["device-pixel-ratio"] = l),
    (N = {
      deviceMin: function () {
        return mb;
      },
      deviceMax: function () {
        return lb;
      },
      noConflict: L,
      create: K,
      addTest: G,
      datatize: n,
      camelize: m,
      render: o,
      store: E,
      access: F,
      target: w,
      object: ub,
      crossover: I,
      action: J,
      resize: H,
      ready: W,
      affix: h,
      sift: i,
      dpr: l,
      deletes: u,
      scrollX: x,
      scrollY: y,
      deviceW: nb,
      deviceH: ob,
      device: Eb,
      inX: A,
      inY: B,
      route: k,
      merge: j,
      media: yb,
      mq: zb,
      wave: Db,
      band: Cb,
      map: e,
      each: g,
      inViewport: C,
      dataset: t,
      viewportH: Bb,
      viewportW: Ab,
    }),
    W(function () {
      var b = t(U.body, "responsejs"),
        c = (T.JSON && JSON.parse) || a.parseJSON;
      (b = b && c ? c(b) : b),
        b && b.create && K(b.create),
        (V.className =
          V.className.replace(/(^|\s)(no-)?responsejs(\s|$)/, "$1$3") +
          " responsejs ");
    }),
    N
  );
});

/* TouchSwipe 1.6.6 */
(function (a) {
  if (typeof define === "function" && define.amd && define.amd.jQuery) {
    define(["jquery"], a);
  } else {
    a(jQuery);
  }
})(function (f) {
  var p = "left",
    o = "right",
    e = "up",
    x = "down",
    c = "in",
    z = "out",
    m = "none",
    s = "auto",
    l = "swipe",
    t = "pinch",
    A = "tap",
    j = "doubletap",
    b = "longtap",
    y = "hold",
    D = "horizontal",
    u = "vertical",
    i = "all",
    r = 10,
    g = "start",
    k = "move",
    h = "end",
    q = "cancel",
    a = "ontouchstart" in window,
    v = window.navigator.msPointerEnabled && !window.navigator.pointerEnabled,
    d = window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
    B = "TouchSwipe";
  var n = {
    fingers: 1,
    threshold: 75,
    cancelThreshold: null,
    pinchThreshold: 20,
    maxTimeThreshold: null,
    fingerReleaseThreshold: 250,
    longTapThreshold: 500,
    doubleTapThreshold: 200,
    swipe: null,
    swipeLeft: null,
    swipeRight: null,
    swipeUp: null,
    swipeDown: null,
    swipeStatus: null,
    pinchIn: null,
    pinchOut: null,
    pinchStatus: null,
    click: null,
    tap: null,
    doubleTap: null,
    longTap: null,
    hold: null,
    triggerOnTouchEnd: true,
    triggerOnTouchLeave: false,
    allowPageScroll: "auto",
    fallbackToMouseEvents: true,
    excludedElements: "label, button, input, select, textarea, a, .noSwipe",
  };
  f.fn.swipe = function (G) {
    var F = f(this),
      E = F.data(B);
    if (E && typeof G === "string") {
      if (E[G]) {
        return E[G].apply(this, Array.prototype.slice.call(arguments, 1));
      } else {
        f.error("Method " + G + " does not exist on jQuery.swipe");
      }
    } else {
      if (!E && (typeof G === "object" || !G)) {
        return w.apply(this, arguments);
      }
    }
    return F;
  };
  f.fn.swipe.defaults = n;
  f.fn.swipe.phases = {
    PHASE_START: g,
    PHASE_MOVE: k,
    PHASE_END: h,
    PHASE_CANCEL: q,
  };
  f.fn.swipe.directions = { LEFT: p, RIGHT: o, UP: e, DOWN: x, IN: c, OUT: z };
  f.fn.swipe.pageScroll = { NONE: m, HORIZONTAL: D, VERTICAL: u, AUTO: s };
  f.fn.swipe.fingers = { ONE: 1, TWO: 2, THREE: 3, ALL: i };
  function w(E) {
    if (
      E &&
      E.allowPageScroll === undefined &&
      (E.swipe !== undefined || E.swipeStatus !== undefined)
    ) {
      E.allowPageScroll = m;
    }
    if (E.click !== undefined && E.tap === undefined) {
      E.tap = E.click;
    }
    if (!E) {
      E = {};
    }
    E = f.extend({}, f.fn.swipe.defaults, E);
    return this.each(function () {
      var G = f(this);
      var F = G.data(B);
      if (!F) {
        F = new C(this, E);
        G.data(B, F);
      }
    });
  }
  function C(a4, av) {
    var az = a || d || !av.fallbackToMouseEvents,
      J = az
        ? d
          ? v
            ? "MSPointerDown"
            : "pointerdown"
          : "touchstart"
        : "mousedown",
      ay = az
        ? d
          ? v
            ? "MSPointerMove"
            : "pointermove"
          : "touchmove"
        : "mousemove",
      U = az ? (d ? (v ? "MSPointerUp" : "pointerup") : "touchend") : "mouseup",
      S = az ? null : "mouseleave",
      aD = d ? (v ? "MSPointerCancel" : "pointercancel") : "touchcancel";
    var ag = 0,
      aP = null,
      ab = 0,
      a1 = 0,
      aZ = 0,
      G = 1,
      aq = 0,
      aJ = 0,
      M = null;
    var aR = f(a4);
    var Z = "start";
    var W = 0;
    var aQ = null;
    var T = 0,
      a2 = 0,
      a5 = 0,
      ad = 0,
      N = 0;
    var aW = null,
      af = null;
    try {
      aR.bind(J, aN);
      aR.bind(aD, a9);
    } catch (ak) {
      f.error("events not supported " + J + "," + aD + " on jQuery.swipe");
    }
    this.enable = function () {
      aR.bind(J, aN);
      aR.bind(aD, a9);
      return aR;
    };
    this.disable = function () {
      aK();
      return aR;
    };
    this.destroy = function () {
      aK();
      aR.data(B, null);
      return aR;
    };
    this.option = function (bc, bb) {
      if (av[bc] !== undefined) {
        if (bb === undefined) {
          return av[bc];
        } else {
          av[bc] = bb;
        }
      } else {
        f.error("Option " + bc + " does not exist on jQuery.swipe.options");
      }
      return null;
    };
    function aN(bd) {
      if (aB()) {
        return;
      }
      if (f(bd.target).closest(av.excludedElements, aR).length > 0) {
        return;
      }
      var be = bd.originalEvent ? bd.originalEvent : bd;
      var bc,
        bb = a ? be.touches[0] : be;
      Z = g;
      if (a) {
        W = be.touches.length;
      } else {
        bd.preventDefault();
      }
      ag = 0;
      aP = null;
      aJ = null;
      ab = 0;
      a1 = 0;
      aZ = 0;
      G = 1;
      aq = 0;
      aQ = aj();
      M = aa();
      R();
      if (!a || W === av.fingers || av.fingers === i || aX()) {
        ai(0, bb);
        T = at();
        if (W == 2) {
          ai(1, be.touches[1]);
          a1 = aZ = au(aQ[0].start, aQ[1].start);
        }
        if (av.swipeStatus || av.pinchStatus) {
          bc = O(be, Z);
        }
      } else {
        bc = false;
      }
      if (bc === false) {
        Z = q;
        O(be, Z);
        return bc;
      } else {
        if (av.hold) {
          af = setTimeout(
            f.proxy(function () {
              aR.trigger("hold", [be.target]);
              if (av.hold) {
                bc = av.hold.call(aR, be, be.target);
              }
            }, this),
            av.longTapThreshold
          );
        }
        ao(true);
      }
      return null;
    }
    function a3(be) {
      var bh = be.originalEvent ? be.originalEvent : be;
      if (Z === h || Z === q || am()) {
        return;
      }
      var bd,
        bc = a ? bh.touches[0] : bh;
      var bf = aH(bc);
      a2 = at();
      if (a) {
        W = bh.touches.length;
      }
      if (av.hold) {
        clearTimeout(af);
      }
      Z = k;
      if (W == 2) {
        if (a1 == 0) {
          ai(1, bh.touches[1]);
          a1 = aZ = au(aQ[0].start, aQ[1].start);
        } else {
          aH(bh.touches[1]);
          aZ = au(aQ[0].end, aQ[1].end);
          aJ = ar(aQ[0].end, aQ[1].end);
        }
        G = a7(a1, aZ);
        aq = Math.abs(a1 - aZ);
      }
      if (W === av.fingers || av.fingers === i || !a || aX()) {
        aP = aL(bf.start, bf.end);
        al(be, aP);
        ag = aS(bf.start, bf.end);
        ab = aM();
        aI(aP, ag);
        if (av.swipeStatus || av.pinchStatus) {
          bd = O(bh, Z);
        }
        if (!av.triggerOnTouchEnd || av.triggerOnTouchLeave) {
          var bb = true;
          if (av.triggerOnTouchLeave) {
            var bg = aY(this);
            bb = E(bf.end, bg);
          }
          if (!av.triggerOnTouchEnd && bb) {
            Z = aC(k);
          } else {
            if (av.triggerOnTouchLeave && !bb) {
              Z = aC(h);
            }
          }
          if (Z == q || Z == h) {
            O(bh, Z);
          }
        }
      } else {
        Z = q;
        O(bh, Z);
      }
      if (bd === false) {
        Z = q;
        O(bh, Z);
      }
    }
    function L(bb) {
      var bc = bb.originalEvent;
      if (a) {
        if (bc.touches.length > 0) {
          F();
          return true;
        }
      }
      if (am()) {
        W = ad;
      }
      a2 = at();
      ab = aM();
      if (ba() || !an()) {
        Z = q;
        O(bc, Z);
      } else {
        if (
          av.triggerOnTouchEnd ||
          (av.triggerOnTouchEnd == false && Z === k)
        ) {
          bb.preventDefault();
          Z = h;
          O(bc, Z);
        } else {
          if (!av.triggerOnTouchEnd && a6()) {
            Z = h;
            aF(bc, Z, A);
          } else {
            if (Z === k) {
              Z = q;
              O(bc, Z);
            }
          }
        }
      }
      ao(false);
      return null;
    }
    function a9() {
      W = 0;
      a2 = 0;
      T = 0;
      a1 = 0;
      aZ = 0;
      G = 1;
      R();
      ao(false);
    }
    function K(bb) {
      var bc = bb.originalEvent;
      if (av.triggerOnTouchLeave) {
        Z = aC(h);
        O(bc, Z);
      }
    }
    function aK() {
      aR.unbind(J, aN);
      aR.unbind(aD, a9);
      aR.unbind(ay, a3);
      aR.unbind(U, L);
      if (S) {
        aR.unbind(S, K);
      }
      ao(false);
    }
    function aC(bf) {
      var be = bf;
      var bd = aA();
      var bc = an();
      var bb = ba();
      if (!bd || bb) {
        be = q;
      } else {
        if (
          bc &&
          bf == k &&
          (!av.triggerOnTouchEnd || av.triggerOnTouchLeave)
        ) {
          be = h;
        } else {
          if (!bc && bf == h && av.triggerOnTouchLeave) {
            be = q;
          }
        }
      }
      return be;
    }
    function O(bd, bb) {
      var bc = undefined;
      if (I() || V()) {
        bc = aF(bd, bb, l);
      } else {
        if ((P() || aX()) && bc !== false) {
          bc = aF(bd, bb, t);
        }
      }
      if (aG() && bc !== false) {
        bc = aF(bd, bb, j);
      } else {
        if (ap() && bc !== false) {
          bc = aF(bd, bb, b);
        } else {
          if (ah() && bc !== false) {
            bc = aF(bd, bb, A);
          }
        }
      }
      if (bb === q) {
        a9(bd);
      }
      if (bb === h) {
        if (a) {
          if (bd.touches.length == 0) {
            a9(bd);
          }
        } else {
          a9(bd);
        }
      }
      return bc;
    }
    function aF(be, bb, bd) {
      var bc = undefined;
      if (bd == l) {
        aR.trigger("swipeStatus", [bb, aP || null, ag || 0, ab || 0, W, aQ]);
        if (av.swipeStatus) {
          bc = av.swipeStatus.call(
            aR,
            be,
            bb,
            aP || null,
            ag || 0,
            ab || 0,
            W,
            aQ
          );
          if (bc === false) {
            return false;
          }
        }
        if (bb == h && aV()) {
          aR.trigger("swipe", [aP, ag, ab, W, aQ]);
          if (av.swipe) {
            bc = av.swipe.call(aR, be, aP, ag, ab, W, aQ);
            if (bc === false) {
              return false;
            }
          }
          switch (aP) {
            case p:
              aR.trigger("swipeLeft", [aP, ag, ab, W, aQ]);
              if (av.swipeLeft) {
                bc = av.swipeLeft.call(aR, be, aP, ag, ab, W, aQ);
              }
              break;
            case o:
              aR.trigger("swipeRight", [aP, ag, ab, W, aQ]);
              if (av.swipeRight) {
                bc = av.swipeRight.call(aR, be, aP, ag, ab, W, aQ);
              }
              break;
            case e:
              aR.trigger("swipeUp", [aP, ag, ab, W, aQ]);
              if (av.swipeUp) {
                bc = av.swipeUp.call(aR, be, aP, ag, ab, W, aQ);
              }
              break;
            case x:
              aR.trigger("swipeDown", [aP, ag, ab, W, aQ]);
              if (av.swipeDown) {
                bc = av.swipeDown.call(aR, be, aP, ag, ab, W, aQ);
              }
              break;
          }
        }
      }
      if (bd == t) {
        aR.trigger("pinchStatus", [bb, aJ || null, aq || 0, ab || 0, W, G, aQ]);
        if (av.pinchStatus) {
          bc = av.pinchStatus.call(
            aR,
            be,
            bb,
            aJ || null,
            aq || 0,
            ab || 0,
            W,
            G,
            aQ
          );
          if (bc === false) {
            return false;
          }
        }
        if (bb == h && a8()) {
          switch (aJ) {
            case c:
              aR.trigger("pinchIn", [aJ || null, aq || 0, ab || 0, W, G, aQ]);
              if (av.pinchIn) {
                bc = av.pinchIn.call(
                  aR,
                  be,
                  aJ || null,
                  aq || 0,
                  ab || 0,
                  W,
                  G,
                  aQ
                );
              }
              break;
            case z:
              aR.trigger("pinchOut", [aJ || null, aq || 0, ab || 0, W, G, aQ]);
              if (av.pinchOut) {
                bc = av.pinchOut.call(
                  aR,
                  be,
                  aJ || null,
                  aq || 0,
                  ab || 0,
                  W,
                  G,
                  aQ
                );
              }
              break;
          }
        }
      }
      if (bd == A) {
        if (bb === q || bb === h) {
          clearTimeout(aW);
          clearTimeout(af);
          if (Y() && !H()) {
            N = at();
            aW = setTimeout(
              f.proxy(function () {
                N = null;
                aR.trigger("tap", [be.target]);
                if (av.tap) {
                  bc = av.tap.call(aR, be, be.target);
                }
              }, this),
              av.doubleTapThreshold
            );
          } else {
            N = null;
            aR.trigger("tap", [be.target]);
            if (av.tap) {
              bc = av.tap.call(aR, be, be.target);
            }
          }
        }
      } else {
        if (bd == j) {
          if (bb === q || bb === h) {
            clearTimeout(aW);
            N = null;
            aR.trigger("doubletap", [be.target]);
            if (av.doubleTap) {
              bc = av.doubleTap.call(aR, be, be.target);
            }
          }
        } else {
          if (bd == b) {
            if (bb === q || bb === h) {
              clearTimeout(aW);
              N = null;
              aR.trigger("longtap", [be.target]);
              if (av.longTap) {
                bc = av.longTap.call(aR, be, be.target);
              }
            }
          }
        }
      }
      return bc;
    }
    function an() {
      var bb = true;
      if (av.threshold !== null) {
        bb = ag >= av.threshold;
      }
      return bb;
    }
    function ba() {
      var bb = false;
      if (av.cancelThreshold !== null && aP !== null) {
        bb = aT(aP) - ag >= av.cancelThreshold;
      }
      return bb;
    }
    function ae() {
      if (av.pinchThreshold !== null) {
        return aq >= av.pinchThreshold;
      }
      return true;
    }
    function aA() {
      var bb;
      if (av.maxTimeThreshold) {
        if (ab >= av.maxTimeThreshold) {
          bb = false;
        } else {
          bb = true;
        }
      } else {
        bb = true;
      }
      return bb;
    }
    function al(bb, bc) {
      if (av.allowPageScroll === m || aX()) {
        bb.preventDefault();
      } else {
        var bd = av.allowPageScroll === s;
        switch (bc) {
          case p:
            if ((av.swipeLeft && bd) || (!bd && av.allowPageScroll != D)) {
              bb.preventDefault();
            }
            break;
          case o:
            if ((av.swipeRight && bd) || (!bd && av.allowPageScroll != D)) {
              bb.preventDefault();
            }
            break;
          case e:
            if ((av.swipeUp && bd) || (!bd && av.allowPageScroll != u)) {
              bb.preventDefault();
            }
            break;
          case x:
            if ((av.swipeDown && bd) || (!bd && av.allowPageScroll != u)) {
              bb.preventDefault();
            }
            break;
        }
      }
    }
    function a8() {
      var bc = aO();
      var bb = X();
      var bd = ae();
      return bc && bb && bd;
    }
    function aX() {
      return !!(av.pinchStatus || av.pinchIn || av.pinchOut);
    }
    function P() {
      return !!(a8() && aX());
    }
    function aV() {
      var be = aA();
      var bg = an();
      var bd = aO();
      var bb = X();
      var bc = ba();
      var bf = !bc && bb && bd && bg && be;
      return bf;
    }
    function V() {
      return !!(
        av.swipe ||
        av.swipeStatus ||
        av.swipeLeft ||
        av.swipeRight ||
        av.swipeUp ||
        av.swipeDown
      );
    }
    function I() {
      return !!(aV() && V());
    }
    function aO() {
      return W === av.fingers || av.fingers === i || !a;
    }
    function X() {
      return aQ[0].end.x !== 0;
    }
    function a6() {
      return !!av.tap;
    }
    function Y() {
      return !!av.doubleTap;
    }
    function aU() {
      return !!av.longTap;
    }
    function Q() {
      if (N == null) {
        return false;
      }
      var bb = at();
      return Y() && bb - N <= av.doubleTapThreshold;
    }
    function H() {
      return Q();
    }
    function ax() {
      return (W === 1 || !a) && (isNaN(ag) || ag < av.threshold);
    }
    function a0() {
      return ab > av.longTapThreshold && ag < r;
    }
    function ah() {
      return !!(ax() && a6());
    }
    function aG() {
      return !!(Q() && Y());
    }
    function ap() {
      return !!(a0() && aU());
    }
    function F() {
      a5 = at();
      ad = event.touches.length + 1;
    }
    function R() {
      a5 = 0;
      ad = 0;
    }
    function am() {
      var bb = false;
      if (a5) {
        var bc = at() - a5;
        if (bc <= av.fingerReleaseThreshold) {
          bb = true;
        }
      }
      return bb;
    }
    function aB() {
      return !!(aR.data(B + "_intouch") === true);
    }
    function ao(bb) {
      if (bb === true) {
        aR.bind(ay, a3);
        aR.bind(U, L);
        if (S) {
          aR.bind(S, K);
        }
      } else {
        aR.unbind(ay, a3, false);
        aR.unbind(U, L, false);
        if (S) {
          aR.unbind(S, K, false);
        }
      }
      aR.data(B + "_intouch", bb === true);
    }
    function ai(bc, bb) {
      var bd = bb.identifier !== undefined ? bb.identifier : 0;
      aQ[bc].identifier = bd;
      aQ[bc].start.x = aQ[bc].end.x = bb.pageX || bb.clientX;
      aQ[bc].start.y = aQ[bc].end.y = bb.pageY || bb.clientY;
      return aQ[bc];
    }
    function aH(bb) {
      var bd = bb.identifier !== undefined ? bb.identifier : 0;
      var bc = ac(bd);
      bc.end.x = bb.pageX || bb.clientX;
      bc.end.y = bb.pageY || bb.clientY;
      return bc;
    }
    function ac(bc) {
      for (var bb = 0; bb < aQ.length; bb++) {
        if (aQ[bb].identifier == bc) {
          return aQ[bb];
        }
      }
    }
    function aj() {
      var bb = [];
      for (var bc = 0; bc <= 5; bc++) {
        bb.push({ start: { x: 0, y: 0 }, end: { x: 0, y: 0 }, identifier: 0 });
      }
      return bb;
    }
    function aI(bb, bc) {
      bc = Math.max(bc, aT(bb));
      M[bb].distance = bc;
    }
    function aT(bb) {
      if (M[bb]) {
        return M[bb].distance;
      }
      return undefined;
    }
    function aa() {
      var bb = {};
      bb[p] = aw(p);
      bb[o] = aw(o);
      bb[e] = aw(e);
      bb[x] = aw(x);
      return bb;
    }
    function aw(bb) {
      return { direction: bb, distance: 0 };
    }
    function aM() {
      return a2 - T;
    }
    function au(be, bd) {
      var bc = Math.abs(be.x - bd.x);
      var bb = Math.abs(be.y - bd.y);
      return Math.round(Math.sqrt(bc * bc + bb * bb));
    }
    function a7(bb, bc) {
      var bd = (bc / bb) * 1;
      return bd.toFixed(2);
    }
    function ar() {
      if (G < 1) {
        return z;
      } else {
        return c;
      }
    }
    function aS(bc, bb) {
      return Math.round(
        Math.sqrt(Math.pow(bb.x - bc.x, 2) + Math.pow(bb.y - bc.y, 2))
      );
    }
    function aE(be, bc) {
      var bb = be.x - bc.x;
      var bg = bc.y - be.y;
      var bd = Math.atan2(bg, bb);
      var bf = Math.round((bd * 180) / Math.PI);
      if (bf < 0) {
        bf = 360 - Math.abs(bf);
      }
      return bf;
    }
    function aL(bc, bb) {
      var bd = aE(bc, bb);
      if (bd <= 45 && bd >= 0) {
        return p;
      } else {
        if (bd <= 360 && bd >= 315) {
          return p;
        } else {
          if (bd >= 135 && bd <= 225) {
            return o;
          } else {
            if (bd > 45 && bd < 135) {
              return x;
            } else {
              return e;
            }
          }
        }
      }
    }
    function at() {
      var bb = new Date();
      return bb.getTime();
    }
    function aY(bb) {
      bb = f(bb);
      var bd = bb.offset();
      var bc = {
        left: bd.left,
        right: bd.left + bb.outerWidth(),
        top: bd.top,
        bottom: bd.top + bb.outerHeight(),
      };
      return bc;
    }
    function E(bb, bc) {
      return (
        bb.x > bc.left && bb.x < bc.right && bb.y > bc.top && bb.y < bc.bottom
      );
    }
  }
});

/*!
 * jQuery Cycle2; version: 2.1.6 build: 20141007
 * http://jquery.malsup.com/cycle2/
 * Copyright (c) 2014 M. Alsup; Dual licensed: MIT/GPL
 */
!(function (a) {
  "use strict";
  function b(a) {
    return (a || "").toLowerCase();
  }
  var c = "2.1.6";
  (a.fn.cycle = function (c) {
    var d;
    return 0 !== this.length || a.isReady
      ? this.each(function () {
          var d,
            e,
            f,
            g,
            h = a(this),
            i = a.fn.cycle.log;
          if (!h.data("cycle.opts")) {
            (h.data("cycle-log") === !1 ||
              (c && c.log === !1) ||
              (e && e.log === !1)) &&
              (i = a.noop),
              i("--c2 init--"),
              (d = h.data());
            for (var j in d)
              d.hasOwnProperty(j) &&
                /^cycle[A-Z]+/.test(j) &&
                ((g = d[j]),
                (f = j.match(/^cycle(.*)/)[1].replace(/^[A-Z]/, b)),
                i(f + ":", g, "(" + typeof g + ")"),
                (d[f] = g));
            (e = a.extend({}, a.fn.cycle.defaults, d, c || {})),
              (e.timeoutId = 0),
              (e.paused = e.paused || !1),
              (e.container = h),
              (e._maxZ = e.maxZ),
              (e.API = a.extend({ _container: h }, a.fn.cycle.API)),
              (e.API.log = i),
              (e.API.trigger = function (a, b) {
                return e.container.trigger(a, b), e.API;
              }),
              h.data("cycle.opts", e),
              h.data("cycle.API", e.API),
              e.API.trigger("cycle-bootstrap", [e, e.API]),
              e.API.addInitialSlides(),
              e.API.preInitSlideshow(),
              e.slides.length && e.API.initSlideshow();
          }
        })
      : ((d = { s: this.selector, c: this.context }),
        a.fn.cycle.log("requeuing slideshow (dom not ready)"),
        a(function () {
          a(d.s, d.c).cycle(c);
        }),
        this);
  }),
    (a.fn.cycle.API = {
      opts: function () {
        return this._container.data("cycle.opts");
      },
      addInitialSlides: function () {
        var b = this.opts(),
          c = b.slides;
        (b.slideCount = 0),
          (b.slides = a()),
          (c = c.jquery ? c : b.container.find(c)),
          b.random &&
            c.sort(function () {
              return Math.random() - 0.5;
            }),
          b.API.add(c);
      },
      preInitSlideshow: function () {
        var b = this.opts();
        b.API.trigger("cycle-pre-initialize", [b]);
        var c = a.fn.cycle.transitions[b.fx];
        c && a.isFunction(c.preInit) && c.preInit(b), (b._preInitialized = !0);
      },
      postInitSlideshow: function () {
        var b = this.opts();
        b.API.trigger("cycle-post-initialize", [b]);
        var c = a.fn.cycle.transitions[b.fx];
        c && a.isFunction(c.postInit) && c.postInit(b);
      },
      initSlideshow: function () {
        var b,
          c = this.opts(),
          d = c.container;
        c.API.calcFirstSlide(),
          "static" == c.container.css("position") &&
            c.container.css("position", "relative"),
          a(c.slides[c.currSlide]).css({
            opacity: 1,
            display: "block",
            visibility: "visible",
          }),
          c.API.stackSlides(
            c.slides[c.currSlide],
            c.slides[c.nextSlide],
            !c.reverse
          ),
          c.pauseOnHover &&
            (c.pauseOnHover !== !0 && (d = a(c.pauseOnHover)),
            d.hover(
              function () {
                c.API.pause(!0);
              },
              function () {
                c.API.resume(!0);
              }
            )),
          c.timeout &&
            ((b = c.API.getSlideOpts(c.currSlide)),
            c.API.queueTransition(b, b.timeout + c.delay)),
          (c._initialized = !0),
          c.API.updateView(!0),
          c.API.trigger("cycle-initialized", [c]),
          c.API.postInitSlideshow();
      },
      pause: function (b) {
        var c = this.opts(),
          d = c.API.getSlideOpts(),
          e = c.hoverPaused || c.paused;
        b ? (c.hoverPaused = !0) : (c.paused = !0),
          e ||
            (c.container.addClass("cycle-paused"),
            c.API.trigger("cycle-paused", [c]).log("cycle-paused"),
            d.timeout &&
              (clearTimeout(c.timeoutId),
              (c.timeoutId = 0),
              (c._remainingTimeout -= a.now() - c._lastQueue),
              (c._remainingTimeout < 0 || isNaN(c._remainingTimeout)) &&
                (c._remainingTimeout = void 0)));
      },
      resume: function (a) {
        var b = this.opts(),
          c = !b.hoverPaused && !b.paused;
        a ? (b.hoverPaused = !1) : (b.paused = !1),
          c ||
            (b.container.removeClass("cycle-paused"),
            0 === b.slides.filter(":animated").length &&
              b.API.queueTransition(b.API.getSlideOpts(), b._remainingTimeout),
            b.API.trigger("cycle-resumed", [b, b._remainingTimeout]).log(
              "cycle-resumed"
            ));
      },
      add: function (b, c) {
        var d,
          e = this.opts(),
          f = e.slideCount,
          g = !1;
        "string" == a.type(b) && (b = a.trim(b)),
          a(b).each(function () {
            var b,
              d = a(this);
            c ? e.container.prepend(d) : e.container.append(d),
              e.slideCount++,
              (b = e.API.buildSlideOpts(d)),
              (e.slides = c ? a(d).add(e.slides) : e.slides.add(d)),
              e.API.initSlide(b, d, --e._maxZ),
              d.data("cycle.opts", b),
              e.API.trigger("cycle-slide-added", [e, b, d]);
          }),
          e.API.updateView(!0),
          (g = e._preInitialized && 2 > f && e.slideCount >= 1),
          g &&
            (e._initialized
              ? e.timeout &&
                ((d = e.slides.length),
                (e.nextSlide = e.reverse ? d - 1 : 1),
                e.timeoutId || e.API.queueTransition(e))
              : e.API.initSlideshow());
      },
      calcFirstSlide: function () {
        var a,
          b = this.opts();
        (a = parseInt(b.startingSlide || 0, 10)),
          (a >= b.slides.length || 0 > a) && (a = 0),
          (b.currSlide = a),
          b.reverse
            ? ((b.nextSlide = a - 1),
              b.nextSlide < 0 && (b.nextSlide = b.slides.length - 1))
            : ((b.nextSlide = a + 1),
              b.nextSlide == b.slides.length && (b.nextSlide = 0));
      },
      calcNextSlide: function () {
        var a,
          b = this.opts();
        b.reverse
          ? ((a = b.nextSlide - 1 < 0),
            (b.nextSlide = a ? b.slideCount - 1 : b.nextSlide - 1),
            (b.currSlide = a ? 0 : b.nextSlide + 1))
          : ((a = b.nextSlide + 1 == b.slides.length),
            (b.nextSlide = a ? 0 : b.nextSlide + 1),
            (b.currSlide = a ? b.slides.length - 1 : b.nextSlide - 1));
      },
      calcTx: function (b, c) {
        var d,
          e = b;
        return (
          e._tempFx
            ? (d = a.fn.cycle.transitions[e._tempFx])
            : c && e.manualFx && (d = a.fn.cycle.transitions[e.manualFx]),
          d || (d = a.fn.cycle.transitions[e.fx]),
          (e._tempFx = null),
          (this.opts()._tempFx = null),
          d ||
            ((d = a.fn.cycle.transitions.fade),
            e.API.log('Transition "' + e.fx + '" not found.  Using fade.')),
          d
        );
      },
      prepareTx: function (a, b) {
        var c,
          d,
          e,
          f,
          g,
          h = this.opts();
        return h.slideCount < 2
          ? void (h.timeoutId = 0)
          : (!a ||
              (h.busy && !h.manualTrump) ||
              (h.API.stopTransition(),
              (h.busy = !1),
              clearTimeout(h.timeoutId),
              (h.timeoutId = 0)),
            void (
              h.busy ||
              ((0 !== h.timeoutId || a) &&
                ((d = h.slides[h.currSlide]),
                (e = h.slides[h.nextSlide]),
                (f = h.API.getSlideOpts(h.nextSlide)),
                (g = h.API.calcTx(f, a)),
                (h._tx = g),
                a && void 0 !== f.manualSpeed && (f.speed = f.manualSpeed),
                h.nextSlide != h.currSlide &&
                (a || (!h.paused && !h.hoverPaused && h.timeout))
                  ? (h.API.trigger("cycle-before", [f, d, e, b]),
                    g.before && g.before(f, d, e, b),
                    (c = function () {
                      (h.busy = !1),
                        h.container.data("cycle.opts") &&
                          (g.after && g.after(f, d, e, b),
                          h.API.trigger("cycle-after", [f, d, e, b]),
                          h.API.queueTransition(f),
                          h.API.updateView(!0));
                    }),
                    (h.busy = !0),
                    g.transition
                      ? g.transition(f, d, e, b, c)
                      : h.API.doTransition(f, d, e, b, c),
                    h.API.calcNextSlide(),
                    h.API.updateView())
                  : h.API.queueTransition(f)))
            ));
      },
      doTransition: function (b, c, d, e, f) {
        var g = b,
          h = a(c),
          i = a(d),
          j = function () {
            i.animate(
              g.animIn || { opacity: 1 },
              g.speed,
              g.easeIn || g.easing,
              f
            );
          };
        i.css(g.cssBefore || {}),
          h.animate(
            g.animOut || {},
            g.speed,
            g.easeOut || g.easing,
            function () {
              h.css(g.cssAfter || {}), g.sync || j();
            }
          ),
          g.sync && j();
      },
      queueTransition: function (b, c) {
        var d = this.opts(),
          e = void 0 !== c ? c : b.timeout;
        return 0 === d.nextSlide && 0 === --d.loop
          ? (d.API.log("terminating; loop=0"),
            (d.timeout = 0),
            e
              ? setTimeout(function () {
                  d.API.trigger("cycle-finished", [d]);
                }, e)
              : d.API.trigger("cycle-finished", [d]),
            void (d.nextSlide = d.currSlide))
          : void 0 !== d.continueAuto &&
            (d.continueAuto === !1 ||
              (a.isFunction(d.continueAuto) && d.continueAuto() === !1))
          ? (d.API.log("terminating automatic transitions"),
            (d.timeout = 0),
            void (d.timeoutId && clearTimeout(d.timeoutId)))
          : void (
              e &&
              ((d._lastQueue = a.now()),
              void 0 === c && (d._remainingTimeout = b.timeout),
              d.paused ||
                d.hoverPaused ||
                (d.timeoutId = setTimeout(function () {
                  d.API.prepareTx(!1, !d.reverse);
                }, e)))
            );
      },
      stopTransition: function () {
        var a = this.opts();
        a.slides.filter(":animated").length &&
          (a.slides.stop(!1, !0),
          a.API.trigger("cycle-transition-stopped", [a])),
          a._tx && a._tx.stopTransition && a._tx.stopTransition(a);
      },
      advanceSlide: function (a) {
        var b = this.opts();
        return (
          clearTimeout(b.timeoutId),
          (b.timeoutId = 0),
          (b.nextSlide = b.currSlide + a),
          b.nextSlide < 0
            ? (b.nextSlide = b.slides.length - 1)
            : b.nextSlide >= b.slides.length && (b.nextSlide = 0),
          b.API.prepareTx(!0, a >= 0),
          !1
        );
      },
      buildSlideOpts: function (c) {
        var d,
          e,
          f = this.opts(),
          g = c.data() || {};
        for (var h in g)
          g.hasOwnProperty(h) &&
            /^cycle[A-Z]+/.test(h) &&
            ((d = g[h]),
            (e = h.match(/^cycle(.*)/)[1].replace(/^[A-Z]/, b)),
            f.API.log(
              "[" + (f.slideCount - 1) + "]",
              e + ":",
              d,
              "(" + typeof d + ")"
            ),
            (g[e] = d));
        (g = a.extend({}, a.fn.cycle.defaults, f, g)),
          (g.slideNum = f.slideCount);
        try {
          delete g.API,
            delete g.slideCount,
            delete g.currSlide,
            delete g.nextSlide,
            delete g.slides;
        } catch (i) {}
        return g;
      },
      getSlideOpts: function (b) {
        var c = this.opts();
        void 0 === b && (b = c.currSlide);
        var d = c.slides[b],
          e = a(d).data("cycle.opts");
        return a.extend({}, c, e);
      },
      initSlide: function (b, c, d) {
        var e = this.opts();
        c.css(b.slideCss || {}),
          d > 0 && c.css("zIndex", d),
          isNaN(b.speed) &&
            (b.speed = a.fx.speeds[b.speed] || a.fx.speeds._default),
          b.sync || (b.speed = b.speed / 2),
          c.addClass(e.slideClass);
      },
      updateView: function (a, b) {
        var c = this.opts();
        if (c._initialized) {
          var d = c.API.getSlideOpts(),
            e = c.slides[c.currSlide];
          (!a &&
            b !== !0 &&
            (c.API.trigger("cycle-update-view-before", [c, d, e]),
            c.updateView < 0)) ||
            (c.slideActiveClass &&
              c.slides
                .removeClass(c.slideActiveClass)
                .eq(c.currSlide)
                .addClass(c.slideActiveClass),
            a &&
              c.hideNonActive &&
              c.slides
                .filter(":not(." + c.slideActiveClass + ")")
                .css("visibility", "hidden"),
            0 === c.updateView &&
              setTimeout(function () {
                c.API.trigger("cycle-update-view", [c, d, e, a]);
              }, d.speed / (c.sync ? 2 : 1)),
            0 !== c.updateView &&
              c.API.trigger("cycle-update-view", [c, d, e, a]),
            a && c.API.trigger("cycle-update-view-after", [c, d, e]));
        }
      },
      getComponent: function (b) {
        var c = this.opts(),
          d = c[b];
        return "string" == typeof d
          ? /^\s*[\>|\+|~]/.test(d)
            ? c.container.find(d)
            : a(d)
          : d.jquery
          ? d
          : a(d);
      },
      stackSlides: function (b, c, d) {
        var e = this.opts();
        b ||
          ((b = e.slides[e.currSlide]),
          (c = e.slides[e.nextSlide]),
          (d = !e.reverse)),
          a(b).css("zIndex", e.maxZ);
        var f,
          g = e.maxZ - 2,
          h = e.slideCount;
        if (d) {
          for (f = e.currSlide + 1; h > f; f++)
            a(e.slides[f]).css("zIndex", g--);
          for (f = 0; f < e.currSlide; f++) a(e.slides[f]).css("zIndex", g--);
        } else {
          for (f = e.currSlide - 1; f >= 0; f--)
            a(e.slides[f]).css("zIndex", g--);
          for (f = h - 1; f > e.currSlide; f--)
            a(e.slides[f]).css("zIndex", g--);
        }
        a(c).css("zIndex", e.maxZ - 1);
      },
      getSlideIndex: function (a) {
        return this.opts().slides.index(a);
      },
    }),
    (a.fn.cycle.log = function () {
      window.console &&
        console.log &&
        console.log("[cycle2] " + Array.prototype.join.call(arguments, " "));
    }),
    (a.fn.cycle.version = function () {
      return "Cycle2: " + c;
    }),
    (a.fn.cycle.transitions = {
      custom: {},
      none: {
        before: function (a, b, c, d) {
          a.API.stackSlides(c, b, d),
            (a.cssBefore = {
              opacity: 1,
              visibility: "visible",
              display: "block",
            });
        },
      },
      fade: {
        before: function (b, c, d, e) {
          var f = b.API.getSlideOpts(b.nextSlide).slideCss || {};
          b.API.stackSlides(c, d, e),
            (b.cssBefore = a.extend(f, {
              opacity: 0,
              visibility: "visible",
              display: "block",
            })),
            (b.animIn = { opacity: 1 }),
            (b.animOut = { opacity: 0 });
        },
      },
      fadeout: {
        before: function (b, c, d, e) {
          var f = b.API.getSlideOpts(b.nextSlide).slideCss || {};
          b.API.stackSlides(c, d, e),
            (b.cssBefore = a.extend(f, {
              opacity: 1,
              visibility: "visible",
              display: "block",
            })),
            (b.animOut = { opacity: 0 });
        },
      },
      scrollHorz: {
        before: function (a, b, c, d) {
          a.API.stackSlides(b, c, d);
          var e = a.container.css("overflow", "hidden").width();
          (a.cssBefore = {
            left: d ? e : -e,
            top: 0,
            opacity: 1,
            visibility: "visible",
            display: "block",
          }),
            (a.cssAfter = { zIndex: a._maxZ - 2, left: 0 }),
            (a.animIn = { left: 0 }),
            (a.animOut = { left: d ? -e : e });
        },
      },
    }),
    (a.fn.cycle.defaults = {
      allowWrap: !0,
      autoSelector: ".cycle-slideshow[data-cycle-auto-init!=false]",
      delay: 0,
      easing: null,
      fx: "fade",
      hideNonActive: !0,
      loop: 0,
      manualFx: void 0,
      manualSpeed: void 0,
      manualTrump: !0,
      maxZ: 100,
      pauseOnHover: !1,
      reverse: !1,
      slideActiveClass: "cycle-slide-active",
      slideClass: "cycle-slide",
      slideCss: { position: "absolute", top: 0, left: 0 },
      slides: "> img",
      speed: 500,
      startingSlide: 0,
      sync: !0,
      timeout: 4e3,
      updateView: 0,
    }),
    a(document).ready(function () {
      a(a.fn.cycle.defaults.autoSelector).cycle();
    });
})(
  jQuery
) /*! Cycle2 autoheight plugin; Copyright (c) M.Alsup, 2012; version: 20130913 */,
  (function (a) {
    "use strict";
    function b(b, d) {
      var e,
        f,
        g,
        h = d.autoHeight;
      if ("container" == h)
        (f = a(d.slides[d.currSlide]).outerHeight()), d.container.height(f);
      else if (d._autoHeightRatio)
        d.container.height(d.container.width() / d._autoHeightRatio);
      else if ("calc" === h || ("number" == a.type(h) && h >= 0)) {
        if (
          ((g = "calc" === h ? c(b, d) : h >= d.slides.length ? 0 : h),
          g == d._sentinelIndex)
        )
          return;
        (d._sentinelIndex = g),
          d._sentinel && d._sentinel.remove(),
          (e = a(d.slides[g].cloneNode(!0))),
          e
            .removeAttr("id name rel")
            .find("[id],[name],[rel]")
            .removeAttr("id name rel"),
          e
            .css({ position: "static", visibility: "hidden", display: "block" })
            .prependTo(d.container)
            .addClass("cycle-sentinel cycle-slide")
            .removeClass("cycle-slide-active"),
          e.find("*").css("visibility", "hidden"),
          (d._sentinel = e);
      }
    }
    function c(b, c) {
      var d = 0,
        e = -1;
      return (
        c.slides.each(function (b) {
          var c = a(this).height();
          c > e && ((e = c), (d = b));
        }),
        d
      );
    }
    function d(b, c, d, e) {
      var f = a(e).outerHeight();
      c.container.animate({ height: f }, c.autoHeightSpeed, c.autoHeightEasing);
    }
    function e(c, f) {
      f._autoHeightOnResize &&
        (a(window).off("resize orientationchange", f._autoHeightOnResize),
        (f._autoHeightOnResize = null)),
        f.container.off("cycle-slide-added cycle-slide-removed", b),
        f.container.off("cycle-destroyed", e),
        f.container.off("cycle-before", d),
        f._sentinel && (f._sentinel.remove(), (f._sentinel = null));
    }
    a.extend(a.fn.cycle.defaults, {
      autoHeight: 0,
      autoHeightSpeed: 250,
      autoHeightEasing: null,
    }),
      a(document).on("cycle-initialized", function (c, f) {
        function g() {
          b(c, f);
        }
        var h,
          i = f.autoHeight,
          j = a.type(i),
          k = null;
        ("string" === j || "number" === j) &&
          (f.container.on("cycle-slide-added cycle-slide-removed", b),
          f.container.on("cycle-destroyed", e),
          "container" == i
            ? f.container.on("cycle-before", d)
            : "string" === j &&
              /\d+\:\d+/.test(i) &&
              ((h = i.match(/(\d+)\:(\d+)/)),
              (h = h[1] / h[2]),
              (f._autoHeightRatio = h)),
          "number" !== j &&
            ((f._autoHeightOnResize = function () {
              clearTimeout(k), (k = setTimeout(g, 50));
            }),
            a(window).on("resize orientationchange", f._autoHeightOnResize)),
          setTimeout(g, 30));
      });
  })(jQuery) /*! caption plugin for Cycle2;  version: 20130306 */,
  (function (a) {
    "use strict";
    a.extend(a.fn.cycle.defaults, {
      caption: "> .cycle-caption",
      captionTemplate: "{{slideNum}} / {{slideCount}}",
      overlay: "> .cycle-overlay",
      overlayTemplate: "<div>{{title}}</div><div>{{desc}}</div>",
      captionModule: "caption",
    }),
      a(document).on("cycle-update-view", function (b, c, d, e) {
        if ("caption" === c.captionModule) {
          a.each(["caption", "overlay"], function () {
            var a = this,
              b = d[a + "Template"],
              f = c.API.getComponent(a);
            f.length && b
              ? (f.html(c.API.tmpl(b, d, c, e)), f.show())
              : f.hide();
          });
        }
      }),
      a(document).on("cycle-destroyed", function (b, c) {
        var d;
        a.each(["caption", "overlay"], function () {
          var a = this,
            b = c[a + "Template"];
          c[a] && b && ((d = c.API.getComponent("caption")), d.empty());
        });
      });
  })(jQuery) /*! command plugin for Cycle2;  version: 20140415 */,
  (function (a) {
    "use strict";
    var b = a.fn.cycle;
    (a.fn.cycle = function (c) {
      var d,
        e,
        f,
        g = a.makeArray(arguments);
      return "number" == a.type(c)
        ? this.cycle("goto", c)
        : "string" == a.type(c)
        ? this.each(function () {
            var h;
            return (
              (d = c),
              (f = a(this).data("cycle.opts")),
              void 0 === f
                ? void b.log(
                    'slideshow must be initialized before sending commands; "' +
                      d +
                      '" ignored'
                  )
                : ((d = "goto" == d ? "jump" : d),
                  (e = f.API[d]),
                  a.isFunction(e)
                    ? ((h = a.makeArray(g)), h.shift(), e.apply(f.API, h))
                    : void b.log("unknown command: ", d))
            );
          })
        : b.apply(this, arguments);
    }),
      a.extend(a.fn.cycle, b),
      a.extend(b.API, {
        next: function () {
          var a = this.opts();
          if (!a.busy || a.manualTrump) {
            var b = a.reverse ? -1 : 1;
            (a.allowWrap === !1 && a.currSlide + b >= a.slideCount) ||
              (a.API.advanceSlide(b),
              a.API.trigger("cycle-next", [a]).log("cycle-next"));
          }
        },
        prev: function () {
          var a = this.opts();
          if (!a.busy || a.manualTrump) {
            var b = a.reverse ? 1 : -1;
            (a.allowWrap === !1 && a.currSlide + b < 0) ||
              (a.API.advanceSlide(b),
              a.API.trigger("cycle-prev", [a]).log("cycle-prev"));
          }
        },
        destroy: function () {
          this.stop();
          var b = this.opts(),
            c = a.isFunction(a._data) ? a._data : a.noop;
          clearTimeout(b.timeoutId),
            (b.timeoutId = 0),
            b.API.stop(),
            b.API.trigger("cycle-destroyed", [b]).log("cycle-destroyed"),
            b.container.removeData(),
            c(b.container[0], "parsedAttrs", !1),
            b.retainStylesOnDestroy ||
              (b.container.removeAttr("style"),
              b.slides.removeAttr("style"),
              b.slides.removeClass(b.slideActiveClass)),
            b.slides.each(function () {
              var d = a(this);
              d.removeData(),
                d.removeClass(b.slideClass),
                c(this, "parsedAttrs", !1);
            });
        },
        jump: function (a, b) {
          var c,
            d = this.opts();
          if (!d.busy || d.manualTrump) {
            var e = parseInt(a, 10);
            if (isNaN(e) || 0 > e || e >= d.slides.length)
              return void d.API.log("goto: invalid slide index: " + e);
            if (e == d.currSlide)
              return void d.API.log("goto: skipping, already on slide", e);
            (d.nextSlide = e),
              clearTimeout(d.timeoutId),
              (d.timeoutId = 0),
              d.API.log("goto: ", e, " (zero-index)"),
              (c = d.currSlide < d.nextSlide),
              (d._tempFx = b),
              d.API.prepareTx(!0, c);
          }
        },
        stop: function () {
          var b = this.opts(),
            c = b.container;
          clearTimeout(b.timeoutId),
            (b.timeoutId = 0),
            b.API.stopTransition(),
            b.pauseOnHover &&
              (b.pauseOnHover !== !0 && (c = a(b.pauseOnHover)),
              c.off("mouseenter mouseleave")),
            b.API.trigger("cycle-stopped", [b]).log("cycle-stopped");
        },
        reinit: function () {
          var a = this.opts();
          a.API.destroy(), a.container.cycle();
        },
        remove: function (b) {
          for (
            var c, d, e = this.opts(), f = [], g = 1, h = 0;
            h < e.slides.length;
            h++
          )
            (c = e.slides[h]),
              h == b
                ? (d = c)
                : (f.push(c), (a(c).data("cycle.opts").slideNum = g), g++);
          d &&
            ((e.slides = a(f)),
            e.slideCount--,
            a(d).remove(),
            b == e.currSlide
              ? e.API.advanceSlide(1)
              : b < e.currSlide
              ? e.currSlide--
              : e.currSlide++,
            e.API.trigger("cycle-slide-removed", [e, b, d]).log(
              "cycle-slide-removed"
            ),
            e.API.updateView());
        },
      }),
      a(document).on("click.cycle", "[data-cycle-cmd]", function (b) {
        b.preventDefault();
        var c = a(this),
          d = c.data("cycle-cmd"),
          e = c.data("cycle-context") || ".cycle-slideshow";
        a(e).cycle(d, c.data("cycle-arg"));
      });
  })(jQuery) /*! hash plugin for Cycle2;  version: 20130905 */,
  (function (a) {
    "use strict";
    function b(b, c) {
      var d;
      return b._hashFence
        ? void (b._hashFence = !1)
        : ((d = window.location.hash.substring(1)),
          void b.slides.each(function (e) {
            if (a(this).data("cycle-hash") == d) {
              if (c === !0) b.startingSlide = e;
              else {
                var f = b.currSlide < e;
                (b.nextSlide = e), b.API.prepareTx(!0, f);
              }
              return !1;
            }
          }));
    }
    a(document).on("cycle-pre-initialize", function (c, d) {
      b(d, !0),
        (d._onHashChange = function () {
          b(d, !1);
        }),
        a(window).on("hashchange", d._onHashChange);
    }),
      a(document).on("cycle-update-view", function (a, b, c) {
        c.hash &&
          "#" + c.hash != window.location.hash &&
          ((b._hashFence = !0), (window.location.hash = c.hash));
      }),
      a(document).on("cycle-destroyed", function (b, c) {
        c._onHashChange && a(window).off("hashchange", c._onHashChange);
      });
  })(jQuery) /*! loader plugin for Cycle2;  version: 20131121 */,
  (function (a) {
    "use strict";
    a.extend(a.fn.cycle.defaults, { loader: !1 }),
      a(document).on("cycle-bootstrap", function (b, c) {
        function d(b, d) {
          function f(b) {
            var f;
            "wait" == c.loader
              ? (h.push(b),
                0 === j &&
                  (h.sort(g),
                  e.apply(c.API, [h, d]),
                  c.container.removeClass("cycle-loading")))
              : ((f = a(c.slides[c.currSlide])),
                e.apply(c.API, [b, d]),
                f.show(),
                c.container.removeClass("cycle-loading"));
          }
          function g(a, b) {
            return a.data("index") - b.data("index");
          }
          var h = [];
          if ("string" == a.type(b)) b = a.trim(b);
          else if ("array" === a.type(b))
            for (var i = 0; i < b.length; i++) b[i] = a(b[i])[0];
          b = a(b);
          var j = b.length;
          j &&
            (b
              .css("visibility", "hidden")
              .appendTo("body")
              .each(function (b) {
                function g() {
                  0 === --i && (--j, f(k));
                }
                var i = 0,
                  k = a(this),
                  l = k.is("img") ? k : k.find("img");
                return (
                  k.data("index", b),
                  (l = l
                    .filter(":not(.cycle-loader-ignore)")
                    .filter(':not([src=""])')),
                  l.length
                    ? ((i = l.length),
                      void l.each(function () {
                        this.complete
                          ? g()
                          : a(this)
                              .load(function () {
                                g();
                              })
                              .on("error", function () {
                                0 === --i &&
                                  (c.API.log(
                                    "slide skipped; img not loaded:",
                                    this.src
                                  ),
                                  0 === --j &&
                                    "wait" == c.loader &&
                                    e.apply(c.API, [h, d]));
                              });
                      }))
                    : (--j, void h.push(k))
                );
              }),
            j && c.container.addClass("cycle-loading"));
        }
        var e;
        c.loader && ((e = c.API.add), (c.API.add = d));
      });
  })(jQuery) /*! pager plugin for Cycle2;  version: 20140415 */,
  (function (a) {
    "use strict";
    function b(b, c, d) {
      var e,
        f = b.API.getComponent("pager");
      f.each(function () {
        var f = a(this);
        if (c.pagerTemplate) {
          var g = b.API.tmpl(c.pagerTemplate, c, b, d[0]);
          e = a(g).appendTo(f);
        } else e = f.children().eq(b.slideCount - 1);
        e.on(b.pagerEvent, function (a) {
          b.pagerEventBubble || a.preventDefault(),
            b.API.page(f, a.currentTarget);
        });
      });
    }
    function c(a, b) {
      var c = this.opts();
      if (!c.busy || c.manualTrump) {
        var d = a.children().index(b),
          e = d,
          f = c.currSlide < e;
        c.currSlide != e &&
          ((c.nextSlide = e),
          (c._tempFx = c.pagerFx),
          c.API.prepareTx(!0, f),
          c.API.trigger("cycle-pager-activated", [c, a, b]));
      }
    }
    a.extend(a.fn.cycle.defaults, {
      pager: "> .cycle-pager",
      pagerActiveClass: "cycle-pager-active",
      pagerEvent: "click.cycle",
      pagerEventBubble: void 0,
      pagerTemplate: "<span>&bull;</span>",
    }),
      a(document).on("cycle-bootstrap", function (a, c, d) {
        d.buildPagerLink = b;
      }),
      a(document).on("cycle-slide-added", function (a, b, d, e) {
        b.pager && (b.API.buildPagerLink(b, d, e), (b.API.page = c));
      }),
      a(document).on("cycle-slide-removed", function (b, c, d) {
        if (c.pager) {
          var e = c.API.getComponent("pager");
          e.each(function () {
            var b = a(this);
            a(b.children()[d]).remove();
          });
        }
      }),
      a(document).on("cycle-update-view", function (b, c) {
        var d;
        c.pager &&
          ((d = c.API.getComponent("pager")),
          d.each(function () {
            a(this)
              .children()
              .removeClass(c.pagerActiveClass)
              .eq(c.currSlide)
              .addClass(c.pagerActiveClass);
          }));
      }),
      a(document).on("cycle-destroyed", function (a, b) {
        var c = b.API.getComponent("pager");
        c && (c.children().off(b.pagerEvent), b.pagerTemplate && c.empty());
      });
  })(jQuery) /*! prevnext plugin for Cycle2;  version: 20140408 */,
  (function (a) {
    "use strict";
    a.extend(a.fn.cycle.defaults, {
      next: "> .cycle-next",
      nextEvent: "click.cycle",
      disabledClass: "disabled",
      prev: "> .cycle-prev",
      prevEvent: "click.cycle",
      swipe: !1,
    }),
      a(document).on("cycle-initialized", function (a, b) {
        if (
          (b.API.getComponent("next").on(b.nextEvent, function (a) {
            a.preventDefault(), b.API.next();
          }),
          b.API.getComponent("prev").on(b.prevEvent, function (a) {
            a.preventDefault(), b.API.prev();
          }),
          b.swipe)
        ) {
          var c = b.swipeVert
              ? "swipeUp.cycle"
              : "swipeLeft.cycle swipeleft.cycle",
            d = b.swipeVert
              ? "swipeDown.cycle"
              : "swipeRight.cycle swiperight.cycle";
          b.container.on(c, function () {
            (b._tempFx = b.swipeFx), b.API.next();
          }),
            b.container.on(d, function () {
              (b._tempFx = b.swipeFx), b.API.prev();
            });
        }
      }),
      a(document).on("cycle-update-view", function (a, b) {
        if (!b.allowWrap) {
          var c = b.disabledClass,
            d = b.API.getComponent("next"),
            e = b.API.getComponent("prev"),
            f = b._prevBoundry || 0,
            g = void 0 !== b._nextBoundry ? b._nextBoundry : b.slideCount - 1;
          b.currSlide == g
            ? d.addClass(c).prop("disabled", !0)
            : d.removeClass(c).prop("disabled", !1),
            b.currSlide === f
              ? e.addClass(c).prop("disabled", !0)
              : e.removeClass(c).prop("disabled", !1);
        }
      }),
      a(document).on("cycle-destroyed", function (a, b) {
        b.API.getComponent("prev").off(b.nextEvent),
          b.API.getComponent("next").off(b.prevEvent),
          b.container.off(
            "swipeleft.cycle swiperight.cycle swipeLeft.cycle swipeRight.cycle swipeUp.cycle swipeDown.cycle"
          );
      });
  })(jQuery) /*! progressive loader plugin for Cycle2;  version: 20130315 */,
  (function (a) {
    "use strict";
    a.extend(a.fn.cycle.defaults, { progressive: !1 }),
      a(document).on("cycle-pre-initialize", function (b, c) {
        if (c.progressive) {
          var d,
            e,
            f = c.API,
            g = f.next,
            h = f.prev,
            i = f.prepareTx,
            j = a.type(c.progressive);
          if ("array" == j) d = c.progressive;
          else if (a.isFunction(c.progressive)) d = c.progressive(c);
          else if ("string" == j) {
            if (((e = a(c.progressive)), (d = a.trim(e.html())), !d)) return;
            if (/^(\[)/.test(d))
              try {
                d = a.parseJSON(d);
              } catch (k) {
                return void f.log("error parsing progressive slides", k);
              }
            else
              (d = d.split(new RegExp(e.data("cycle-split") || "\n"))),
                d[d.length - 1] || d.pop();
          }
          i &&
            (f.prepareTx = function (a, b) {
              var e, f;
              return a || 0 === d.length
                ? void i.apply(c.API, [a, b])
                : void (b && c.currSlide == c.slideCount - 1
                    ? ((f = d[0]),
                      (d = d.slice(1)),
                      c.container.one("cycle-slide-added", function (a, b) {
                        setTimeout(function () {
                          b.API.advanceSlide(1);
                        }, 50);
                      }),
                      c.API.add(f))
                    : b || 0 !== c.currSlide
                    ? i.apply(c.API, [a, b])
                    : ((e = d.length - 1),
                      (f = d[e]),
                      (d = d.slice(0, e)),
                      c.container.one("cycle-slide-added", function (a, b) {
                        setTimeout(function () {
                          (b.currSlide = 1), b.API.advanceSlide(-1);
                        }, 50);
                      }),
                      c.API.add(f, !0)));
            }),
            g &&
              (f.next = function () {
                var a = this.opts();
                if (d.length && a.currSlide == a.slideCount - 1) {
                  var b = d[0];
                  (d = d.slice(1)),
                    a.container.one("cycle-slide-added", function (a, b) {
                      g.apply(b.API), b.container.removeClass("cycle-loading");
                    }),
                    a.container.addClass("cycle-loading"),
                    a.API.add(b);
                } else g.apply(a.API);
              }),
            h &&
              (f.prev = function () {
                var a = this.opts();
                if (d.length && 0 === a.currSlide) {
                  var b = d.length - 1,
                    c = d[b];
                  (d = d.slice(0, b)),
                    a.container.one("cycle-slide-added", function (a, b) {
                      (b.currSlide = 1),
                        b.API.advanceSlide(-1),
                        b.container.removeClass("cycle-loading");
                    }),
                    a.container.addClass("cycle-loading"),
                    a.API.add(c, !0);
                } else h.apply(a.API);
              });
        }
      });
  })(jQuery) /*! tmpl plugin for Cycle2;  version: 20121227 */,
  (function (a) {
    "use strict";
    a.extend(a.fn.cycle.defaults, { tmplRegex: "{{((.)?.*?)}}" }),
      a.extend(a.fn.cycle.API, {
        tmpl: function (b, c) {
          var d = new RegExp(c.tmplRegex || a.fn.cycle.defaults.tmplRegex, "g"),
            e = a.makeArray(arguments);
          return (
            e.shift(),
            b.replace(d, function (b, c) {
              var d,
                f,
                g,
                h,
                i = c.split(".");
              for (d = 0; d < e.length; d++)
                if ((g = e[d])) {
                  if (i.length > 1)
                    for (h = g, f = 0; f < i.length; f++)
                      (g = h), (h = h[i[f]] || c);
                  else h = g[c];
                  if (a.isFunction(h)) return h.apply(g, e);
                  if (void 0 !== h && null !== h && h != c) return h;
                }
              return c;
            })
          );
        },
      });
  })(jQuery);
//# sourceMappingURL=jquery.cycle2.js.map

/* Plugin for Cycle2; Copyright (c) 2012 M. Alsup; v20141007 */
!(function (a) {
  "use strict";
  a(document).on("cycle-bootstrap", function (a, b, c) {
    "carousel" === b.fx &&
      ((c.getSlideIndex = function (a) {
        var b = this.opts()._carouselWrap.children(),
          c = b.index(a);
        return c % b.length;
      }),
      (c.next = function () {
        var a = b.reverse ? -1 : 1;
        (b.allowWrap === !1 &&
          b.currSlide + a > b.slideCount - b.carouselVisible) ||
          (b.API.advanceSlide(a),
          b.API.trigger("cycle-next", [b]).log("cycle-next"));
      }));
  }),
    (a.fn.cycle.transitions.carousel = {
      preInit: function (b) {
        (b.hideNonActive = !1),
          b.container.on("cycle-destroyed", a.proxy(this.onDestroy, b.API)),
          (b.API.stopTransition = this.stopTransition);
        for (var c = 0; c < b.startingSlide; c++)
          b.container.append(b.slides[0]);
      },
      postInit: function (b) {
        var c,
          d,
          e,
          f,
          g = b.carouselVertical;
        b.carouselVisible &&
          b.carouselVisible > b.slideCount &&
          (b.carouselVisible = b.slideCount - 1);
        var h = b.carouselVisible || b.slides.length,
          i = { display: g ? "block" : "inline-block", position: "static" };
        if (
          (b.container.css({ position: "relative", overflow: "hidden" }),
          b.slides.css(i),
          (b._currSlide = b.currSlide),
          (f = a('<div class="cycle-carousel-wrap"></div>')
            .prependTo(b.container)
            .css({
              margin: 0,
              padding: 0,
              top: 0,
              left: 0,
              position: "absolute",
            })
            .append(b.slides)),
          (b._carouselWrap = f),
          g || f.css("white-space", "nowrap"),
          b.allowWrap !== !1)
        ) {
          for (d = 0; d < (void 0 === b.carouselVisible ? 2 : 1); d++) {
            for (c = 0; c < b.slideCount; c++)
              f.append(b.slides[c].cloneNode(!0));
            for (c = b.slideCount; c--; ) f.prepend(b.slides[c].cloneNode(!0));
          }
          f.find(".cycle-slide-active").removeClass("cycle-slide-active"),
            b.slides.eq(b.startingSlide).addClass("cycle-slide-active");
        }
        b.pager &&
          b.allowWrap === !1 &&
          ((e = b.slideCount - h),
          a(b.pager)
            .children()
            .filter(":gt(" + e + ")")
            .hide()),
          (b._nextBoundry = b.slideCount - b.carouselVisible),
          this.prepareDimensions(b);
      },
      prepareDimensions: function (b) {
        var c,
          d,
          e,
          f,
          g = b.carouselVertical,
          h = b.carouselVisible || b.slides.length;
        if (
          (b.carouselFluid && b.carouselVisible
            ? b._carouselResizeThrottle || this.fluidSlides(b)
            : b.carouselVisible && b.carouselSlideDimension
            ? ((c = h * b.carouselSlideDimension),
              b.container[g ? "height" : "width"](c))
            : b.carouselVisible &&
              ((c = h * a(b.slides[0])[g ? "outerHeight" : "outerWidth"](!0)),
              b.container[g ? "height" : "width"](c)),
          (d = b.carouselOffset || 0),
          b.allowWrap !== !1)
        )
          if (b.carouselSlideDimension)
            d -= (b.slideCount + b.currSlide) * b.carouselSlideDimension;
          else
            for (
              e = b._carouselWrap.children(), f = 0;
              f < b.slideCount + b.currSlide;
              f++
            )
              d -= a(e[f])[g ? "outerHeight" : "outerWidth"](!0);
        b._carouselWrap.css(g ? "top" : "left", d);
      },
      fluidSlides: function (b) {
        function c() {
          clearTimeout(e), (e = setTimeout(d, 20));
        }
        function d() {
          b._carouselWrap.stop(!1, !0);
          var a = b.container.width() / b.carouselVisible;
          (a = Math.ceil(a - g)),
            b._carouselWrap.children().width(a),
            b._sentinel && b._sentinel.width(a),
            h(b);
        }
        var e,
          f = b.slides.eq(0),
          g = f.outerWidth() - f.width(),
          h = this.prepareDimensions;
        a(window).on("resize", c), (b._carouselResizeThrottle = c), d();
      },
      transition: function (b, c, d, e, f) {
        var g,
          h = {},
          i = b.nextSlide - b.currSlide,
          j = b.carouselVertical,
          k = b.speed;
        if (b.allowWrap === !1) {
          e = i > 0;
          var l = b._currSlide,
            m = b.slideCount - b.carouselVisible;
          i > 0 && b.nextSlide > m && l == m
            ? (i = 0)
            : i > 0 && b.nextSlide > m
            ? (i = b.nextSlide - l - (b.nextSlide - m))
            : 0 > i && b.currSlide > m && b.nextSlide > m
            ? (i = 0)
            : 0 > i && b.currSlide > m
            ? (i += b.currSlide - m)
            : (l = b.currSlide),
            (g = this.getScroll(b, j, l, i)),
            (b.API.opts()._currSlide = b.nextSlide > m ? m : b.nextSlide);
        } else
          e && 0 === b.nextSlide
            ? ((g = this.getDim(b, b.currSlide, j)),
              (f = this.genCallback(b, e, j, f)))
            : e || b.nextSlide != b.slideCount - 1
            ? (g = this.getScroll(b, j, b.currSlide, i))
            : ((g = this.getDim(b, b.currSlide, j)),
              (f = this.genCallback(b, e, j, f)));
        (h[j ? "top" : "left"] = e ? "-=" + g : "+=" + g),
          b.throttleSpeed &&
            (k = (g / a(b.slides[0])[j ? "height" : "width"]()) * b.speed),
          b._carouselWrap.animate(h, k, b.easing, f);
      },
      getDim: function (b, c, d) {
        var e = a(b.slides[c]);
        return e[d ? "outerHeight" : "outerWidth"](!0);
      },
      getScroll: function (a, b, c, d) {
        var e,
          f = 0;
        if (d > 0) for (e = c; c + d > e; e++) f += this.getDim(a, e, b);
        else for (e = c; e > c + d; e--) f += this.getDim(a, e, b);
        return f;
      },
      genCallback: function (b, c, d, e) {
        return function () {
          var c = a(b.slides[b.nextSlide]).position(),
            f = 0 - c[d ? "top" : "left"] + (b.carouselOffset || 0);
          b._carouselWrap.css(b.carouselVertical ? "top" : "left", f), e();
        };
      },
      stopTransition: function () {
        var a = this.opts();
        a.slides.stop(!1, !0), a._carouselWrap.stop(!1, !0);
      },
      onDestroy: function () {
        var b = this.opts();
        b._carouselResizeThrottle &&
          a(window).off("resize", b._carouselResizeThrottle),
          b.slides.prependTo(b.container),
          b._carouselWrap.remove();
      },
    });
})(jQuery);

/* Plugin for Cycle2; Copyright (c) 2012 M. Alsup; v20141007 */
!(function (a) {
  "use strict";
  a.fn.cycle.transitions.scrollVert = {
    before: function (a, b, c, d) {
      a.API.stackSlides(a, b, c, d);
      var e = a.container.css("overflow", "hidden").height();
      (a.cssBefore = {
        top: d ? -e : e,
        left: 0,
        opacity: 1,
        display: "block",
        visibility: "visible",
      }),
        (a.animIn = { top: 0 }),
        (a.animOut = { top: d ? e : -e });
    },
  };
})(jQuery);

/*
 *	jQuery dotdotdot 1.8.3
 *
 *	Copyright (c) Fred Heusschen
 *	www.frebsite.nl
 *
 *	Plugin website:
 *	dotdotdot.frebsite.nl
 *
 *	Licensed under the MIT license.
 *	http://en.wikipedia.org/wiki/MIT_License
 */
!(function (t, e) {
  function n(t, e, n) {
    var r = t.children(),
      o = !1;
    t.empty();
    for (var i = 0, d = r.length; d > i; i++) {
      var l = r.eq(i);
      if ((t.append(l), n && t.append(n), a(t, e))) {
        l.remove(), (o = !0);
        break;
      }
      n && n.detach();
    }
    return o;
  }
  function r(e, n, i, d, l) {
    var s = !1,
      c =
        "a, table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style",
      u = "script, .dotdotdot-keep";
    return (
      e
        .contents()
        .detach()
        .each(function () {
          var h = this,
            f = t(h);
          if ("undefined" == typeof h) return !0;
          if (f.is(u)) e.append(f);
          else {
            if (s) return !0;
            e.append(f),
              !l ||
                f.is(d.after) ||
                f.find(d.after).length ||
                e[e.is(c) ? "after" : "append"](l),
              a(i, d) &&
                (s = 3 == h.nodeType ? o(f, n, i, d, l) : r(f, n, i, d, l)),
              s || (l && l.detach());
          }
        }),
      n.addClass("is-truncated"),
      s
    );
  }
  function o(e, n, r, o, d) {
    var c = e[0];
    if (!c) return !1;
    var h = s(c),
      f = -1 !== h.indexOf(" ") ? " " : "　",
      p = "letter" == o.wrap ? "" : f,
      g = h.split(p),
      v = -1,
      w = -1,
      b = 0,
      m = g.length - 1;
    for (
      o.fallbackToLetter &&
      0 == b &&
      0 == m &&
      ((p = ""), (g = h.split(p)), (m = g.length - 1));
      m >= b && (0 != b || 0 != m);

    ) {
      var y = Math.floor((b + m) / 2);
      if (y == w) break;
      (w = y),
        l(c, g.slice(0, w + 1).join(p) + o.ellipsis),
        r.children().each(function () {
          t(this).toggle().toggle();
        }),
        a(r, o)
          ? ((m = w),
            o.fallbackToLetter &&
              0 == b &&
              0 == m &&
              ((p = ""),
              (g = g[0].split(p)),
              (v = -1),
              (w = -1),
              (b = 0),
              (m = g.length - 1)))
          : ((v = w), (b = w));
    }
    if (-1 == v || (1 == g.length && 0 == g[0].length)) {
      var x = e.parent();
      e.detach();
      var C = d && d.closest(x).length ? d.length : 0;
      if (
        (x.contents().length > C
          ? (c = u(x.contents().eq(-1 - C), n))
          : ((c = u(x, n, !0)), C || x.detach()),
        c && ((h = i(s(c), o)), l(c, h), C && d))
      ) {
        var T = d.parent();
        t(c).parent().append(d), t.trim(T.html()) || T.remove();
      }
    } else (h = i(g.slice(0, v + 1).join(p), o)), l(c, h);
    return !0;
  }
  function a(t, e) {
    return t.innerHeight() > e.maxHeight;
  }
  function i(e, n) {
    for (; t.inArray(e.slice(-1), n.lastCharacter.remove) > -1; )
      e = e.slice(0, -1);
    return (
      t.inArray(e.slice(-1), n.lastCharacter.noEllipsis) < 0 &&
        (e += n.ellipsis),
      e
    );
  }
  function d(t) {
    return { width: t.innerWidth(), height: t.innerHeight() };
  }
  function l(t, e) {
    t.innerText
      ? (t.innerText = e)
      : t.nodeValue
      ? (t.nodeValue = e)
      : t.textContent && (t.textContent = e);
  }
  function s(t) {
    return t.innerText
      ? t.innerText
      : t.nodeValue
      ? t.nodeValue
      : t.textContent
      ? t.textContent
      : "";
  }
  function c(t) {
    do t = t.previousSibling;
    while (t && 1 !== t.nodeType && 3 !== t.nodeType);
    return t;
  }
  function u(e, n, r) {
    var o,
      a = e && e[0];
    if (a) {
      if (!r) {
        if (3 === a.nodeType) return a;
        if (t.trim(e.text())) return u(e.contents().last(), n);
      }
      for (o = c(a); !o; ) {
        if (((e = e.parent()), e.is(n) || !e.length)) return !1;
        o = c(e[0]);
      }
      if (o) return u(t(o), n);
    }
    return !1;
  }
  function h(e, n) {
    return e
      ? "string" == typeof e
        ? ((e = t(e, n)), e.length ? e : !1)
        : e.jquery
        ? e
        : !1
      : !1;
  }
  function f(t) {
    for (
      var e = t.innerHeight(),
        n = ["paddingTop", "paddingBottom"],
        r = 0,
        o = n.length;
      o > r;
      r++
    ) {
      var a = parseInt(t.css(n[r]), 10);
      isNaN(a) && (a = 0), (e -= a);
    }
    return e;
  }
  if (!t.fn.dotdotdot) {
    (t.fn.dotdotdot = function (e) {
      if (0 == this.length)
        return (
          t.fn.dotdotdot.debug('No element found for "' + this.selector + '".'),
          this
        );
      if (this.length > 1)
        return this.each(function () {
          t(this).dotdotdot(e);
        });
      var o = this,
        i = o.contents();
      o.data("dotdotdot") && o.trigger("destroy.dot"),
        o.data("dotdotdot-style", o.attr("style") || ""),
        o.css("word-wrap", "break-word"),
        "nowrap" === o.css("white-space") && o.css("white-space", "normal"),
        (o.bind_events = function () {
          return (
            o
              .bind("update.dot", function (e, d) {
                switch (
                  (o.removeClass("is-truncated"),
                  e.preventDefault(),
                  e.stopPropagation(),
                  typeof l.height)
                ) {
                  case "number":
                    l.maxHeight = l.height;
                    break;
                  case "function":
                    l.maxHeight = l.height.call(o[0]);
                    break;
                  default:
                    l.maxHeight = f(o);
                }
                (l.maxHeight += l.tolerance),
                  "undefined" != typeof d &&
                    (("string" == typeof d ||
                      ("nodeType" in d && 1 === d.nodeType)) &&
                      (d = t("<div />").append(d).contents()),
                    d instanceof t && (i = d)),
                  (g = o.wrapInner('<div class="dotdotdot" />').children()),
                  g
                    .contents()
                    .detach()
                    .end()
                    .append(i.clone(!0))
                    .find("br")
                    .replaceWith("  <br />  ")
                    .end()
                    .css({
                      height: "auto",
                      width: "auto",
                      border: "none",
                      padding: 0,
                      margin: 0,
                    });
                var c = !1,
                  u = !1;
                return (
                  s.afterElement &&
                    ((c = s.afterElement.clone(!0)),
                    c.show(),
                    s.afterElement.detach()),
                  a(g, l) &&
                    (u = "children" == l.wrap ? n(g, l, c) : r(g, o, g, l, c)),
                  g.replaceWith(g.contents()),
                  (g = null),
                  t.isFunction(l.callback) && l.callback.call(o[0], u, i),
                  (s.isTruncated = u),
                  u
                );
              })
              .bind("isTruncated.dot", function (t, e) {
                return (
                  t.preventDefault(),
                  t.stopPropagation(),
                  "function" == typeof e && e.call(o[0], s.isTruncated),
                  s.isTruncated
                );
              })
              .bind("originalContent.dot", function (t, e) {
                return (
                  t.preventDefault(),
                  t.stopPropagation(),
                  "function" == typeof e && e.call(o[0], i),
                  i
                );
              })
              .bind("destroy.dot", function (t) {
                t.preventDefault(),
                  t.stopPropagation(),
                  o
                    .unwatch()
                    .unbind_events()
                    .contents()
                    .detach()
                    .end()
                    .append(i)
                    .attr("style", o.data("dotdotdot-style") || "")
                    .removeClass("is-truncated")
                    .data("dotdotdot", !1);
              }),
            o
          );
        }),
        (o.unbind_events = function () {
          return o.unbind(".dot"), o;
        }),
        (o.watch = function () {
          if ((o.unwatch(), "window" == l.watch)) {
            var e = t(window),
              n = e.width(),
              r = e.height();
            e.bind("resize.dot" + s.dotId, function () {
              (n == e.width() && r == e.height() && l.windowResizeFix) ||
                ((n = e.width()),
                (r = e.height()),
                u && clearInterval(u),
                (u = setTimeout(function () {
                  o.trigger("update.dot");
                }, 100)));
            });
          } else
            (c = d(o)),
              (u = setInterval(function () {
                if (o.is(":visible")) {
                  var t = d(o);
                  (c.width == t.width && c.height == t.height) ||
                    (o.trigger("update.dot"), (c = t));
                }
              }, 500));
          return o;
        }),
        (o.unwatch = function () {
          return (
            t(window).unbind("resize.dot" + s.dotId), u && clearInterval(u), o
          );
        });
      var l = t.extend(!0, {}, t.fn.dotdotdot.defaults, e),
        s = {},
        c = {},
        u = null,
        g = null;
      return (
        l.lastCharacter.remove instanceof Array ||
          (l.lastCharacter.remove =
            t.fn.dotdotdot.defaultArrays.lastCharacter.remove),
        l.lastCharacter.noEllipsis instanceof Array ||
          (l.lastCharacter.noEllipsis =
            t.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis),
        (s.afterElement = h(l.after, o)),
        (s.isTruncated = !1),
        (s.dotId = p++),
        o.data("dotdotdot", !0).bind_events().trigger("update.dot"),
        l.watch && o.watch(),
        o
      );
    }),
      (t.fn.dotdotdot.defaults = {
        ellipsis: "... ",
        wrap: "word",
        fallbackToLetter: !0,
        lastCharacter: {},
        tolerance: 0,
        callback: null,
        after: null,
        height: null,
        watch: !1,
        windowResizeFix: !0,
      }),
      (t.fn.dotdotdot.defaultArrays = {
        lastCharacter: {
          remove: [" ", "　", ",", ";", ".", "!", "?"],
          noEllipsis: [],
        },
      }),
      (t.fn.dotdotdot.debug = function (t) {});
    var p = 1,
      g = t.fn.html;
    t.fn.html = function (n) {
      return n != e && !t.isFunction(n) && this.data("dotdotdot")
        ? this.trigger("update", [n])
        : g.apply(this, arguments);
    };
    var v = t.fn.text;
    t.fn.text = function (n) {
      return n != e && !t.isFunction(n) && this.data("dotdotdot")
        ? ((n = t("<div />").text(n).html()), this.trigger("update", [n]))
        : v.apply(this, arguments);
    };
  }
})(jQuery),
  jQuery(document).ready(function (t) {
    t(".dot-ellipsis").each(function () {
      var e = t(this).hasClass("dot-resize-update"),
        n = t(this).hasClass("dot-timer-update"),
        r = 0,
        o = t(this).attr("class").split(/\s+/);
      t.each(o, function (t, e) {
        var n = e.match(/^dot-height-(\d+)$/);
        null !== n && (r = Number(n[1]));
      });
      var a = new Object();
      n && (a.watch = !0),
        e && (a.watch = "window"),
        r > 0 && (a.height = r),
        t(this).dotdotdot(a);
    });
  }),
  jQuery(window).on("load", function () {
    jQuery(".dot-ellipsis.dot-load-update").trigger("update.dot");
  });

/*! Copyright (c) 2013 Brandon Aaron (http://brandon.aaron.sh)
 * Licensed under the MIT License (LICENSE.txt).
 * Version: 3.1.11
 * Requires: jQuery 1.2.2+
 */
!(function (a) {
  "function" == typeof define && define.amd
    ? define(["jquery"], a)
    : "object" == typeof exports
    ? (module.exports = a)
    : a(jQuery);
})(function (a) {
  function b(b) {
    var g = b || window.event,
      h = i.call(arguments, 1),
      j = 0,
      l = 0,
      m = 0,
      n = 0,
      o = 0,
      p = 0;
    if (
      ((b = a.event.fix(g)),
      (b.type = "mousewheel"),
      "detail" in g && (m = -1 * g.detail),
      "wheelDelta" in g && (m = g.wheelDelta),
      "wheelDeltaY" in g && (m = g.wheelDeltaY),
      "wheelDeltaX" in g && (l = -1 * g.wheelDeltaX),
      "axis" in g && g.axis === g.HORIZONTAL_AXIS && ((l = -1 * m), (m = 0)),
      (j = 0 === m ? l : m),
      "deltaY" in g && ((m = -1 * g.deltaY), (j = m)),
      "deltaX" in g && ((l = g.deltaX), 0 === m && (j = -1 * l)),
      0 !== m || 0 !== l)
    ) {
      if (1 === g.deltaMode) {
        var q = a.data(this, "mousewheel-line-height");
        (j *= q), (m *= q), (l *= q);
      } else if (2 === g.deltaMode) {
        var r = a.data(this, "mousewheel-page-height");
        (j *= r), (m *= r), (l *= r);
      }
      if (
        ((n = Math.max(Math.abs(m), Math.abs(l))),
        (!f || f > n) && ((f = n), d(g, n) && (f /= 40)),
        d(g, n) && ((j /= 40), (l /= 40), (m /= 40)),
        (j = Math[j >= 1 ? "floor" : "ceil"](j / f)),
        (l = Math[l >= 1 ? "floor" : "ceil"](l / f)),
        (m = Math[m >= 1 ? "floor" : "ceil"](m / f)),
        k.settings.normalizeOffset && this.getBoundingClientRect)
      ) {
        var s = this.getBoundingClientRect();
        (o = b.clientX - s.left), (p = b.clientY - s.top);
      }
      return (
        (b.deltaX = l),
        (b.deltaY = m),
        (b.deltaFactor = f),
        (b.offsetX = o),
        (b.offsetY = p),
        (b.deltaMode = 0),
        h.unshift(b, j, l, m),
        e && clearTimeout(e),
        (e = setTimeout(c, 200)),
        (a.event.dispatch || a.event.handle).apply(this, h)
      );
    }
  }
  function c() {
    f = null;
  }
  function d(a, b) {
    return (
      k.settings.adjustOldDeltas && "mousewheel" === a.type && b % 120 === 0
    );
  }
  var e,
    f,
    g = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"],
    h =
      "onwheel" in document || document.documentMode >= 9
        ? ["wheel"]
        : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
    i = Array.prototype.slice;
  if (a.event.fixHooks)
    for (var j = g.length; j; ) a.event.fixHooks[g[--j]] = a.event.mouseHooks;
  var k = (a.event.special.mousewheel = {
    version: "3.1.11",
    setup: function () {
      if (this.addEventListener)
        for (var c = h.length; c; ) this.addEventListener(h[--c], b, !1);
      else this.onmousewheel = b;
      a.data(this, "mousewheel-line-height", k.getLineHeight(this)),
        a.data(this, "mousewheel-page-height", k.getPageHeight(this));
    },
    teardown: function () {
      if (this.removeEventListener)
        for (var c = h.length; c; ) this.removeEventListener(h[--c], b, !1);
      else this.onmousewheel = null;
      a.removeData(this, "mousewheel-line-height"),
        a.removeData(this, "mousewheel-page-height");
    },
    getLineHeight: function (b) {
      var c = a(b)["offsetParent" in a.fn ? "offsetParent" : "parent"]();
      return c.length || (c = a("body")), parseInt(c.css("fontSize"), 10);
    },
    getPageHeight: function (b) {
      return a(b).height();
    },
    settings: { adjustOldDeltas: !0, normalizeOffset: !0 },
  });
  a.fn.extend({
    mousewheel: function (a) {
      return a ? this.bind("mousewheel", a) : this.trigger("mousewheel");
    },
    unmousewheel: function (a) {
      return this.unbind("mousewheel", a);
    },
  });
});

/*! fancyBox v2.1.5 fancyapps.com | fancyapps.com/fancybox/#license */
(function (r, G, f, v) {
  var J = f("html"),
    n = f(r),
    p = f(G),
    b = (f.fancybox = function () {
      b.open.apply(this, arguments);
    }),
    I = navigator.userAgent.match(/msie/i),
    B = null,
    s = G.createTouch !== v,
    t = function (a) {
      return a && a.hasOwnProperty && a instanceof f;
    },
    q = function (a) {
      return a && "string" === f.type(a);
    },
    E = function (a) {
      return q(a) && 0 < a.indexOf("%");
    },
    l = function (a, d) {
      var e = parseInt(a, 10) || 0;
      d && E(a) && (e *= b.getViewport()[d] / 100);
      return Math.ceil(e);
    },
    w = function (a, b) {
      return l(a, b) + "px";
    };
  f.extend(b, {
    version: "2.1.5",
    defaults: {
      padding: 15,
      margin: 20,
      width: 800,
      height: 600,
      minWidth: 100,
      minHeight: 100,
      maxWidth: 9999,
      maxHeight: 9999,
      pixelRatio: 1,
      autoSize: !0,
      autoHeight: !1,
      autoWidth: !1,
      autoResize: !0,
      autoCenter: !s,
      fitToView: !0,
      aspectRatio: !1,
      topRatio: 0.5,
      leftRatio: 0.5,
      scrolling: "auto",
      wrapCSS: "",
      arrows: !0,
      closeBtn: !0,
      closeClick: !1,
      nextClick: !1,
      mouseWheel: !0,
      autoPlay: !1,
      playSpeed: 3e3,
      preload: 3,
      modal: !1,
      loop: !0,
      ajax: { dataType: "html", headers: { "X-fancyBox": !0 } },
      iframe: { scrolling: "auto", preload: !0 },
      swf: {
        wmode: "transparent",
        allowfullscreen: "true",
        allowscriptaccess: "always",
      },
      keys: {
        next: { 13: "left", 34: "up", 39: "left", 40: "up" },
        prev: { 8: "right", 33: "down", 37: "right", 38: "down" },
        close: [27],
        play: [32],
        toggle: [70],
      },
      direction: { next: "left", prev: "right" },
      scrollOutside: !0,
      index: 0,
      type: null,
      href: null,
      content: null,
      title: null,
      tpl: {
        wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
        image: '<img class="fancybox-image" src="{href}" alt="" />',
        iframe:
          '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' +
          (I ? ' allowtransparency="true"' : "") +
          "></iframe>",
        error:
          '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
        closeBtn:
          '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
        next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
        prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
      },
      openEffect: "fade",
      openSpeed: 250,
      openEasing: "swing",
      openOpacity: !0,
      openMethod: "zoomIn",
      closeEffect: "fade",
      closeSpeed: 250,
      closeEasing: "swing",
      closeOpacity: !0,
      closeMethod: "zoomOut",
      nextEffect: "elastic",
      nextSpeed: 250,
      nextEasing: "swing",
      nextMethod: "changeIn",
      prevEffect: "elastic",
      prevSpeed: 250,
      prevEasing: "swing",
      prevMethod: "changeOut",
      helpers: { overlay: !0, title: !0 },
      onCancel: f.noop,
      beforeLoad: f.noop,
      afterLoad: f.noop,
      beforeShow: f.noop,
      afterShow: f.noop,
      beforeChange: f.noop,
      beforeClose: f.noop,
      afterClose: f.noop,
    },
    group: {},
    opts: {},
    previous: null,
    coming: null,
    current: null,
    isActive: !1,
    isOpen: !1,
    isOpened: !1,
    wrap: null,
    skin: null,
    outer: null,
    inner: null,
    player: { timer: null, isActive: !1 },
    ajaxLoad: null,
    imgPreload: null,
    transitions: {},
    helpers: {},
    open: function (a, d) {
      if (a && (f.isPlainObject(d) || (d = {}), !1 !== b.close(!0)))
        return (
          f.isArray(a) || (a = t(a) ? f(a).get() : [a]),
          f.each(a, function (e, c) {
            var k = {},
              g,
              h,
              j,
              m,
              l;
            "object" === f.type(c) &&
              (c.nodeType && (c = f(c)),
              t(c)
                ? ((k = {
                    href: c.data("fancybox-href") || c.attr("href"),
                    title: c.data("fancybox-title") || c.attr("title"),
                    isDom: !0,
                    element: c,
                  }),
                  f.metadata && f.extend(!0, k, c.metadata()))
                : (k = c));
            g = d.href || k.href || (q(c) ? c : null);
            h = d.title !== v ? d.title : k.title || "";
            m = (j = d.content || k.content) ? "html" : d.type || k.type;
            !m &&
              k.isDom &&
              ((m = c.data("fancybox-type")),
              m ||
                (m = (m = c.prop("class").match(/fancybox\.(\w+)/))
                  ? m[1]
                  : null));
            q(g) &&
              (m ||
                (b.isImage(g)
                  ? (m = "image")
                  : b.isSWF(g)
                  ? (m = "swf")
                  : "#" === g.charAt(0)
                  ? (m = "inline")
                  : q(c) && ((m = "html"), (j = c))),
              "ajax" === m &&
                ((l = g.split(/\s+/, 2)), (g = l.shift()), (l = l.shift())));
            j ||
              ("inline" === m
                ? g
                  ? (j = f(q(g) ? g.replace(/.*(?=#[^\s]+$)/, "") : g))
                  : k.isDom && (j = c)
                : "html" === m
                ? (j = g)
                : !m && !g && k.isDom && ((m = "inline"), (j = c)));
            f.extend(k, {
              href: g,
              type: m,
              content: j,
              title: h,
              selector: l,
            });
            a[e] = k;
          }),
          (b.opts = f.extend(!0, {}, b.defaults, d)),
          d.keys !== v &&
            (b.opts.keys = d.keys ? f.extend({}, b.defaults.keys, d.keys) : !1),
          (b.group = a),
          b._start(b.opts.index)
        );
    },
    cancel: function () {
      var a = b.coming;
      a &&
        !1 !== b.trigger("onCancel") &&
        (b.hideLoading(),
        b.ajaxLoad && b.ajaxLoad.abort(),
        (b.ajaxLoad = null),
        b.imgPreload && (b.imgPreload.onload = b.imgPreload.onerror = null),
        a.wrap && a.wrap.stop(!0, !0).trigger("onReset").remove(),
        (b.coming = null),
        b.current || b._afterZoomOut(a));
    },
    close: function (a) {
      b.cancel();
      !1 !== b.trigger("beforeClose") &&
        (b.unbindEvents(),
        b.isActive &&
          (!b.isOpen || !0 === a
            ? (f(".fancybox-wrap").stop(!0).trigger("onReset").remove(),
              b._afterZoomOut())
            : ((b.isOpen = b.isOpened = !1),
              (b.isClosing = !0),
              f(".fancybox-item, .fancybox-nav").remove(),
              b.wrap.stop(!0, !0).removeClass("fancybox-opened"),
              b.transitions[b.current.closeMethod]())));
    },
    play: function (a) {
      var d = function () {
          clearTimeout(b.player.timer);
        },
        e = function () {
          d();
          b.current &&
            b.player.isActive &&
            (b.player.timer = setTimeout(b.next, b.current.playSpeed));
        },
        c = function () {
          d();
          p.unbind(".player");
          b.player.isActive = !1;
          b.trigger("onPlayEnd");
        };
      if (!0 === a || (!b.player.isActive && !1 !== a)) {
        if (
          b.current &&
          (b.current.loop || b.current.index < b.group.length - 1)
        )
          (b.player.isActive = !0),
            p.bind({
              "onCancel.player beforeClose.player": c,
              "onUpdate.player": e,
              "beforeLoad.player": d,
            }),
            e(),
            b.trigger("onPlayStart");
      } else c();
    },
    next: function (a) {
      var d = b.current;
      d && (q(a) || (a = d.direction.next), b.jumpto(d.index + 1, a, "next"));
    },
    prev: function (a) {
      var d = b.current;
      d && (q(a) || (a = d.direction.prev), b.jumpto(d.index - 1, a, "prev"));
    },
    jumpto: function (a, d, e) {
      var c = b.current;
      c &&
        ((a = l(a)),
        (b.direction = d || c.direction[a >= c.index ? "next" : "prev"]),
        (b.router = e || "jumpto"),
        c.loop &&
          (0 > a && (a = c.group.length + (a % c.group.length)),
          (a %= c.group.length)),
        c.group[a] !== v && (b.cancel(), b._start(a)));
    },
    reposition: function (a, d) {
      var e = b.current,
        c = e ? e.wrap : null,
        k;
      c &&
        ((k = b._getPosition(d)),
        a && "scroll" === a.type
          ? (delete k.position, c.stop(!0, !0).animate(k, 200))
          : (c.css(k), (e.pos = f.extend({}, e.dim, k))));
    },
    update: function (a) {
      var d = a && a.type,
        e = !d || "orientationchange" === d;
      e && (clearTimeout(B), (B = null));
      b.isOpen &&
        !B &&
        (B = setTimeout(
          function () {
            var c = b.current;
            c &&
              !b.isClosing &&
              (b.wrap.removeClass("fancybox-tmp"),
              (e || "load" === d || ("resize" === d && c.autoResize)) &&
                b._setDimension(),
              ("scroll" === d && c.canShrink) || b.reposition(a),
              b.trigger("onUpdate"),
              (B = null));
          },
          e && !s ? 0 : 300
        ));
    },
    toggle: function (a) {
      b.isOpen &&
        ((b.current.fitToView =
          "boolean" === f.type(a) ? a : !b.current.fitToView),
        s &&
          (b.wrap.removeAttr("style").addClass("fancybox-tmp"),
          b.trigger("onUpdate")),
        b.update());
    },
    hideLoading: function () {
      p.unbind(".loading");
      f("#fancybox-loading").remove();
    },
    showLoading: function () {
      var a, d;
      b.hideLoading();
      a = f('<div id="fancybox-loading"><div></div></div>')
        .click(b.cancel)
        .appendTo("body");
      p.bind("keydown.loading", function (a) {
        if (27 === (a.which || a.keyCode)) a.preventDefault(), b.cancel();
      });
      b.defaults.fixed ||
        ((d = b.getViewport()),
        a.css({
          position: "absolute",
          top: 0.5 * d.h + d.y,
          left: 0.5 * d.w + d.x,
        }));
    },
    getViewport: function () {
      var a = (b.current && b.current.locked) || !1,
        d = { x: n.scrollLeft(), y: n.scrollTop() };
      a
        ? ((d.w = a[0].clientWidth), (d.h = a[0].clientHeight))
        : ((d.w = s && r.innerWidth ? r.innerWidth : n.width()),
          (d.h = s && r.innerHeight ? r.innerHeight : n.height()));
      return d;
    },
    unbindEvents: function () {
      b.wrap && t(b.wrap) && b.wrap.unbind(".fb");
      p.unbind(".fb");
      n.unbind(".fb");
    },
    bindEvents: function () {
      var a = b.current,
        d;
      a &&
        (n.bind(
          "orientationchange.fb" +
            (s ? "" : " resize.fb") +
            (a.autoCenter && !a.locked ? " scroll.fb" : ""),
          b.update
        ),
        (d = a.keys) &&
          p.bind("keydown.fb", function (e) {
            var c = e.which || e.keyCode,
              k = e.target || e.srcElement;
            if (27 === c && b.coming) return !1;
            !e.ctrlKey &&
              !e.altKey &&
              !e.shiftKey &&
              !e.metaKey &&
              (!k || (!k.type && !f(k).is("[contenteditable]"))) &&
              f.each(d, function (d, k) {
                if (1 < a.group.length && k[c] !== v)
                  return b[d](k[c]), e.preventDefault(), !1;
                if (-1 < f.inArray(c, k)) return b[d](), e.preventDefault(), !1;
              });
          }),
        f.fn.mousewheel &&
          a.mouseWheel &&
          b.wrap.bind("mousewheel.fb", function (d, c, k, g) {
            for (
              var h = f(d.target || null), j = !1;
              h.length &&
              !j &&
              !h.is(".fancybox-skin") &&
              !h.is(".fancybox-wrap");

            )
              (j =
                h[0] &&
                !(h[0].style.overflow && "hidden" === h[0].style.overflow) &&
                ((h[0].clientWidth && h[0].scrollWidth > h[0].clientWidth) ||
                  (h[0].clientHeight &&
                    h[0].scrollHeight > h[0].clientHeight))),
                (h = f(h).parent());
            if (0 !== c && !j && 1 < b.group.length && !a.canShrink) {
              if (0 < g || 0 < k) b.prev(0 < g ? "down" : "left");
              else if (0 > g || 0 > k) b.next(0 > g ? "up" : "right");
              d.preventDefault();
            }
          }));
    },
    trigger: function (a, d) {
      var e,
        c = d || b.coming || b.current;
      if (c) {
        f.isFunction(c[a]) &&
          (e = c[a].apply(c, Array.prototype.slice.call(arguments, 1)));
        if (!1 === e) return !1;
        c.helpers &&
          f.each(c.helpers, function (d, e) {
            if (e && b.helpers[d] && f.isFunction(b.helpers[d][a]))
              b.helpers[d][a](f.extend(!0, {}, b.helpers[d].defaults, e), c);
          });
        p.trigger(a);
      }
    },
    isImage: function (a) {
      return (
        q(a) &&
        a.match(
          /(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i
        )
      );
    },
    isSWF: function (a) {
      return q(a) && a.match(/\.(swf)((\?|#).*)?$/i);
    },
    _start: function (a) {
      var d = {},
        e,
        c;
      a = l(a);
      e = b.group[a] || null;
      if (!e) return !1;
      d = f.extend(!0, {}, b.opts, e);
      e = d.margin;
      c = d.padding;
      "number" === f.type(e) && (d.margin = [e, e, e, e]);
      "number" === f.type(c) && (d.padding = [c, c, c, c]);
      d.modal &&
        f.extend(!0, d, {
          closeBtn: !1,
          closeClick: !1,
          nextClick: !1,
          arrows: !1,
          mouseWheel: !1,
          keys: null,
          helpers: { overlay: { closeClick: !1 } },
        });
      d.autoSize && (d.autoWidth = d.autoHeight = !0);
      "auto" === d.width && (d.autoWidth = !0);
      "auto" === d.height && (d.autoHeight = !0);
      d.group = b.group;
      d.index = a;
      b.coming = d;
      if (!1 === b.trigger("beforeLoad")) b.coming = null;
      else {
        c = d.type;
        e = d.href;
        if (!c)
          return (
            (b.coming = null),
            b.current && b.router && "jumpto" !== b.router
              ? ((b.current.index = a), b[b.router](b.direction))
              : !1
          );
        b.isActive = !0;
        if ("image" === c || "swf" === c)
          (d.autoHeight = d.autoWidth = !1), (d.scrolling = "visible");
        "image" === c && (d.aspectRatio = !0);
        "iframe" === c && s && (d.scrolling = "scroll");
        d.wrap = f(d.tpl.wrap)
          .addClass(
            "fancybox-" +
              (s ? "mobile" : "desktop") +
              " fancybox-type-" +
              c +
              " fancybox-tmp " +
              d.wrapCSS
          )
          .appendTo(d.parent || "body");
        f.extend(d, {
          skin: f(".fancybox-skin", d.wrap),
          outer: f(".fancybox-outer", d.wrap),
          inner: f(".fancybox-inner", d.wrap),
        });
        f.each(["Top", "Right", "Bottom", "Left"], function (a, b) {
          d.skin.css("padding" + b, w(d.padding[a]));
        });
        b.trigger("onReady");
        if ("inline" === c || "html" === c) {
          if (!d.content || !d.content.length) return b._error("content");
        } else if (!e) return b._error("href");
        "image" === c
          ? b._loadImage()
          : "ajax" === c
          ? b._loadAjax()
          : "iframe" === c
          ? b._loadIframe()
          : b._afterLoad();
      }
    },
    _error: function (a) {
      f.extend(b.coming, {
        type: "html",
        autoWidth: !0,
        autoHeight: !0,
        minWidth: 0,
        minHeight: 0,
        scrolling: "no",
        hasError: a,
        content: b.coming.tpl.error,
      });
      b._afterLoad();
    },
    _loadImage: function () {
      var a = (b.imgPreload = new Image());
      a.onload = function () {
        this.onload = this.onerror = null;
        b.coming.width = this.width / b.opts.pixelRatio;
        b.coming.height = this.height / b.opts.pixelRatio;
        b._afterLoad();
      };
      a.onerror = function () {
        this.onload = this.onerror = null;
        b._error("image");
      };
      a.src = b.coming.href;
      !0 !== a.complete && b.showLoading();
    },
    _loadAjax: function () {
      var a = b.coming;
      b.showLoading();
      b.ajaxLoad = f.ajax(
        f.extend({}, a.ajax, {
          url: a.href,
          error: function (a, e) {
            b.coming && "abort" !== e ? b._error("ajax", a) : b.hideLoading();
          },
          success: function (d, e) {
            "success" === e && ((a.content = d), b._afterLoad());
          },
        })
      );
    },
    _loadIframe: function () {
      var a = b.coming,
        d = f(a.tpl.iframe.replace(/\{rnd\}/g, new Date().getTime()))
          .attr("scrolling", s ? "auto" : a.iframe.scrolling)
          .attr("src", a.href);
      f(a.wrap).bind("onReset", function () {
        try {
          f(this)
            .find("iframe")
            .hide()
            .attr("src", "//about:blank")
            .end()
            .empty();
        } catch (a) {}
      });
      a.iframe.preload &&
        (b.showLoading(),
        d.one("load", function () {
          f(this).data("ready", 1);
          s || f(this).bind("load.fb", b.update);
          f(this)
            .parents(".fancybox-wrap")
            .width("100%")
            .removeClass("fancybox-tmp")
            .show();
          b._afterLoad();
        }));
      a.content = d.appendTo(a.inner);
      a.iframe.preload || b._afterLoad();
    },
    _preloadImages: function () {
      var a = b.group,
        d = b.current,
        e = a.length,
        c = d.preload ? Math.min(d.preload, e - 1) : 0,
        f,
        g;
      for (g = 1; g <= c; g += 1)
        (f = a[(d.index + g) % e]),
          "image" === f.type && f.href && (new Image().src = f.href);
    },
    _afterLoad: function () {
      var a = b.coming,
        d = b.current,
        e,
        c,
        k,
        g,
        h;
      b.hideLoading();
      if (a && !1 !== b.isActive)
        if (!1 === b.trigger("afterLoad", a, d))
          a.wrap.stop(!0).trigger("onReset").remove(), (b.coming = null);
        else {
          d &&
            (b.trigger("beforeChange", d),
            d.wrap
              .stop(!0)
              .removeClass("fancybox-opened")
              .find(".fancybox-item, .fancybox-nav")
              .remove());
          b.unbindEvents();
          e = a.content;
          c = a.type;
          k = a.scrolling;
          f.extend(b, {
            wrap: a.wrap,
            skin: a.skin,
            outer: a.outer,
            inner: a.inner,
            current: a,
            previous: d,
          });
          g = a.href;
          switch (c) {
            case "inline":
            case "ajax":
            case "html":
              a.selector
                ? (e = f("<div>").html(e).find(a.selector))
                : t(e) &&
                  (e.data("fancybox-placeholder") ||
                    e.data(
                      "fancybox-placeholder",
                      f('<div class="fancybox-placeholder"></div>')
                        .insertAfter(e)
                        .hide()
                    ),
                  (e = e.show().detach()),
                  a.wrap.bind("onReset", function () {
                    f(this).find(e).length &&
                      e
                        .hide()
                        .replaceAll(e.data("fancybox-placeholder"))
                        .data("fancybox-placeholder", !1);
                  }));
              break;
            case "image":
              e = a.tpl.image.replace("{href}", g);
              break;
            case "swf":
              (e =
                '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' +
                g +
                '"></param>'),
                (h = ""),
                f.each(a.swf, function (a, b) {
                  e += '<param name="' + a + '" value="' + b + '"></param>';
                  h += " " + a + '="' + b + '"';
                }),
                (e +=
                  '<embed src="' +
                  g +
                  '" type="application/x-shockwave-flash" width="100%" height="100%"' +
                  h +
                  "></embed></object>");
          }
          (!t(e) || !e.parent().is(a.inner)) && a.inner.append(e);
          b.trigger("beforeShow");
          a.inner.css(
            "overflow",
            "yes" === k ? "scroll" : "no" === k ? "hidden" : k
          );
          b._setDimension();
          b.reposition();
          b.isOpen = !1;
          b.coming = null;
          b.bindEvents();
          if (b.isOpened) {
            if (d.prevMethod) b.transitions[d.prevMethod]();
          } else
            f(".fancybox-wrap")
              .not(a.wrap)
              .stop(!0)
              .trigger("onReset")
              .remove();
          b.transitions[b.isOpened ? a.nextMethod : a.openMethod]();
          b._preloadImages();
        }
    },
    _setDimension: function () {
      var a = b.getViewport(),
        d = 0,
        e = !1,
        c = !1,
        e = b.wrap,
        k = b.skin,
        g = b.inner,
        h = b.current,
        c = h.width,
        j = h.height,
        m = h.minWidth,
        u = h.minHeight,
        n = h.maxWidth,
        p = h.maxHeight,
        s = h.scrolling,
        q = h.scrollOutside ? h.scrollbarWidth : 0,
        x = h.margin,
        y = l(x[1] + x[3]),
        r = l(x[0] + x[2]),
        v,
        z,
        t,
        C,
        A,
        F,
        B,
        D,
        H;
      e.add(k).add(g).width("auto").height("auto").removeClass("fancybox-tmp");
      x = l(k.outerWidth(!0) - k.width());
      v = l(k.outerHeight(!0) - k.height());
      z = y + x;
      t = r + v;
      C = E(c) ? ((a.w - z) * l(c)) / 100 : c;
      A = E(j) ? ((a.h - t) * l(j)) / 100 : j;
      if ("iframe" === h.type) {
        if (((H = h.content), h.autoHeight && 1 === H.data("ready")))
          try {
            H[0].contentWindow.document.location &&
              (g.width(C).height(9999),
              (F = H.contents().find("body")),
              q && F.css("overflow-x", "hidden"),
              (A = F.outerHeight(!0)));
          } catch (G) {}
      } else if (h.autoWidth || h.autoHeight)
        g.addClass("fancybox-tmp"),
          h.autoWidth || g.width(C),
          h.autoHeight || g.height(A),
          h.autoWidth && (C = g.width()),
          h.autoHeight && (A = g.height()),
          g.removeClass("fancybox-tmp");
      c = l(C);
      j = l(A);
      D = C / A;
      m = l(E(m) ? l(m, "w") - z : m);
      n = l(E(n) ? l(n, "w") - z : n);
      u = l(E(u) ? l(u, "h") - t : u);
      p = l(E(p) ? l(p, "h") - t : p);
      F = n;
      B = p;
      h.fitToView && ((n = Math.min(a.w - z, n)), (p = Math.min(a.h - t, p)));
      z = a.w - y;
      r = a.h - r;
      h.aspectRatio
        ? (c > n && ((c = n), (j = l(c / D))),
          j > p && ((j = p), (c = l(j * D))),
          c < m && ((c = m), (j = l(c / D))),
          j < u && ((j = u), (c = l(j * D))))
        : ((c = Math.max(m, Math.min(c, n))),
          h.autoHeight && "iframe" !== h.type && (g.width(c), (j = g.height())),
          (j = Math.max(u, Math.min(j, p))));
      if (h.fitToView)
        if (
          (g.width(c).height(j),
          e.width(c + x),
          (a = e.width()),
          (y = e.height()),
          h.aspectRatio)
        )
          for (; (a > z || y > r) && c > m && j > u && !(19 < d++); )
            (j = Math.max(u, Math.min(p, j - 10))),
              (c = l(j * D)),
              c < m && ((c = m), (j = l(c / D))),
              c > n && ((c = n), (j = l(c / D))),
              g.width(c).height(j),
              e.width(c + x),
              (a = e.width()),
              (y = e.height());
        else
          (c = Math.max(m, Math.min(c, c - (a - z)))),
            (j = Math.max(u, Math.min(j, j - (y - r))));
      q && "auto" === s && j < A && c + x + q < z && (c += q);
      g.width(c).height(j);
      e.width(c + x);
      a = e.width();
      y = e.height();
      e = (a > z || y > r) && c > m && j > u;
      c = h.aspectRatio
        ? c < F && j < B && c < C && j < A
        : (c < F || j < B) && (c < C || j < A);
      f.extend(h, {
        dim: { width: w(a), height: w(y) },
        origWidth: C,
        origHeight: A,
        canShrink: e,
        canExpand: c,
        wPadding: x,
        hPadding: v,
        wrapSpace: y - k.outerHeight(!0),
        skinSpace: k.height() - j,
      });
      !H && h.autoHeight && j > u && j < p && !c && g.height("auto");
    },
    _getPosition: function (a) {
      var d = b.current,
        e = b.getViewport(),
        c = d.margin,
        f = b.wrap.width() + c[1] + c[3],
        g = b.wrap.height() + c[0] + c[2],
        c = { position: "absolute", top: c[0], left: c[3] };
      d.autoCenter && d.fixed && !a && g <= e.h && f <= e.w
        ? (c.position = "fixed")
        : d.locked || ((c.top += e.y), (c.left += e.x));
      c.top = w(Math.max(c.top, c.top + (e.h - g) * d.topRatio));
      c.left = w(Math.max(c.left, c.left + (e.w - f) * d.leftRatio));
      return c;
    },
    _afterZoomIn: function () {
      var a = b.current;
      a &&
        ((b.isOpen = b.isOpened = !0),
        b.wrap.css("overflow", "visible").addClass("fancybox-opened"),
        b.update(),
        (a.closeClick || (a.nextClick && 1 < b.group.length)) &&
          b.inner.css("cursor", "pointer").bind("click.fb", function (d) {
            !f(d.target).is("a") &&
              !f(d.target).parent().is("a") &&
              (d.preventDefault(), b[a.closeClick ? "close" : "next"]());
          }),
        a.closeBtn &&
          f(a.tpl.closeBtn)
            .appendTo(b.skin)
            .bind("click.fb", function (a) {
              a.preventDefault();
              b.close();
            }),
        a.arrows &&
          1 < b.group.length &&
          ((a.loop || 0 < a.index) &&
            f(a.tpl.prev).appendTo(b.outer).bind("click.fb", b.prev),
          (a.loop || a.index < b.group.length - 1) &&
            f(a.tpl.next).appendTo(b.outer).bind("click.fb", b.next)),
        b.trigger("afterShow"),
        !a.loop && a.index === a.group.length - 1
          ? b.play(!1)
          : b.opts.autoPlay &&
            !b.player.isActive &&
            ((b.opts.autoPlay = !1), b.play()));
    },
    _afterZoomOut: function (a) {
      a = a || b.current;
      f(".fancybox-wrap").trigger("onReset").remove();
      f.extend(b, {
        group: {},
        opts: {},
        router: !1,
        current: null,
        isActive: !1,
        isOpened: !1,
        isOpen: !1,
        isClosing: !1,
        wrap: null,
        skin: null,
        outer: null,
        inner: null,
      });
      b.trigger("afterClose", a);
    },
  });
  b.transitions = {
    getOrigPosition: function () {
      var a = b.current,
        d = a.element,
        e = a.orig,
        c = {},
        f = 50,
        g = 50,
        h = a.hPadding,
        j = a.wPadding,
        m = b.getViewport();
      !e &&
        a.isDom &&
        d.is(":visible") &&
        ((e = d.find("img:first")), e.length || (e = d));
      t(e)
        ? ((c = e.offset()),
          e.is("img") && ((f = e.outerWidth()), (g = e.outerHeight())))
        : ((c.top = m.y + (m.h - g) * a.topRatio),
          (c.left = m.x + (m.w - f) * a.leftRatio));
      if ("fixed" === b.wrap.css("position") || a.locked)
        (c.top -= m.y), (c.left -= m.x);
      return (c = {
        top: w(c.top - h * a.topRatio),
        left: w(c.left - j * a.leftRatio),
        width: w(f + j),
        height: w(g + h),
      });
    },
    step: function (a, d) {
      var e,
        c,
        f = d.prop;
      c = b.current;
      var g = c.wrapSpace,
        h = c.skinSpace;
      if ("width" === f || "height" === f)
        (e = d.end === d.start ? 1 : (a - d.start) / (d.end - d.start)),
          b.isClosing && (e = 1 - e),
          (c = "width" === f ? c.wPadding : c.hPadding),
          (c = a - c),
          b.skin[f](l("width" === f ? c : c - g * e)),
          b.inner[f](l("width" === f ? c : c - g * e - h * e));
    },
    zoomIn: function () {
      var a = b.current,
        d = a.pos,
        e = a.openEffect,
        c = "elastic" === e,
        k = f.extend({ opacity: 1 }, d);
      delete k.position;
      c
        ? ((d = this.getOrigPosition()), a.openOpacity && (d.opacity = 0.1))
        : "fade" === e && (d.opacity = 0.1);
      b.wrap.css(d).animate(k, {
        duration: "none" === e ? 0 : a.openSpeed,
        easing: a.openEasing,
        step: c ? this.step : null,
        complete: b._afterZoomIn,
      });
    },
    zoomOut: function () {
      var a = b.current,
        d = a.closeEffect,
        e = "elastic" === d,
        c = { opacity: 0.1 };
      e && ((c = this.getOrigPosition()), a.closeOpacity && (c.opacity = 0.1));
      b.wrap.animate(c, {
        duration: "none" === d ? 0 : a.closeSpeed,
        easing: a.closeEasing,
        step: e ? this.step : null,
        complete: b._afterZoomOut,
      });
    },
    changeIn: function () {
      var a = b.current,
        d = a.nextEffect,
        e = a.pos,
        c = { opacity: 1 },
        f = b.direction,
        g;
      e.opacity = 0.1;
      "elastic" === d &&
        ((g = "down" === f || "up" === f ? "top" : "left"),
        "down" === f || "right" === f
          ? ((e[g] = w(l(e[g]) - 200)), (c[g] = "+=200px"))
          : ((e[g] = w(l(e[g]) + 200)), (c[g] = "-=200px")));
      "none" === d
        ? b._afterZoomIn()
        : b.wrap.css(e).animate(c, {
            duration: a.nextSpeed,
            easing: a.nextEasing,
            complete: b._afterZoomIn,
          });
    },
    changeOut: function () {
      var a = b.previous,
        d = a.prevEffect,
        e = { opacity: 0.1 },
        c = b.direction;
      "elastic" === d &&
        (e["down" === c || "up" === c ? "top" : "left"] =
          ("up" === c || "left" === c ? "-" : "+") + "=200px");
      a.wrap.animate(e, {
        duration: "none" === d ? 0 : a.prevSpeed,
        easing: a.prevEasing,
        complete: function () {
          f(this).trigger("onReset").remove();
        },
      });
    },
  };
  b.helpers.overlay = {
    defaults: {
      closeClick: !0,
      speedOut: 200,
      showEarly: !0,
      css: {},
      locked: !s,
      fixed: !0,
    },
    overlay: null,
    fixed: !1,
    el: f("html"),
    create: function (a) {
      a = f.extend({}, this.defaults, a);
      this.overlay && this.close();
      this.overlay = f('<div class="fancybox-overlay"></div>').appendTo(
        b.coming ? b.coming.parent : a.parent
      );
      this.fixed = !1;
      a.fixed &&
        b.defaults.fixed &&
        (this.overlay.addClass("fancybox-overlay-fixed"), (this.fixed = !0));
    },
    open: function (a) {
      var d = this;
      a = f.extend({}, this.defaults, a);
      this.overlay
        ? this.overlay.unbind(".overlay").width("auto").height("auto")
        : this.create(a);
      this.fixed ||
        (n.bind("resize.overlay", f.proxy(this.update, this)), this.update());
      a.closeClick &&
        this.overlay.bind("click.overlay", function (a) {
          if (f(a.target).hasClass("fancybox-overlay"))
            return b.isActive ? b.close() : d.close(), !1;
        });
      this.overlay.css(a.css).show();
    },
    close: function () {
      var a, b;
      n.unbind("resize.overlay");
      this.el.hasClass("fancybox-lock") &&
        (f(".fancybox-margin").removeClass("fancybox-margin"),
        (a = n.scrollTop()),
        (b = n.scrollLeft()),
        this.el.removeClass("fancybox-lock"),
        n.scrollTop(a).scrollLeft(b));
      f(".fancybox-overlay").remove().hide();
      f.extend(this, { overlay: null, fixed: !1 });
    },
    update: function () {
      var a = "100%",
        b;
      this.overlay.width(a).height("100%");
      I
        ? ((b = Math.max(G.documentElement.offsetWidth, G.body.offsetWidth)),
          p.width() > b && (a = p.width()))
        : p.width() > n.width() && (a = p.width());
      this.overlay.width(a).height(p.height());
    },
    onReady: function (a, b) {
      var e = this.overlay;
      f(".fancybox-overlay").stop(!0, !0);
      e || this.create(a);
      a.locked &&
        this.fixed &&
        b.fixed &&
        (e ||
          (this.margin =
            p.height() > n.height()
              ? f("html").css("margin-right").replace("px", "")
              : !1),
        (b.locked = this.overlay.append(b.wrap)),
        (b.fixed = !1));
      !0 === a.showEarly && this.beforeShow.apply(this, arguments);
    },
    beforeShow: function (a, b) {
      var e, c;
      b.locked &&
        (!1 !== this.margin &&
          (f("*")
            .filter(function () {
              return (
                "fixed" === f(this).css("position") &&
                !f(this).hasClass("fancybox-overlay") &&
                !f(this).hasClass("fancybox-wrap")
              );
            })
            .addClass("fancybox-margin"),
          this.el.addClass("fancybox-margin")),
        (e = n.scrollTop()),
        (c = n.scrollLeft()),
        this.el.addClass("fancybox-lock"),
        n.scrollTop(e).scrollLeft(c));
      this.open(a);
    },
    onUpdate: function () {
      this.fixed || this.update();
    },
    afterClose: function (a) {
      this.overlay &&
        !b.coming &&
        this.overlay.fadeOut(a.speedOut, f.proxy(this.close, this));
    },
  };
  b.helpers.title = {
    defaults: { type: "float", position: "bottom" },
    beforeShow: function (a) {
      var d = b.current,
        e = d.title,
        c = a.type;
      f.isFunction(e) && (e = e.call(d.element, d));
      if (q(e) && "" !== f.trim(e)) {
        d = f(
          '<div class="fancybox-title fancybox-title-' +
            c +
            '-wrap">' +
            e +
            "</div>"
        );
        switch (c) {
          case "inside":
            c = b.skin;
            break;
          case "outside":
            c = b.wrap;
            break;
          case "over":
            c = b.inner;
            break;
          default:
            (c = b.skin),
              d.appendTo("body"),
              I && d.width(d.width()),
              d.wrapInner('<span class="child"></span>'),
              (b.current.margin[2] += Math.abs(l(d.css("margin-bottom"))));
        }
        d["top" === a.position ? "prependTo" : "appendTo"](c);
      }
    },
  };
  f.fn.fancybox = function (a) {
    var d,
      e = f(this),
      c = this.selector || "",
      k = function (g) {
        var h = f(this).blur(),
          j = d,
          k,
          l;
        !g.ctrlKey &&
          !g.altKey &&
          !g.shiftKey &&
          !g.metaKey &&
          !h.is(".fancybox-wrap") &&
          ((k = a.groupAttr || "data-fancybox-group"),
          (l = h.attr(k)),
          l || ((k = "rel"), (l = h.get(0)[k])),
          l &&
            "" !== l &&
            "nofollow" !== l &&
            ((h = c.length ? f(c) : e),
            (h = h.filter("[" + k + '="' + l + '"]')),
            (j = h.index(this))),
          (a.index = j),
          !1 !== b.open(h, a) && g.preventDefault());
      };
    a = a || {};
    d = a.index || 0;
    !c || !1 === a.live
      ? e.unbind("click.fb-start").bind("click.fb-start", k)
      : p
          .undelegate(c, "click.fb-start")
          .delegate(
            c + ":not('.fancybox-item, .fancybox-nav')",
            "click.fb-start",
            k
          );
    this.filter("[data-fancybox-start=1]").trigger("click");
    return this;
  };
  p.ready(function () {
    var a, d;
    f.scrollbarWidth === v &&
      (f.scrollbarWidth = function () {
        var a = f(
            '<div style="width:50px;height:50px;overflow:auto"><div/></div>'
          ).appendTo("body"),
          b = a.children(),
          b = b.innerWidth() - b.height(99).innerWidth();
        a.remove();
        return b;
      });
    if (f.support.fixedPosition === v) {
      a = f.support;
      d = f('<div style="position:fixed;top:20px;"></div>').appendTo("body");
      var e = 20 === d[0].offsetTop || 15 === d[0].offsetTop;
      d.remove();
      a.fixedPosition = e;
    }
    f.extend(b.defaults, {
      scrollbarWidth: f.scrollbarWidth(),
      fixed: f.support.fixedPosition,
      parent: f("body"),
    });
    a = f(r).width();
    J.addClass("fancybox-lock-test");
    d = f(r).width();
    J.removeClass("fancybox-lock-test");
    f(
      "<style type='text/css'>.fancybox-margin{margin-right:" +
        (d - a) +
        "px;}</style>"
    ).appendTo("head");
  });
})(window, document, jQuery);

//flexbox polyfill

!(function (e) {
  if ("object" == typeof exports && "undefined" != typeof module)
    module.exports = e();
  else if ("function" == typeof define && define.amd) define([], e);
  else {
    var t;
    (t =
      "undefined" != typeof window
        ? window
        : "undefined" != typeof global
        ? global
        : "undefined" != typeof self
        ? self
        : this),
      (t.flexibility = e());
  }
})(function () {
  return (function e(t, r, l) {
    function n(f, i) {
      if (!r[f]) {
        if (!t[f]) {
          var s = "function" == typeof require && require;
          if (!i && s) return s(f, !0);
          if (o) return o(f, !0);
          var a = new Error("Cannot find module '" + f + "'");
          throw ((a.code = "MODULE_NOT_FOUND"), a);
        }
        var c = (r[f] = { exports: {} });
        t[f][0].call(
          c.exports,
          function (e) {
            var r = t[f][1][e];
            return n(r ? r : e);
          },
          c,
          c.exports,
          e,
          t,
          r,
          l
        );
      }
      return r[f].exports;
    }
    for (
      var o = "function" == typeof require && require, f = 0;
      f < l.length;
      f++
    )
      n(l[f]);
    return n;
  })(
    {
      1: [
        function (e, t, r) {
          t.exports = function (e) {
            var t,
              r,
              l,
              n = -1;
            if (e.lines.length > 1 && "flex-start" === e.style.alignContent)
              for (t = 0; (l = e.lines[++n]); )
                (l.crossStart = t), (t += l.cross);
            else if (e.lines.length > 1 && "flex-end" === e.style.alignContent)
              for (t = e.flexStyle.crossSpace; (l = e.lines[++n]); )
                (l.crossStart = t), (t += l.cross);
            else if (e.lines.length > 1 && "center" === e.style.alignContent)
              for (t = e.flexStyle.crossSpace / 2; (l = e.lines[++n]); )
                (l.crossStart = t), (t += l.cross);
            else if (
              e.lines.length > 1 &&
              "space-between" === e.style.alignContent
            )
              for (
                r = e.flexStyle.crossSpace / (e.lines.length - 1), t = 0;
                (l = e.lines[++n]);

              )
                (l.crossStart = t), (t += l.cross + r);
            else if (
              e.lines.length > 1 &&
              "space-around" === e.style.alignContent
            )
              for (
                r = (2 * e.flexStyle.crossSpace) / (2 * e.lines.length),
                  t = r / 2;
                (l = e.lines[++n]);

              )
                (l.crossStart = t), (t += l.cross + r);
            else
              for (
                r = e.flexStyle.crossSpace / e.lines.length,
                  t = e.flexStyle.crossInnerBefore;
                (l = e.lines[++n]);

              )
                (l.crossStart = t), (l.cross += r), (t += l.cross);
          };
        },
        {},
      ],
      2: [
        function (e, t, r) {
          t.exports = function (e) {
            for (var t, r = -1; (line = e.lines[++r]); )
              for (t = -1; (child = line.children[++t]); ) {
                var l = child.style.alignSelf;
                "auto" === l && (l = e.style.alignItems),
                  "flex-start" === l
                    ? (child.flexStyle.crossStart = line.crossStart)
                    : "flex-end" === l
                    ? (child.flexStyle.crossStart =
                        line.crossStart +
                        line.cross -
                        child.flexStyle.crossOuter)
                    : "center" === l
                    ? (child.flexStyle.crossStart =
                        line.crossStart +
                        (line.cross - child.flexStyle.crossOuter) / 2)
                    : ((child.flexStyle.crossStart = line.crossStart),
                      (child.flexStyle.crossOuter = line.cross),
                      (child.flexStyle.cross =
                        child.flexStyle.crossOuter -
                        child.flexStyle.crossBefore -
                        child.flexStyle.crossAfter));
              }
          };
        },
        {},
      ],
      3: [
        function (e, t, r) {
          t.exports = function l(e, l) {
            var t = "row" === l || "row-reverse" === l,
              r = e.mainAxis;
            if (r) {
              var n = (t && "inline" === r) || (!t && "block" === r);
              n ||
                (e.flexStyle = {
                  main: e.flexStyle.cross,
                  cross: e.flexStyle.main,
                  mainOffset: e.flexStyle.crossOffset,
                  crossOffset: e.flexStyle.mainOffset,
                  mainBefore: e.flexStyle.crossBefore,
                  mainAfter: e.flexStyle.crossAfter,
                  crossBefore: e.flexStyle.mainBefore,
                  crossAfter: e.flexStyle.mainAfter,
                  mainInnerBefore: e.flexStyle.crossInnerBefore,
                  mainInnerAfter: e.flexStyle.crossInnerAfter,
                  crossInnerBefore: e.flexStyle.mainInnerBefore,
                  crossInnerAfter: e.flexStyle.mainInnerAfter,
                  mainBorderBefore: e.flexStyle.crossBorderBefore,
                  mainBorderAfter: e.flexStyle.crossBorderAfter,
                  crossBorderBefore: e.flexStyle.mainBorderBefore,
                  crossBorderAfter: e.flexStyle.mainBorderAfter,
                });
            } else
              t
                ? (e.flexStyle = {
                    main: e.style.width,
                    cross: e.style.height,
                    mainOffset: e.style.offsetWidth,
                    crossOffset: e.style.offsetHeight,
                    mainBefore: e.style.marginLeft,
                    mainAfter: e.style.marginRight,
                    crossBefore: e.style.marginTop,
                    crossAfter: e.style.marginBottom,
                    mainInnerBefore: e.style.paddingLeft,
                    mainInnerAfter: e.style.paddingRight,
                    crossInnerBefore: e.style.paddingTop,
                    crossInnerAfter: e.style.paddingBottom,
                    mainBorderBefore: e.style.borderLeftWidth,
                    mainBorderAfter: e.style.borderRightWidth,
                    crossBorderBefore: e.style.borderTopWidth,
                    crossBorderAfter: e.style.borderBottomWidth,
                  })
                : (e.flexStyle = {
                    main: e.style.height,
                    cross: e.style.width,
                    mainOffset: e.style.offsetHeight,
                    crossOffset: e.style.offsetWidth,
                    mainBefore: e.style.marginTop,
                    mainAfter: e.style.marginBottom,
                    crossBefore: e.style.marginLeft,
                    crossAfter: e.style.marginRight,
                    mainInnerBefore: e.style.paddingTop,
                    mainInnerAfter: e.style.paddingBottom,
                    crossInnerBefore: e.style.paddingLeft,
                    crossInnerAfter: e.style.paddingRight,
                    mainBorderBefore: e.style.borderTopWidth,
                    mainBorderAfter: e.style.borderBottomWidth,
                    crossBorderBefore: e.style.borderLeftWidth,
                    crossBorderAfter: e.style.borderRightWidth,
                  }),
                "content-box" === e.style.boxSizing &&
                  ("number" == typeof e.flexStyle.main &&
                    (e.flexStyle.main +=
                      e.flexStyle.mainInnerBefore +
                      e.flexStyle.mainInnerAfter +
                      e.flexStyle.mainBorderBefore +
                      e.flexStyle.mainBorderAfter),
                  "number" == typeof e.flexStyle.cross &&
                    (e.flexStyle.cross +=
                      e.flexStyle.crossInnerBefore +
                      e.flexStyle.crossInnerAfter +
                      e.flexStyle.crossBorderBefore +
                      e.flexStyle.crossBorderAfter));
            (e.mainAxis = t ? "inline" : "block"),
              (e.crossAxis = t ? "block" : "inline"),
              "number" == typeof e.style.flexBasis &&
                (e.flexStyle.main =
                  e.style.flexBasis +
                  e.flexStyle.mainInnerBefore +
                  e.flexStyle.mainInnerAfter +
                  e.flexStyle.mainBorderBefore +
                  e.flexStyle.mainBorderAfter),
              (e.flexStyle.mainOuter = e.flexStyle.main),
              (e.flexStyle.crossOuter = e.flexStyle.cross),
              "auto" === e.flexStyle.mainOuter &&
                (e.flexStyle.mainOuter = e.flexStyle.mainOffset),
              "auto" === e.flexStyle.crossOuter &&
                (e.flexStyle.crossOuter = e.flexStyle.crossOffset),
              "number" == typeof e.flexStyle.mainBefore &&
                (e.flexStyle.mainOuter += e.flexStyle.mainBefore),
              "number" == typeof e.flexStyle.mainAfter &&
                (e.flexStyle.mainOuter += e.flexStyle.mainAfter),
              "number" == typeof e.flexStyle.crossBefore &&
                (e.flexStyle.crossOuter += e.flexStyle.crossBefore),
              "number" == typeof e.flexStyle.crossAfter &&
                (e.flexStyle.crossOuter += e.flexStyle.crossAfter);
          };
        },
        {},
      ],
      4: [
        function (e, t, r) {
          var l = e("../reduce");
          t.exports = function (e) {
            if (e.mainSpace > 0) {
              var t = l(
                e.children,
                function (e, t) {
                  return e + parseFloat(t.style.flexGrow);
                },
                0
              );
              t > 0 &&
                ((e.main = l(
                  e.children,
                  function (r, l) {
                    return (
                      "auto" === l.flexStyle.main
                        ? (l.flexStyle.main =
                            l.flexStyle.mainOffset +
                            (parseFloat(l.style.flexGrow) / t) * e.mainSpace)
                        : (l.flexStyle.main +=
                            (parseFloat(l.style.flexGrow) / t) * e.mainSpace),
                      (l.flexStyle.mainOuter =
                        l.flexStyle.main +
                        l.flexStyle.mainBefore +
                        l.flexStyle.mainAfter),
                      r + l.flexStyle.mainOuter
                    );
                  },
                  0
                )),
                (e.mainSpace = 0));
            }
          };
        },
        { "../reduce": 12 },
      ],
      5: [
        function (e, t, r) {
          var l = e("../reduce");
          t.exports = function (e) {
            if (e.mainSpace < 0) {
              var t = l(
                e.children,
                function (e, t) {
                  return e + parseFloat(t.style.flexShrink);
                },
                0
              );
              t > 0 &&
                ((e.main = l(
                  e.children,
                  function (r, l) {
                    return (
                      (l.flexStyle.main +=
                        (parseFloat(l.style.flexShrink) / t) * e.mainSpace),
                      (l.flexStyle.mainOuter =
                        l.flexStyle.main +
                        l.flexStyle.mainBefore +
                        l.flexStyle.mainAfter),
                      r + l.flexStyle.mainOuter
                    );
                  },
                  0
                )),
                (e.mainSpace = 0));
            }
          };
        },
        { "../reduce": 12 },
      ],
      6: [
        function (e, t, r) {
          var l = e("../reduce");
          t.exports = function (e) {
            var t;
            e.lines = [(t = { main: 0, cross: 0, children: [] })];
            for (var r, n = -1; (r = e.children[++n]); )
              "nowrap" === e.style.flexWrap ||
              0 === t.children.length ||
              "auto" === e.flexStyle.main ||
              e.flexStyle.main -
                e.flexStyle.mainInnerBefore -
                e.flexStyle.mainInnerAfter -
                e.flexStyle.mainBorderBefore -
                e.flexStyle.mainBorderAfter >=
                t.main + r.flexStyle.mainOuter
                ? ((t.main += r.flexStyle.mainOuter),
                  (t.cross = Math.max(t.cross, r.flexStyle.crossOuter)))
                : e.lines.push(
                    (t = {
                      main: r.flexStyle.mainOuter,
                      cross: r.flexStyle.crossOuter,
                      children: [],
                    })
                  ),
                t.children.push(r);
            (e.flexStyle.mainLines = l(
              e.lines,
              function (e, t) {
                return Math.max(e, t.main);
              },
              0
            )),
              (e.flexStyle.crossLines = l(
                e.lines,
                function (e, t) {
                  return e + t.cross;
                },
                0
              )),
              "auto" === e.flexStyle.main &&
                (e.flexStyle.main = Math.max(
                  e.flexStyle.mainOffset,
                  e.flexStyle.mainLines +
                    e.flexStyle.mainInnerBefore +
                    e.flexStyle.mainInnerAfter +
                    e.flexStyle.mainBorderBefore +
                    e.flexStyle.mainBorderAfter
                )),
              "auto" === e.flexStyle.cross &&
                (e.flexStyle.cross = Math.max(
                  e.flexStyle.crossOffset,
                  e.flexStyle.crossLines +
                    e.flexStyle.crossInnerBefore +
                    e.flexStyle.crossInnerAfter +
                    e.flexStyle.crossBorderBefore +
                    e.flexStyle.crossBorderAfter
                )),
              (e.flexStyle.crossSpace =
                e.flexStyle.cross -
                e.flexStyle.crossInnerBefore -
                e.flexStyle.crossInnerAfter -
                e.flexStyle.crossBorderBefore -
                e.flexStyle.crossBorderAfter -
                e.flexStyle.crossLines),
              (e.flexStyle.mainOuter =
                e.flexStyle.main +
                e.flexStyle.mainBefore +
                e.flexStyle.mainAfter),
              (e.flexStyle.crossOuter =
                e.flexStyle.cross +
                e.flexStyle.crossBefore +
                e.flexStyle.crossAfter);
          };
        },
        { "../reduce": 12 },
      ],
      7: [
        function (e, t, r) {
          function l(t) {
            for (var r, l = -1; (r = t.children[++l]); )
              e("./flex-direction")(r, t.style.flexDirection);
            e("./flex-direction")(t, t.style.flexDirection),
              e("./order")(t),
              e("./flexbox-lines")(t),
              e("./align-content")(t),
              (l = -1);
            for (var n; (n = t.lines[++l]); )
              (n.mainSpace =
                t.flexStyle.main -
                t.flexStyle.mainInnerBefore -
                t.flexStyle.mainInnerAfter -
                t.flexStyle.mainBorderBefore -
                t.flexStyle.mainBorderAfter -
                n.main),
                e("./flex-grow")(n),
                e("./flex-shrink")(n),
                e("./margin-main")(n),
                e("./margin-cross")(n),
                e("./justify-content")(n, t.style.justifyContent, t);
            e("./align-items")(t);
          }
          t.exports = l;
        },
        {
          "./align-content": 1,
          "./align-items": 2,
          "./flex-direction": 3,
          "./flex-grow": 4,
          "./flex-shrink": 5,
          "./flexbox-lines": 6,
          "./justify-content": 8,
          "./margin-cross": 9,
          "./margin-main": 10,
          "./order": 11,
        },
      ],
      8: [
        function (e, t, r) {
          t.exports = function (e, t, r) {
            var l,
              n,
              o,
              f = r.flexStyle.mainInnerBefore,
              i = -1;
            if ("flex-end" === t)
              for (l = e.mainSpace, l += f; (o = e.children[++i]); )
                (o.flexStyle.mainStart = l), (l += o.flexStyle.mainOuter);
            else if ("center" === t)
              for (l = e.mainSpace / 2, l += f; (o = e.children[++i]); )
                (o.flexStyle.mainStart = l), (l += o.flexStyle.mainOuter);
            else if ("space-between" === t)
              for (
                n = e.mainSpace / (e.children.length - 1), l = 0, l += f;
                (o = e.children[++i]);

              )
                (o.flexStyle.mainStart = l), (l += o.flexStyle.mainOuter + n);
            else if ("space-around" === t)
              for (
                n = (2 * e.mainSpace) / (2 * e.children.length),
                  l = n / 2,
                  l += f;
                (o = e.children[++i]);

              )
                (o.flexStyle.mainStart = l), (l += o.flexStyle.mainOuter + n);
            else
              for (l = 0, l += f; (o = e.children[++i]); )
                (o.flexStyle.mainStart = l), (l += o.flexStyle.mainOuter);
          };
        },
        {},
      ],
      9: [
        function (e, t, r) {
          t.exports = function (e) {
            for (var t, r = -1; (t = e.children[++r]); ) {
              var l = 0;
              "auto" === t.flexStyle.crossBefore && ++l,
                "auto" === t.flexStyle.crossAfter && ++l;
              var n = e.cross - t.flexStyle.crossOuter;
              "auto" === t.flexStyle.crossBefore &&
                (t.flexStyle.crossBefore = n / l),
                "auto" === t.flexStyle.crossAfter &&
                  (t.flexStyle.crossAfter = n / l),
                "auto" === t.flexStyle.cross
                  ? (t.flexStyle.crossOuter =
                      t.flexStyle.crossOffset +
                      t.flexStyle.crossBefore +
                      t.flexStyle.crossAfter)
                  : (t.flexStyle.crossOuter =
                      t.flexStyle.cross +
                      t.flexStyle.crossBefore +
                      t.flexStyle.crossAfter);
            }
          };
        },
        {},
      ],
      10: [
        function (e, t, r) {
          t.exports = function (e) {
            for (var t, r = 0, l = -1; (t = e.children[++l]); )
              "auto" === t.flexStyle.mainBefore && ++r,
                "auto" === t.flexStyle.mainAfter && ++r;
            if (r > 0) {
              for (l = -1; (t = e.children[++l]); )
                "auto" === t.flexStyle.mainBefore &&
                  (t.flexStyle.mainBefore = e.mainSpace / r),
                  "auto" === t.flexStyle.mainAfter &&
                    (t.flexStyle.mainAfter = e.mainSpace / r),
                  "auto" === t.flexStyle.main
                    ? (t.flexStyle.mainOuter =
                        t.flexStyle.mainOffset +
                        t.flexStyle.mainBefore +
                        t.flexStyle.mainAfter)
                    : (t.flexStyle.mainOuter =
                        t.flexStyle.main +
                        t.flexStyle.mainBefore +
                        t.flexStyle.mainAfter);
              e.mainSpace = 0;
            }
          };
        },
        {},
      ],
      11: [
        function (e, t, r) {
          var l = /^(column|row)-reverse$/;
          t.exports = function (e) {
            e.children.sort(function (e, t) {
              return e.style.order - t.style.order || e.index - t.index;
            }),
              l.test(e.style.flexDirection) && e.children.reverse();
          };
        },
        {},
      ],
      12: [
        function (e, t, r) {
          function l(e, t, r) {
            for (var l = e.length, n = -1; ++n < l; )
              n in e && (r = t(r, e[n], n));
            return r;
          }
          t.exports = l;
        },
        {},
      ],
      13: [
        function (e, t, r) {
          function l(e) {
            i(f(e));
          }
          var n = e("./read"),
            o = e("./write"),
            f = e("./readAll"),
            i = e("./writeAll");
          (t.exports = l),
            (t.exports.read = n),
            (t.exports.write = o),
            (t.exports.readAll = f),
            (t.exports.writeAll = i);
        },
        { "./read": 15, "./readAll": 16, "./write": 17, "./writeAll": 18 },
      ],
      14: [
        function (e, t, r) {
          function l(e, t, r) {
            var l = e[t],
              f = String(l).match(o);
            if (!f) {
              var a = t.match(s);
              if (a) {
                var c = e["border" + a[1] + "Style"];
                return "none" === c ? 0 : i[l] || 0;
              }
              return l;
            }
            var y = f[1],
              x = f[2];
            return "px" === x
              ? 1 * y
              : "cm" === x
              ? 0.3937 * y * 96
              : "in" === x
              ? 96 * y
              : "mm" === x
              ? (0.3937 * y * 96) / 10
              : "pc" === x
              ? (12 * y * 96) / 72
              : "pt" === x
              ? (96 * y) / 72
              : "rem" === x
              ? 16 * y
              : n(l, r);
          }
          function n(e, t) {
            (f.style.cssText =
              "border:none!important;clip:rect(0 0 0 0)!important;display:block!important;font-size:1em!important;height:0!important;margin:0!important;padding:0!important;position:relative!important;width:" +
              e +
              "!important"),
              t.parentNode.insertBefore(f, t.nextSibling);
            var r = f.offsetWidth;
            return t.parentNode.removeChild(f), r;
          }
          t.exports = l;
          var o = /^([-+]?\d*\.?\d+)(%|[a-z]+)$/,
            f = document.createElement("div"),
            i = { medium: 4, none: 0, thick: 6, thin: 2 },
            s = /^border(Bottom|Left|Right|Top)Width$/;
        },
        {},
      ],
      15: [
        function (e, t, r) {
          function l(e) {
            var t = {
                alignContent: "stretch",
                alignItems: "stretch",
                alignSelf: "auto",
                borderBottomStyle: "none",
                borderBottomWidth: 0,
                borderLeftStyle: "none",
                borderLeftWidth: 0,
                borderRightStyle: "none",
                borderRightWidth: 0,
                borderTopStyle: "none",
                borderTopWidth: 0,
                boxSizing: "content-box",
                display: "inline",
                flexBasis: "auto",
                flexDirection: "row",
                flexGrow: 0,
                flexShrink: 1,
                flexWrap: "nowrap",
                justifyContent: "flex-start",
                height: "auto",
                marginTop: 0,
                marginRight: 0,
                marginLeft: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingRight: 0,
                paddingLeft: 0,
                paddingBottom: 0,
                maxHeight: "none",
                maxWidth: "none",
                minHeight: 0,
                minWidth: 0,
                order: 0,
                position: "static",
                width: "auto",
              },
              r = e instanceof Element;
            if (r) {
              var l = e.hasAttribute("data-style"),
                i = l
                  ? e.getAttribute("data-style")
                  : e.getAttribute("style") || "";
              l || e.setAttribute("data-style", i);
              var s = (window.getComputedStyle && getComputedStyle(e)) || {};
              f(t, s);
              var c = e.currentStyle || {};
              n(t, c), o(t, i);
              for (var y in t) t[y] = a(t, y, e);
              var x = e.getBoundingClientRect();
              (t.offsetHeight = x.height || e.offsetHeight),
                (t.offsetWidth = x.width || e.offsetWidth);
            }
            var S = { element: e, style: t };
            return S;
          }
          function n(e, t) {
            for (var r in e) {
              var l = r in t;
              if (l) e[r] = t[r];
              else {
                var n = r.replace(/[A-Z]/g, "-$&").toLowerCase(),
                  o = n in t;
                o && (e[r] = t[n]);
              }
            }
            var f = "-js-display" in t;
            f && (e.display = t["-js-display"]);
          }
          function o(e, t) {
            for (var r; (r = i.exec(t)); ) {
              var l = r[1].toLowerCase().replace(/-[a-z]/g, function (e) {
                return e.slice(1).toUpperCase();
              });
              e[l] = r[2];
            }
          }
          function f(e, t) {
            for (var r in e) {
              var l = r in t;
              l && !s.test(r) && (e[r] = t[r]);
            }
          }
          t.exports = l;
          var i = /([^\s:;]+)\s*:\s*([^;]+?)\s*(;|$)/g,
            s = /^(alignSelf|height|width)$/,
            a = e("./getComputedLength");
        },
        { "./getComputedLength": 14 },
      ],
      16: [
        function (e, t, r) {
          function l(e) {
            var t = [];
            return n(e, t), t;
          }
          function n(e, t) {
            for (var r, l = o(e), i = [], s = -1; (r = e.childNodes[++s]); ) {
              var a = 3 === r.nodeType && !/^\s*$/.test(r.nodeValue);
              if (l && a) {
                var c = r;
                (r = e.insertBefore(document.createElement("flex-item"), c)),
                  r.appendChild(c);
              }
              var y = r instanceof Element;
              if (y) {
                var x = n(r, t);
                if (l) {
                  var S = r.style;
                  (S.display = "inline-block"),
                    (S.position = "absolute"),
                    (x.style = f(r).style),
                    i.push(x);
                }
              }
            }
            var m = { element: e, children: i };
            return l && ((m.style = f(e).style), t.push(m)), m;
          }
          function o(e) {
            var t = e instanceof Element,
              r = t && e.getAttribute("data-style"),
              l = t && e.currentStyle && e.currentStyle["-js-display"],
              n = i.test(r) || s.test(l);
            return n;
          }
          t.exports = l;
          var f = e("../read"),
            i = /(^|;)\s*display\s*:\s*(inline-)?flex\s*(;|$)/i,
            s = /^(inline-)?flex$/i;
        },
        { "../read": 15 },
      ],
      17: [
        function (e, t, r) {
          function l(e) {
            o(e);
            var t = e.element.style,
              r =
                "inline" === e.mainAxis ? ["main", "cross"] : ["cross", "main"];
            (t.boxSizing = "content-box"),
              (t.display = "block"),
              (t.position = "relative"),
              (t.width = n(
                e.flexStyle[r[0]] -
                  e.flexStyle[r[0] + "InnerBefore"] -
                  e.flexStyle[r[0] + "InnerAfter"] -
                  e.flexStyle[r[0] + "BorderBefore"] -
                  e.flexStyle[r[0] + "BorderAfter"]
              )),
              (t.height = n(
                e.flexStyle[r[1]] -
                  e.flexStyle[r[1] + "InnerBefore"] -
                  e.flexStyle[r[1] + "InnerAfter"] -
                  e.flexStyle[r[1] + "BorderBefore"] -
                  e.flexStyle[r[1] + "BorderAfter"]
              ));
            for (var l, f = -1; (l = e.children[++f]); ) {
              var i = l.element.style,
                s =
                  "inline" === l.mainAxis
                    ? ["main", "cross"]
                    : ["cross", "main"];
              (i.boxSizing = "content-box"),
                (i.display = "block"),
                (i.position = "absolute"),
                "auto" !== l.flexStyle[s[0]] &&
                  (i.width = n(
                    l.flexStyle[s[0]] -
                      l.flexStyle[s[0] + "InnerBefore"] -
                      l.flexStyle[s[0] + "InnerAfter"] -
                      l.flexStyle[s[0] + "BorderBefore"] -
                      l.flexStyle[s[0] + "BorderAfter"]
                  )),
                "auto" !== l.flexStyle[s[1]] &&
                  (i.height = n(
                    l.flexStyle[s[1]] -
                      l.flexStyle[s[1] + "InnerBefore"] -
                      l.flexStyle[s[1] + "InnerAfter"] -
                      l.flexStyle[s[1] + "BorderBefore"] -
                      l.flexStyle[s[1] + "BorderAfter"]
                  )),
                (i.top = n(l.flexStyle[s[1] + "Start"])),
                (i.left = n(l.flexStyle[s[0] + "Start"])),
                (i.marginTop = n(l.flexStyle[s[1] + "Before"])),
                (i.marginRight = n(l.flexStyle[s[0] + "After"])),
                (i.marginBottom = n(l.flexStyle[s[1] + "After"])),
                (i.marginLeft = n(l.flexStyle[s[0] + "Before"]));
            }
          }
          function n(e) {
            return "string" == typeof e ? e : Math.max(e, 0) + "px";
          }
          t.exports = l;
          var o = e("../flexbox");
        },
        { "../flexbox": 7 },
      ],
      18: [
        function (e, t, r) {
          function l(e) {
            for (var t, r = -1; (t = e[++r]); ) n(t);
          }
          t.exports = l;
          var n = e("../write");
        },
        { "../write": 17 },
      ],
    },
    {},
    [13]
  )(13);
});

/*! tooltipster v4.1.4 */ !(function (a, b) {
  "function" == typeof define && define.amd
    ? define(["jquery"], function (a) {
        return b(a);
      })
    : "object" == typeof exports
    ? (module.exports = b(require("jquery")))
    : b(jQuery);
})(this, function (a) {
  function b(a) {
    this.$container, (this.constraints = null), this.__$tooltip, this.__init(a);
  }
  function c(b, c) {
    var d = !0;
    return (
      a.each(b, function (a, e) {
        return void 0 === c[a] || b[a] !== c[a] ? ((d = !1), !1) : void 0;
      }),
      d
    );
  }
  function d(b) {
    var c = b.attr("id"),
      d = c ? h.window.document.getElementById(c) : null;
    return d ? d === b[0] : a.contains(h.window.document.body, b[0]);
  }
  function e() {
    if (!g) return !1;
    var a = g.document.body || g.document.documentElement,
      b = a.style,
      c = "transition",
      d = ["Moz", "Webkit", "Khtml", "O", "ms"];
    if ("string" == typeof b[c]) return !0;
    c = c.charAt(0).toUpperCase() + c.substr(1);
    for (var e = 0; e < d.length; e++)
      if ("string" == typeof b[d[e] + c]) return !0;
    return !1;
  }
  var f = {
      animation: "fade",
      animationDuration: 350,
      content: null,
      contentAsHTML: !1,
      contentCloning: !1,
      debug: !0,
      delay: 300,
      delayTouch: [300, 500],
      functionInit: null,
      functionBefore: null,
      functionReady: null,
      functionAfter: null,
      functionFormat: null,
      IEmin: 6,
      interactive: !1,
      multiple: !1,
      parent: "body",
      plugins: ["sideTip"],
      repositionOnScroll: !1,
      restoration: "none",
      selfDestruction: !0,
      theme: [],
      timer: 0,
      trackerInterval: 500,
      trackOrigin: !1,
      trackTooltip: !1,
      trigger: "hover",
      triggerClose: {
        click: !1,
        mouseleave: !1,
        originClick: !1,
        scroll: !1,
        tap: !1,
        touchleave: !1,
      },
      triggerOpen: { click: !1, mouseenter: !1, tap: !1, touchstart: !1 },
      updateAnimation: "rotate",
      zIndex: 9999999,
    },
    g = "undefined" != typeof window ? window : null,
    h = {
      hasTouchCapability: !(
        !g ||
        !(
          "ontouchstart" in g ||
          (g.DocumentTouch && g.document instanceof g.DocumentTouch) ||
          g.navigator.maxTouchPoints
        )
      ),
      hasTransitions: e(),
      IE: !1,
      semVer: "4.1.4",
      window: g,
    },
    i = function () {
      (this.__$emitterPrivate = a({})),
        (this.__$emitterPublic = a({})),
        (this.__instancesLatestArr = []),
        (this.__plugins = {}),
        (this._env = h);
    };
  (i.prototype = {
    __bridge: function (b, c, d) {
      if (!c[d]) {
        var e = function () {};
        e.prototype = b;
        var g = new e();
        g.__init && g.__init(c),
          a.each(b, function (a, b) {
            0 != a.indexOf("__") &&
              (c[a]
                ? f.debug &&
                  console.log(
                    "The " +
                      a +
                      " method of the " +
                      d +
                      " plugin conflicts with another plugin or native methods"
                  )
                : ((c[a] = function () {
                    return g[a].apply(
                      g,
                      Array.prototype.slice.apply(arguments)
                    );
                  }),
                  (c[a].bridged = g)));
          }),
          (c[d] = g);
      }
      return this;
    },
    __setWindow: function (a) {
      return (h.window = a), this;
    },
    _getRuler: function (a) {
      return new b(a);
    },
    _off: function () {
      return (
        this.__$emitterPrivate.off.apply(
          this.__$emitterPrivate,
          Array.prototype.slice.apply(arguments)
        ),
        this
      );
    },
    _on: function () {
      return (
        this.__$emitterPrivate.on.apply(
          this.__$emitterPrivate,
          Array.prototype.slice.apply(arguments)
        ),
        this
      );
    },
    _one: function () {
      return (
        this.__$emitterPrivate.one.apply(
          this.__$emitterPrivate,
          Array.prototype.slice.apply(arguments)
        ),
        this
      );
    },
    _plugin: function (b) {
      var c = this;
      if ("string" == typeof b) {
        var d = b,
          e = null;
        return (
          d.indexOf(".") > 0
            ? (e = c.__plugins[d])
            : a.each(c.__plugins, function (a, b) {
                return b.name.substring(b.name.length - d.length - 1) == "." + d
                  ? ((e = b), !1)
                  : void 0;
              }),
          e
        );
      }
      if (b.name.indexOf(".") < 0)
        throw new Error("Plugins must be namespaced");
      return (
        (c.__plugins[b.name] = b), b.core && c.__bridge(b.core, c, b.name), this
      );
    },
    _trigger: function () {
      var a = Array.prototype.slice.apply(arguments);
      return (
        "string" == typeof a[0] && (a[0] = { type: a[0] }),
        this.__$emitterPrivate.trigger.apply(this.__$emitterPrivate, a),
        this.__$emitterPublic.trigger.apply(this.__$emitterPublic, a),
        this
      );
    },
    instances: function (b) {
      var c = [],
        d = b || ".tooltipstered";
      return (
        a(d).each(function () {
          var b = a(this),
            d = b.data("tooltipster-ns");
          d &&
            a.each(d, function (a, d) {
              c.push(b.data(d));
            });
        }),
        c
      );
    },
    instancesLatest: function () {
      return this.__instancesLatestArr;
    },
    off: function () {
      return (
        this.__$emitterPublic.off.apply(
          this.__$emitterPublic,
          Array.prototype.slice.apply(arguments)
        ),
        this
      );
    },
    on: function () {
      return (
        this.__$emitterPublic.on.apply(
          this.__$emitterPublic,
          Array.prototype.slice.apply(arguments)
        ),
        this
      );
    },
    one: function () {
      return (
        this.__$emitterPublic.one.apply(
          this.__$emitterPublic,
          Array.prototype.slice.apply(arguments)
        ),
        this
      );
    },
    origins: function (b) {
      var c = b ? b + " " : "";
      return a(c + ".tooltipstered").toArray();
    },
    setDefaults: function (b) {
      return a.extend(f, b), this;
    },
    triggerHandler: function () {
      return (
        this.__$emitterPublic.triggerHandler.apply(
          this.__$emitterPublic,
          Array.prototype.slice.apply(arguments)
        ),
        this
      );
    },
  }),
    (a.tooltipster = new i()),
    (a.Tooltipster = function (b, c) {
      (this.__callbacks = { close: [], open: [] }),
        this.__closingTime,
        this.__Content,
        this.__contentBcr,
        (this.__destroyed = !1),
        (this.__destroying = !1),
        (this.__$emitterPrivate = a({})),
        (this.__$emitterPublic = a({})),
        (this.__enabled = !0),
        this.__garbageCollector,
        this.__Geometry,
        this.__lastPosition,
        (this.__namespace = "tooltipster-" + Math.round(1e6 * Math.random())),
        this.__options,
        this.__$originParents,
        (this.__pointerIsOverOrigin = !1),
        (this.__previousThemes = []),
        (this.__state = "closed"),
        (this.__timeouts = { close: [], open: null }),
        (this.__touchEvents = []),
        (this.__tracker = null),
        this._$origin,
        this._$tooltip,
        this.__init(b, c);
    }),
    (a.Tooltipster.prototype = {
      __init: function (b, c) {
        var d = this;
        if (
          ((d._$origin = a(b)),
          (d.__options = a.extend(!0, {}, f, c)),
          d.__optionsFormat(),
          !h.IE || h.IE >= d.__options.IEmin)
        ) {
          var e = null;
          if (
            (void 0 === d._$origin.data("tooltipster-initialTitle") &&
              ((e = d._$origin.attr("title")),
              void 0 === e && (e = null),
              d._$origin.data("tooltipster-initialTitle", e)),
            null !== d.__options.content)
          )
            d.__contentSet(d.__options.content);
          else {
            var g,
              i = d._$origin.attr("data-tooltip-content");
            i && (g = a(i)),
              g && g[0] ? d.__contentSet(g.first()) : d.__contentSet(e);
          }
          d._$origin.removeAttr("title").addClass("tooltipstered"),
            d.__prepareOrigin(),
            d.__prepareGC(),
            a.each(d.__options.plugins, function (a, b) {
              d._plug(b);
            }),
            h.hasTouchCapability &&
              a("body").on(
                "touchmove." + d.__namespace + "-triggerOpen",
                function (a) {
                  d._touchRecordEvent(a);
                }
              ),
            d
              ._on("created", function () {
                d.__prepareTooltip();
              })
              ._on("repositioned", function (a) {
                d.__lastPosition = a.position;
              });
        } else d.__options.disabled = !0;
      },
      __contentInsert: function () {
        var a = this,
          b = a._$tooltip.find(".tooltipster-content"),
          c = a.__Content,
          d = function (a) {
            c = a;
          };
        return (
          a._trigger({ type: "format", content: a.__Content, format: d }),
          a.__options.functionFormat &&
            (c = a.__options.functionFormat.call(
              a,
              a,
              { origin: a._$origin[0] },
              a.__Content
            )),
          "string" != typeof c || a.__options.contentAsHTML
            ? b.empty().append(c)
            : b.text(c),
          a
        );
      },
      __contentSet: function (b) {
        return (
          b instanceof a && this.__options.contentCloning && (b = b.clone(!0)),
          (this.__Content = b),
          this._trigger({ type: "updated", content: b }),
          this
        );
      },
      __destroyError: function () {
        throw new Error(
          "This tooltip has been destroyed and cannot execute your method call."
        );
      },
      __geometry: function () {
        var b = this,
          c = b._$origin,
          d = b._$origin.is("area");
        if (d) {
          var e = b._$origin.parent().attr("name");
          c = a('img[usemap="#' + e + '"]');
        }
        var f = c[0].getBoundingClientRect(),
          g = a(h.window.document),
          i = a(h.window),
          j = c,
          k = {
            available: { document: null, window: null },
            document: { size: { height: g.height(), width: g.width() } },
            window: {
              scroll: {
                left:
                  h.window.scrollX ||
                  h.window.document.documentElement.scrollLeft,
                top:
                  h.window.scrollY ||
                  h.window.document.documentElement.scrollTop,
              },
              size: { height: i.height(), width: i.width() },
            },
            origin: {
              fixedLineage: !1,
              offset: {},
              size: { height: f.bottom - f.top, width: f.right - f.left },
              usemapImage: d ? c[0] : null,
              windowOffset: {
                bottom: f.bottom,
                left: f.left,
                right: f.right,
                top: f.top,
              },
            },
          };
        if (d) {
          var l = b._$origin.attr("shape"),
            m = b._$origin.attr("coords");
          if (
            (m &&
              ((m = m.split(",")),
              a.map(m, function (a, b) {
                m[b] = parseInt(a);
              })),
            "default" != l)
          )
            switch (l) {
              case "circle":
                var n = m[0],
                  o = m[1],
                  p = m[2],
                  q = o - p,
                  r = n - p;
                (k.origin.size.height = 2 * p),
                  (k.origin.size.width = k.origin.size.height),
                  (k.origin.windowOffset.left += r),
                  (k.origin.windowOffset.top += q);
                break;
              case "rect":
                var s = m[0],
                  t = m[1],
                  u = m[2],
                  v = m[3];
                (k.origin.size.height = v - t),
                  (k.origin.size.width = u - s),
                  (k.origin.windowOffset.left += s),
                  (k.origin.windowOffset.top += t);
                break;
              case "poly":
                for (
                  var w = 0, x = 0, y = 0, z = 0, A = "even", B = 0;
                  B < m.length;
                  B++
                ) {
                  var C = m[B];
                  "even" == A
                    ? (C > y && ((y = C), 0 === B && (w = y)),
                      w > C && (w = C),
                      (A = "odd"))
                    : (C > z && ((z = C), 1 == B && (x = z)),
                      x > C && (x = C),
                      (A = "even"));
                }
                (k.origin.size.height = z - x),
                  (k.origin.size.width = y - w),
                  (k.origin.windowOffset.left += w),
                  (k.origin.windowOffset.top += x);
            }
        }
        var D = function (a) {
          (k.origin.size.height = a.height),
            (k.origin.windowOffset.left = a.left),
            (k.origin.windowOffset.top = a.top),
            (k.origin.size.width = a.width);
        };
        for (
          b._trigger({
            type: "geometry",
            edit: D,
            geometry: {
              height: k.origin.size.height,
              left: k.origin.windowOffset.left,
              top: k.origin.windowOffset.top,
              width: k.origin.size.width,
            },
          }),
            k.origin.windowOffset.right =
              k.origin.windowOffset.left + k.origin.size.width,
            k.origin.windowOffset.bottom =
              k.origin.windowOffset.top + k.origin.size.height,
            k.origin.offset.left =
              k.origin.windowOffset.left + k.window.scroll.left,
            k.origin.offset.top =
              k.origin.windowOffset.top + k.window.scroll.top,
            k.origin.offset.bottom = k.origin.offset.top + k.origin.size.height,
            k.origin.offset.right = k.origin.offset.left + k.origin.size.width,
            k.available.document = {
              bottom: {
                height: k.document.size.height - k.origin.offset.bottom,
                width: k.document.size.width,
              },
              left: {
                height: k.document.size.height,
                width: k.origin.offset.left,
              },
              right: {
                height: k.document.size.height,
                width: k.document.size.width - k.origin.offset.right,
              },
              top: {
                height: k.origin.offset.top,
                width: k.document.size.width,
              },
            },
            k.available.window = {
              bottom: {
                height: Math.max(
                  k.window.size.height -
                    Math.max(k.origin.windowOffset.bottom, 0),
                  0
                ),
                width: k.window.size.width,
              },
              left: {
                height: k.window.size.height,
                width: Math.max(k.origin.windowOffset.left, 0),
              },
              right: {
                height: k.window.size.height,
                width: Math.max(
                  k.window.size.width -
                    Math.max(k.origin.windowOffset.right, 0),
                  0
                ),
              },
              top: {
                height: Math.max(k.origin.windowOffset.top, 0),
                width: k.window.size.width,
              },
            };
          "html" != j[0].tagName.toLowerCase();

        ) {
          if ("fixed" == j.css("position")) {
            k.origin.fixedLineage = !0;
            break;
          }
          j = j.parent();
        }
        return k;
      },
      __optionsFormat: function () {
        return (
          "number" == typeof this.__options.animationDuration &&
            (this.__options.animationDuration = [
              this.__options.animationDuration,
              this.__options.animationDuration,
            ]),
          "number" == typeof this.__options.delay &&
            (this.__options.delay = [
              this.__options.delay,
              this.__options.delay,
            ]),
          "number" == typeof this.__options.delayTouch &&
            (this.__options.delayTouch = [
              this.__options.delayTouch,
              this.__options.delayTouch,
            ]),
          "string" == typeof this.__options.theme &&
            (this.__options.theme = [this.__options.theme]),
          "string" == typeof this.__options.parent &&
            (this.__options.parent = a(this.__options.parent)),
          "hover" == this.__options.trigger
            ? ((this.__options.triggerOpen = {
                mouseenter: !0,
                touchstart: !0,
              }),
              (this.__options.triggerClose = {
                mouseleave: !0,
                originClick: !0,
                touchleave: !0,
              }))
            : "click" == this.__options.trigger &&
              ((this.__options.triggerOpen = { click: !0, tap: !0 }),
              (this.__options.triggerClose = { click: !0, tap: !0 })),
          this._trigger("options"),
          this
        );
      },
      __prepareGC: function () {
        var b = this;
        return (
          b.__options.selfDestruction
            ? (b.__garbageCollector = setInterval(function () {
                var c = new Date().getTime();
                (b.__touchEvents = a.grep(b.__touchEvents, function (a, b) {
                  return c - a.time > 6e4;
                })),
                  d(b._$origin) || b.destroy();
              }, 2e4))
            : clearInterval(b.__garbageCollector),
          b
        );
      },
      __prepareOrigin: function () {
        var a = this;
        if (
          (a._$origin.off("." + a.__namespace + "-triggerOpen"),
          h.hasTouchCapability &&
            a._$origin.on(
              "touchstart." +
                a.__namespace +
                "-triggerOpen touchend." +
                a.__namespace +
                "-triggerOpen touchcancel." +
                a.__namespace +
                "-triggerOpen",
              function (b) {
                a._touchRecordEvent(b);
              }
            ),
          a.__options.triggerOpen.click ||
            (a.__options.triggerOpen.tap && h.hasTouchCapability))
        ) {
          var b = "";
          a.__options.triggerOpen.click &&
            (b += "click." + a.__namespace + "-triggerOpen "),
            a.__options.triggerOpen.tap &&
              h.hasTouchCapability &&
              (b += "touchend." + a.__namespace + "-triggerOpen"),
            a._$origin.on(b, function (b) {
              a._touchIsMeaningfulEvent(b) && a._open(b);
            });
        }
        if (
          a.__options.triggerOpen.mouseenter ||
          (a.__options.triggerOpen.touchstart && h.hasTouchCapability)
        ) {
          var b = "";
          a.__options.triggerOpen.mouseenter &&
            (b += "mouseenter." + a.__namespace + "-triggerOpen "),
            a.__options.triggerOpen.touchstart &&
              h.hasTouchCapability &&
              (b += "touchstart." + a.__namespace + "-triggerOpen"),
            a._$origin.on(b, function (b) {
              (!a._touchIsTouchEvent(b) && a._touchIsEmulatedEvent(b)) ||
                ((a.__pointerIsOverOrigin = !0), a._openShortly(b));
            });
        }
        if (
          a.__options.triggerClose.mouseleave ||
          (a.__options.triggerClose.touchleave && h.hasTouchCapability)
        ) {
          var b = "";
          a.__options.triggerClose.mouseleave &&
            (b += "mouseleave." + a.__namespace + "-triggerOpen "),
            a.__options.triggerClose.touchleave &&
              h.hasTouchCapability &&
              (b +=
                "touchend." +
                a.__namespace +
                "-triggerOpen touchcancel." +
                a.__namespace +
                "-triggerOpen"),
            a._$origin.on(b, function (b) {
              a._touchIsMeaningfulEvent(b) && (a.__pointerIsOverOrigin = !1);
            });
        }
        return a;
      },
      __prepareTooltip: function () {
        var b = this,
          c = b.__options.interactive ? "auto" : "";
        return (
          b._$tooltip
            .attr("id", b.__namespace)
            .css({ "pointer-events": c, zIndex: b.__options.zIndex }),
          a.each(b.__previousThemes, function (a, c) {
            b._$tooltip.removeClass(c);
          }),
          a.each(b.__options.theme, function (a, c) {
            b._$tooltip.addClass(c);
          }),
          (b.__previousThemes = a.merge([], b.__options.theme)),
          b
        );
      },
      __scrollHandler: function (b) {
        var c = this;
        if (c.__options.triggerClose.scroll) c._close(b);
        else {
          if (b.target === h.window.document)
            c.__Geometry.origin.fixedLineage ||
              (c.__options.repositionOnScroll && c.reposition(b));
          else {
            var d = c.__geometry(),
              e = !1;
            if (
              ("fixed" != c._$origin.css("position") &&
                c.__$originParents.each(function (b, c) {
                  var f = a(c),
                    g = f.css("overflow-x"),
                    h = f.css("overflow-y");
                  if ("visible" != g || "visible" != h) {
                    var i = c.getBoundingClientRect();
                    if (
                      "visible" != g &&
                      (d.origin.windowOffset.left < i.left ||
                        d.origin.windowOffset.right > i.right)
                    )
                      return (e = !0), !1;
                    if (
                      "visible" != h &&
                      (d.origin.windowOffset.top < i.top ||
                        d.origin.windowOffset.bottom > i.bottom)
                    )
                      return (e = !0), !1;
                  }
                  return "fixed" == f.css("position") ? !1 : void 0;
                }),
              e)
            )
              c._$tooltip.css("visibility", "hidden");
            else if (
              (c._$tooltip.css("visibility", "visible"),
              c.__options.repositionOnScroll)
            )
              c.reposition(b);
            else {
              var f = d.origin.offset.left - c.__Geometry.origin.offset.left,
                g = d.origin.offset.top - c.__Geometry.origin.offset.top;
              c._$tooltip.css({
                left: c.__lastPosition.coord.left + f,
                top: c.__lastPosition.coord.top + g,
              });
            }
          }
          c._trigger({ type: "scroll", event: b });
        }
        return c;
      },
      __stateSet: function (a) {
        return (
          (this.__state = a), this._trigger({ type: "state", state: a }), this
        );
      },
      __timeoutsClear: function () {
        return (
          clearTimeout(this.__timeouts.open),
          (this.__timeouts.open = null),
          a.each(this.__timeouts.close, function (a, b) {
            clearTimeout(b);
          }),
          (this.__timeouts.close = []),
          this
        );
      },
      __trackerStart: function () {
        var a = this,
          b = a._$tooltip.find(".tooltipster-content");
        return (
          a.__options.trackTooltip &&
            (a.__contentBcr = b[0].getBoundingClientRect()),
          (a.__tracker = setInterval(function () {
            if (d(a._$origin) && d(a._$tooltip)) {
              if (a.__options.trackOrigin) {
                var e = a.__geometry(),
                  f = !1;
                c(e.origin.size, a.__Geometry.origin.size) &&
                  (a.__Geometry.origin.fixedLineage
                    ? c(
                        e.origin.windowOffset,
                        a.__Geometry.origin.windowOffset
                      ) && (f = !0)
                    : c(e.origin.offset, a.__Geometry.origin.offset) &&
                      (f = !0)),
                  f ||
                    (a.__options.triggerClose.mouseleave
                      ? a._close()
                      : a.reposition());
              }
              if (a.__options.trackTooltip) {
                var g = b[0].getBoundingClientRect();
                (g.height === a.__contentBcr.height &&
                  g.width === a.__contentBcr.width) ||
                  (a.reposition(), (a.__contentBcr = g));
              }
            } else a._close();
          }, a.__options.trackerInterval)),
          a
        );
      },
      _close: function (b, c) {
        var d = this,
          e = !0;
        if (
          (d._trigger({
            type: "close",
            event: b,
            stop: function () {
              e = !1;
            },
          }),
          e || d.__destroying)
        ) {
          c && d.__callbacks.close.push(c),
            (d.__callbacks.open = []),
            d.__timeoutsClear();
          var f = function () {
            a.each(d.__callbacks.close, function (a, c) {
              c.call(d, d, { event: b, origin: d._$origin[0] });
            }),
              (d.__callbacks.close = []);
          };
          if ("closed" != d.__state) {
            var g = !0,
              i = new Date(),
              j = i.getTime(),
              k = j + d.__options.animationDuration[1];
            if (
              ("disappearing" == d.__state && k > d.__closingTime && (g = !1),
              g)
            ) {
              (d.__closingTime = k),
                "disappearing" != d.__state && d.__stateSet("disappearing");
              var l = function () {
                clearInterval(d.__tracker),
                  d._trigger({ type: "closing", event: b }),
                  d._$tooltip
                    .off("." + d.__namespace + "-triggerClose")
                    .removeClass("tooltipster-dying"),
                  a(h.window).off("." + d.__namespace + "-triggerClose"),
                  d.__$originParents.each(function (b, c) {
                    a(c).off("scroll." + d.__namespace + "-triggerClose");
                  }),
                  (d.__$originParents = null),
                  a("body").off("." + d.__namespace + "-triggerClose"),
                  d._$origin.off("." + d.__namespace + "-triggerClose"),
                  d._off("dismissable"),
                  d.__stateSet("closed"),
                  d._trigger({ type: "after", event: b }),
                  d.__options.functionAfter &&
                    d.__options.functionAfter.call(d, d, {
                      event: b,
                      origin: d._$origin[0],
                    }),
                  f();
              };
              h.hasTransitions
                ? (d._$tooltip.css({
                    "-moz-animation-duration":
                      d.__options.animationDuration[1] + "ms",
                    "-ms-animation-duration":
                      d.__options.animationDuration[1] + "ms",
                    "-o-animation-duration":
                      d.__options.animationDuration[1] + "ms",
                    "-webkit-animation-duration":
                      d.__options.animationDuration[1] + "ms",
                    "animation-duration":
                      d.__options.animationDuration[1] + "ms",
                    "transition-duration":
                      d.__options.animationDuration[1] + "ms",
                  }),
                  d._$tooltip
                    .clearQueue()
                    .removeClass("tooltipster-show")
                    .addClass("tooltipster-dying"),
                  d.__options.animationDuration[1] > 0 &&
                    d._$tooltip.delay(d.__options.animationDuration[1]),
                  d._$tooltip.queue(l))
                : d._$tooltip
                    .stop()
                    .fadeOut(d.__options.animationDuration[1], l);
            }
          } else f();
        }
        return d;
      },
      _off: function () {
        return (
          this.__$emitterPrivate.off.apply(
            this.__$emitterPrivate,
            Array.prototype.slice.apply(arguments)
          ),
          this
        );
      },
      _on: function () {
        return (
          this.__$emitterPrivate.on.apply(
            this.__$emitterPrivate,
            Array.prototype.slice.apply(arguments)
          ),
          this
        );
      },
      _one: function () {
        return (
          this.__$emitterPrivate.one.apply(
            this.__$emitterPrivate,
            Array.prototype.slice.apply(arguments)
          ),
          this
        );
      },
      _open: function (b, c) {
        var e = this;
        if (!e.__destroying && d(e._$origin) && e.__enabled) {
          var f = !0;
          if (
            ("closed" == e.__state &&
              (e._trigger({
                type: "before",
                event: b,
                stop: function () {
                  f = !1;
                },
              }),
              f &&
                e.__options.functionBefore &&
                (f = e.__options.functionBefore.call(e, e, {
                  event: b,
                  origin: e._$origin[0],
                }))),
            f !== !1 && null !== e.__Content)
          ) {
            c && e.__callbacks.open.push(c),
              (e.__callbacks.close = []),
              e.__timeoutsClear();
            var g,
              i = function () {
                "stable" != e.__state && e.__stateSet("stable"),
                  a.each(e.__callbacks.open, function (a, b) {
                    b.call(e, e, {
                      origin: e._$origin[0],
                      tooltip: e._$tooltip[0],
                    });
                  }),
                  (e.__callbacks.open = []);
              };
            if ("closed" !== e.__state)
              (g = 0),
                "disappearing" === e.__state
                  ? (e.__stateSet("appearing"),
                    h.hasTransitions
                      ? (e._$tooltip
                          .clearQueue()
                          .removeClass("tooltipster-dying")
                          .addClass("tooltipster-show"),
                        e.__options.animationDuration[0] > 0 &&
                          e._$tooltip.delay(e.__options.animationDuration[0]),
                        e._$tooltip.queue(i))
                      : e._$tooltip.stop().fadeIn(i))
                  : "stable" == e.__state && i();
            else {
              if (
                (e.__stateSet("appearing"),
                (g = e.__options.animationDuration[0]),
                e.__contentInsert(),
                e.reposition(b, !0),
                h.hasTransitions
                  ? (e._$tooltip
                      .addClass("tooltipster-" + e.__options.animation)
                      .addClass("tooltipster-initial")
                      .css({
                        "-moz-animation-duration":
                          e.__options.animationDuration[0] + "ms",
                        "-ms-animation-duration":
                          e.__options.animationDuration[0] + "ms",
                        "-o-animation-duration":
                          e.__options.animationDuration[0] + "ms",
                        "-webkit-animation-duration":
                          e.__options.animationDuration[0] + "ms",
                        "animation-duration":
                          e.__options.animationDuration[0] + "ms",
                        "transition-duration":
                          e.__options.animationDuration[0] + "ms",
                      }),
                    setTimeout(function () {
                      "closed" != e.__state &&
                        (e._$tooltip
                          .addClass("tooltipster-show")
                          .removeClass("tooltipster-initial"),
                        e.__options.animationDuration[0] > 0 &&
                          e._$tooltip.delay(e.__options.animationDuration[0]),
                        e._$tooltip.queue(i));
                    }, 0))
                  : e._$tooltip
                      .css("display", "none")
                      .fadeIn(e.__options.animationDuration[0], i),
                e.__trackerStart(),
                a(h.window)
                  .on(
                    "resize." + e.__namespace + "-triggerClose",
                    function (a) {
                      e.reposition(a);
                    }
                  )
                  .on(
                    "scroll." + e.__namespace + "-triggerClose",
                    function (a) {
                      e.__scrollHandler(a);
                    }
                  ),
                (e.__$originParents = e._$origin.parents()),
                e.__$originParents.each(function (b, c) {
                  a(c).on(
                    "scroll." + e.__namespace + "-triggerClose",
                    function (a) {
                      e.__scrollHandler(a);
                    }
                  );
                }),
                e.__options.triggerClose.mouseleave ||
                  (e.__options.triggerClose.touchleave && h.hasTouchCapability))
              ) {
                e._on("dismissable", function (a) {
                  a.dismissable
                    ? a.delay
                      ? ((m = setTimeout(function () {
                          e._close(a.event);
                        }, a.delay)),
                        e.__timeouts.close.push(m))
                      : e._close(a)
                    : clearTimeout(m);
                });
                var j = e._$origin,
                  k = "",
                  l = "",
                  m = null;
                e.__options.interactive && (j = j.add(e._$tooltip)),
                  e.__options.triggerClose.mouseleave &&
                    ((k += "mouseenter." + e.__namespace + "-triggerClose "),
                    (l += "mouseleave." + e.__namespace + "-triggerClose ")),
                  e.__options.triggerClose.touchleave &&
                    h.hasTouchCapability &&
                    ((k += "touchstart." + e.__namespace + "-triggerClose"),
                    (l +=
                      "touchend." +
                      e.__namespace +
                      "-triggerClose touchcancel." +
                      e.__namespace +
                      "-triggerClose")),
                  j
                    .on(l, function (a) {
                      if (
                        e._touchIsTouchEvent(a) ||
                        !e._touchIsEmulatedEvent(a)
                      ) {
                        var b =
                          "mouseleave" == a.type
                            ? e.__options.delay
                            : e.__options.delayTouch;
                        e._trigger({
                          delay: b[1],
                          dismissable: !0,
                          event: a,
                          type: "dismissable",
                        });
                      }
                    })
                    .on(k, function (a) {
                      (!e._touchIsTouchEvent(a) &&
                        e._touchIsEmulatedEvent(a)) ||
                        e._trigger({
                          dismissable: !1,
                          event: a,
                          type: "dismissable",
                        });
                    });
              }
              e.__options.triggerClose.originClick &&
                e._$origin.on(
                  "click." + e.__namespace + "-triggerClose",
                  function (a) {
                    e._touchIsTouchEvent(a) ||
                      e._touchIsEmulatedEvent(a) ||
                      e._close(a);
                  }
                ),
                (e.__options.triggerClose.click ||
                  (e.__options.triggerClose.tap && h.hasTouchCapability)) &&
                  setTimeout(function () {
                    if ("closed" != e.__state) {
                      var b = "";
                      e.__options.triggerClose.click &&
                        (b += "click." + e.__namespace + "-triggerClose "),
                        e.__options.triggerClose.tap &&
                          h.hasTouchCapability &&
                          (b += "touchend." + e.__namespace + "-triggerClose"),
                        a("body").on(b, function (b) {
                          e._touchIsMeaningfulEvent(b) &&
                            (e._touchRecordEvent(b),
                            (e.__options.interactive &&
                              a.contains(e._$tooltip[0], b.target)) ||
                              e._close(b));
                        }),
                        e.__options.triggerClose.tap &&
                          h.hasTouchCapability &&
                          a("body").on(
                            "touchstart." + e.__namespace + "-triggerClose",
                            function (a) {
                              e._touchRecordEvent(a);
                            }
                          );
                    }
                  }, 0),
                e._trigger("ready"),
                e.__options.functionReady &&
                  e.__options.functionReady.call(e, e, {
                    origin: e._$origin[0],
                    tooltip: e._$tooltip[0],
                  });
            }
            if (e.__options.timer > 0) {
              var m = setTimeout(function () {
                e._close();
              }, e.__options.timer + g);
              e.__timeouts.close.push(m);
            }
          }
        }
        return e;
      },
      _openShortly: function (a) {
        var b = this,
          c = !0;
        if (
          "stable" != b.__state &&
          "appearing" != b.__state &&
          !b.__timeouts.open &&
          (b._trigger({
            type: "start",
            event: a,
            stop: function () {
              c = !1;
            },
          }),
          c)
        ) {
          var d =
            0 == a.type.indexOf("touch")
              ? b.__options.delayTouch
              : b.__options.delay;
          d[0]
            ? (b.__timeouts.open = setTimeout(function () {
                (b.__timeouts.open = null),
                  b.__pointerIsOverOrigin && b._touchIsMeaningfulEvent(a)
                    ? (b._trigger("startend"), b._open(a))
                    : b._trigger("startcancel");
              }, d[0]))
            : (b._trigger("startend"), b._open(a));
        }
        return b;
      },
      _optionsExtract: function (b, c) {
        var d = this,
          e = a.extend(!0, {}, c),
          f = d.__options[b];
        return (
          f ||
            ((f = {}),
            a.each(c, function (a, b) {
              var c = d.__options[a];
              void 0 !== c && (f[a] = c);
            })),
          a.each(e, function (b, c) {
            void 0 !== f[b] &&
              ("object" != typeof c ||
              c instanceof Array ||
              null == c ||
              "object" != typeof f[b] ||
              f[b] instanceof Array ||
              null == f[b]
                ? (e[b] = f[b])
                : a.extend(e[b], f[b]));
          }),
          e
        );
      },
      _plug: function (b) {
        var c = a.tooltipster._plugin(b);
        if (!c) throw new Error('The "' + b + '" plugin is not defined');
        return (
          c.instance && a.tooltipster.__bridge(c.instance, this, c.name), this
        );
      },
      _touchIsEmulatedEvent: function (a) {
        for (
          var b = !1,
            c = new Date().getTime(),
            d = this.__touchEvents.length - 1;
          d >= 0;
          d--
        ) {
          var e = this.__touchEvents[d];
          if (!(c - e.time < 500)) break;
          e.target === a.target && (b = !0);
        }
        return b;
      },
      _touchIsMeaningfulEvent: function (a) {
        return (
          (this._touchIsTouchEvent(a) && !this._touchSwiped(a.target)) ||
          (!this._touchIsTouchEvent(a) && !this._touchIsEmulatedEvent(a))
        );
      },
      _touchIsTouchEvent: function (a) {
        return 0 == a.type.indexOf("touch");
      },
      _touchRecordEvent: function (a) {
        return (
          this._touchIsTouchEvent(a) &&
            ((a.time = new Date().getTime()), this.__touchEvents.push(a)),
          this
        );
      },
      _touchSwiped: function (a) {
        for (var b = !1, c = this.__touchEvents.length - 1; c >= 0; c--) {
          var d = this.__touchEvents[c];
          if ("touchmove" == d.type) {
            b = !0;
            break;
          }
          if ("touchstart" == d.type && a === d.target) break;
        }
        return b;
      },
      _trigger: function () {
        var b = Array.prototype.slice.apply(arguments);
        return (
          "string" == typeof b[0] && (b[0] = { type: b[0] }),
          (b[0].instance = this),
          (b[0].origin = this._$origin ? this._$origin[0] : null),
          (b[0].tooltip = this._$tooltip ? this._$tooltip[0] : null),
          this.__$emitterPrivate.trigger.apply(this.__$emitterPrivate, b),
          a.tooltipster._trigger.apply(a.tooltipster, b),
          this.__$emitterPublic.trigger.apply(this.__$emitterPublic, b),
          this
        );
      },
      _unplug: function (b) {
        var c = this;
        if (c[b]) {
          var d = a.tooltipster._plugin(b);
          d.instance &&
            a.each(d.instance, function (a, d) {
              c[a] && c[a].bridged === c[b] && delete c[a];
            }),
            c[b].__destroy && c[b].__destroy(),
            delete c[b];
        }
        return c;
      },
      close: function (a) {
        return (
          this.__destroyed ? this.__destroyError() : this._close(null, a), this
        );
      },
      content: function (a) {
        var b = this;
        if (void 0 === a) return b.__Content;
        if (b.__destroyed) b.__destroyError();
        else if ((b.__contentSet(a), null !== b.__Content)) {
          if (
            "closed" !== b.__state &&
            (b.__contentInsert(), b.reposition(), b.__options.updateAnimation)
          )
            if (h.hasTransitions) {
              var c = b.__options.updateAnimation;
              b._$tooltip.addClass("tooltipster-update-" + c),
                setTimeout(function () {
                  "closed" != b.__state &&
                    b._$tooltip.removeClass("tooltipster-update-" + c);
                }, 1e3);
            } else
              b._$tooltip.fadeTo(200, 0.5, function () {
                "closed" != b.__state && b._$tooltip.fadeTo(200, 1);
              });
        } else b._close();
        return b;
      },
      destroy: function () {
        var b = this;
        return (
          b.__destroyed
            ? b.__destroyError()
            : b.__destroying ||
              ((b.__destroying = !0),
              b._close(null, function () {
                b._trigger("destroy"),
                  (b.__destroying = !1),
                  (b.__destroyed = !0),
                  b._$origin
                    .removeData(b.__namespace)
                    .off("." + b.__namespace + "-triggerOpen"),
                  a("body").off("." + b.__namespace + "-triggerOpen");
                var c = b._$origin.data("tooltipster-ns");
                if (c)
                  if (1 === c.length) {
                    var d = null;
                    "previous" == b.__options.restoration
                      ? (d = b._$origin.data("tooltipster-initialTitle"))
                      : "current" == b.__options.restoration &&
                        (d =
                          "string" == typeof b.__Content
                            ? b.__Content
                            : a("<div></div>").append(b.__Content).html()),
                      d && b._$origin.attr("title", d),
                      b._$origin.removeClass("tooltipstered"),
                      b._$origin
                        .removeData("tooltipster-ns")
                        .removeData("tooltipster-initialTitle");
                  } else
                    (c = a.grep(c, function (a, c) {
                      return a !== b.__namespace;
                    })),
                      b._$origin.data("tooltipster-ns", c);
                b._trigger("destroyed"),
                  b._off(),
                  b.off(),
                  (b.__Content = null),
                  (b.__$emitterPrivate = null),
                  (b.__$emitterPublic = null),
                  (b.__options.parent = null),
                  (b._$origin = null),
                  (b._$tooltip = null),
                  (a.tooltipster.__instancesLatestArr = a.grep(
                    a.tooltipster.__instancesLatestArr,
                    function (a, c) {
                      return b !== a;
                    }
                  )),
                  clearInterval(b.__garbageCollector);
              })),
          b
        );
      },
      disable: function () {
        return this.__destroyed
          ? (this.__destroyError(), this)
          : (this._close(), (this.__enabled = !1), this);
      },
      elementOrigin: function () {
        return this.__destroyed ? void this.__destroyError() : this._$origin[0];
      },
      elementTooltip: function () {
        return this._$tooltip ? this._$tooltip[0] : null;
      },
      enable: function () {
        return (this.__enabled = !0), this;
      },
      hide: function (a) {
        return this.close(a);
      },
      instance: function () {
        return this;
      },
      off: function () {
        return (
          this.__destroyed ||
            this.__$emitterPublic.off.apply(
              this.__$emitterPublic,
              Array.prototype.slice.apply(arguments)
            ),
          this
        );
      },
      on: function () {
        return (
          this.__destroyed
            ? this.__destroyError()
            : this.__$emitterPublic.on.apply(
                this.__$emitterPublic,
                Array.prototype.slice.apply(arguments)
              ),
          this
        );
      },
      one: function () {
        return (
          this.__destroyed
            ? this.__destroyError()
            : this.__$emitterPublic.one.apply(
                this.__$emitterPublic,
                Array.prototype.slice.apply(arguments)
              ),
          this
        );
      },
      open: function (a) {
        return (
          this.__destroyed || this.__destroying
            ? this.__destroyError()
            : this._open(null, a),
          this
        );
      },
      option: function (b, c) {
        return void 0 === c
          ? this.__options[b]
          : (this.__destroyed
              ? this.__destroyError()
              : ((this.__options[b] = c),
                this.__optionsFormat(),
                a.inArray(b, ["trigger", "triggerClose", "triggerOpen"]) >= 0 &&
                  this.__prepareOrigin(),
                "selfDestruction" === b && this.__prepareGC()),
            this);
      },
      reposition: function (a, b) {
        var c = this;
        return (
          c.__destroyed
            ? c.__destroyError()
            : (d(c._$tooltip) || b) &&
              (b || c._$tooltip.detach(),
              (c.__Geometry = c.__geometry()),
              c._trigger({
                type: "reposition",
                event: a,
                helper: { geo: c.__Geometry },
              })),
          c
        );
      },
      show: function (a) {
        return this.open(a);
      },
      status: function () {
        return {
          destroyed: this.__destroyed,
          destroying: this.__destroying,
          enabled: this.__enabled,
          open: "closed" !== this.__state,
          state: this.__state,
        };
      },
      triggerHandler: function () {
        return (
          this.__destroyed
            ? this.__destroyError()
            : this.__$emitterPublic.triggerHandler.apply(
                this.__$emitterPublic,
                Array.prototype.slice.apply(arguments)
              ),
          this
        );
      },
    }),
    (a.fn.tooltipster = function () {
      var b = Array.prototype.slice.apply(arguments),
        c =
          "You are using a single HTML element as content for several tooltips. You probably want to set the contentCloning option to TRUE.";
      if (0 === this.length) return this;
      if ("string" == typeof b[0]) {
        var d = "#*$~&";
        return (
          this.each(function () {
            var e = a(this).data("tooltipster-ns"),
              f = e ? a(this).data(e[0]) : null;
            if (!f)
              throw new Error(
                "You called Tooltipster's \"" +
                  b[0] +
                  '" method on an uninitialized element'
              );
            if ("function" != typeof f[b[0]])
              throw new Error('Unknown method "' + b[0] + '"');
            this.length > 1 &&
              "content" == b[0] &&
              (b[1] instanceof a ||
                ("object" == typeof b[1] && null != b[1] && b[1].tagName)) &&
              !f.__options.contentCloning &&
              f.__options.debug &&
              console.log(c);
            var g = f[b[0]](b[1], b[2]);
            return g !== f || "instance" === b[0] ? ((d = g), !1) : void 0;
          }),
          "#*$~&" !== d ? d : this
        );
      }
      a.tooltipster.__instancesLatestArr = [];
      var e = b[0] && void 0 !== b[0].multiple,
        g = (e && b[0].multiple) || (!e && f.multiple),
        h = b[0] && void 0 !== b[0].content,
        i = (h && b[0].content) || (!h && f.content),
        j = b[0] && void 0 !== b[0].contentCloning,
        k = (j && b[0].contentCloning) || (!j && f.contentCloning),
        l = b[0] && void 0 !== b[0].debug,
        m = (l && b[0].debug) || (!l && f.debug);
      return (
        this.length > 1 &&
          (i instanceof a ||
            ("object" == typeof i && null != i && i.tagName)) &&
          !k &&
          m &&
          console.log(c),
        this.each(function () {
          var c = !1,
            d = a(this),
            e = d.data("tooltipster-ns"),
            f = null;
          e
            ? g
              ? (c = !0)
              : m &&
                (console.log(
                  "Tooltipster: one or more tooltips are already attached to the element below. Ignoring."
                ),
                console.log(this))
            : (c = !0),
            c &&
              ((f = new a.Tooltipster(this, b[0])),
              e || (e = []),
              e.push(f.__namespace),
              d.data("tooltipster-ns", e),
              d.data(f.__namespace, f),
              f.__options.functionInit &&
                f.__options.functionInit.call(f, f, { origin: this }),
              f._trigger("init")),
            a.tooltipster.__instancesLatestArr.push(f);
        }),
        this
      );
    }),
    (b.prototype = {
      __init: function (b) {
        (this.__$tooltip = b),
          this.__$tooltip
            .css({ left: 0, overflow: "hidden", position: "absolute", top: 0 })
            .find(".tooltipster-content")
            .css("overflow", "auto"),
          (this.$container = a('<div class="tooltipster-ruler"></div>')
            .append(this.__$tooltip)
            .appendTo("body"));
      },
      __forceRedraw: function () {
        var a = this.__$tooltip.parent();
        this.__$tooltip.detach(), this.__$tooltip.appendTo(a);
      },
      constrain: function (a, b) {
        return (
          (this.constraints = { width: a, height: b }),
          this.__$tooltip.css({
            display: "block",
            height: "",
            overflow: "auto",
            width: a,
          }),
          this
        );
      },
      destroy: function () {
        this.__$tooltip
          .detach()
          .find(".tooltipster-content")
          .css({ display: "", overflow: "" }),
          this.$container.remove();
      },
      free: function () {
        return (
          (this.constraints = null),
          this.__$tooltip.css({
            display: "",
            height: "",
            overflow: "visible",
            width: "",
          }),
          this
        );
      },
      measure: function () {
        this.__forceRedraw();
        var a = this.__$tooltip[0].getBoundingClientRect(),
          b = {
            size: { height: a.height || a.bottom, width: a.width || a.right },
          };
        if (this.constraints) {
          var c = this.__$tooltip.find(".tooltipster-content"),
            d = this.__$tooltip.outerHeight(),
            e = c[0].getBoundingClientRect(),
            f = {
              height: d <= this.constraints.height,
              width:
                a.width <= this.constraints.width &&
                e.width >= c[0].scrollWidth - 1,
            };
          b.fits = f.height && f.width;
        }
        return (
          h.IE && h.IE <= 11 && (b.size.width = Math.ceil(b.size.width) + 1), b
        );
      },
    });
  var j = navigator.userAgent.toLowerCase();
  -1 != j.indexOf("msie")
    ? (h.IE = parseInt(j.split("msie")[1]))
    : -1 !== j.toLowerCase().indexOf("trident") && -1 !== j.indexOf(" rv:11")
    ? (h.IE = 11)
    : -1 != j.toLowerCase().indexOf("edge/") &&
      (h.IE = parseInt(j.toLowerCase().split("edge/")[1]));
  var k = "tooltipster.sideTip";
  return (
    a.tooltipster._plugin({
      name: k,
      instance: {
        __defaults: function () {
          return {
            arrow: !0,
            distance: 6,
            functionPosition: null,
            maxWidth: null,
            minIntersection: 16,
            minWidth: 0,
            position: null,
            side: "top",
            viewportAware: !0,
          };
        },
        __init: function (a) {
          var b = this;
          (b.__instance = a),
            (b.__namespace =
              "tooltipster-sideTip-" + Math.round(1e6 * Math.random())),
            (b.__previousState = "closed"),
            b.__options,
            b.__optionsFormat(),
            b.__instance._on("state." + b.__namespace, function (a) {
              "closed" == a.state
                ? b.__close()
                : "appearing" == a.state &&
                  "closed" == b.__previousState &&
                  b.__create(),
                (b.__previousState = a.state);
            }),
            b.__instance._on("options." + b.__namespace, function () {
              b.__optionsFormat();
            }),
            b.__instance._on("reposition." + b.__namespace, function (a) {
              b.__reposition(a.event, a.helper);
            });
        },
        __close: function () {
          this.__instance.content() instanceof a &&
            this.__instance.content().detach(),
            this.__instance._$tooltip.remove(),
            (this.__instance._$tooltip = null);
        },
        __create: function () {
          var b = a(
            '<div class="tooltipster-base tooltipster-sidetip"><div class="tooltipster-box"><div class="tooltipster-content"></div></div><div class="tooltipster-arrow"><div class="tooltipster-arrow-uncropped"><div class="tooltipster-arrow-border"></div><div class="tooltipster-arrow-background"></div></div></div></div>'
          );
          this.__options.arrow ||
            b
              .find(".tooltipster-box")
              .css("margin", 0)
              .end()
              .find(".tooltipster-arrow")
              .hide(),
            this.__options.minWidth &&
              b.css("min-width", this.__options.minWidth + "px"),
            this.__options.maxWidth &&
              b.css("max-width", this.__options.maxWidth + "px"),
            (this.__instance._$tooltip = b),
            this.__instance._trigger("created");
        },
        __destroy: function () {
          this.__instance._off("." + self.__namespace);
        },
        __optionsFormat: function () {
          var b = this;
          if (
            ((b.__options = b.__instance._optionsExtract(k, b.__defaults())),
            b.__options.position && (b.__options.side = b.__options.position),
            "object" != typeof b.__options.distance &&
              (b.__options.distance = [b.__options.distance]),
            b.__options.distance.length < 4 &&
              (void 0 === b.__options.distance[1] &&
                (b.__options.distance[1] = b.__options.distance[0]),
              void 0 === b.__options.distance[2] &&
                (b.__options.distance[2] = b.__options.distance[0]),
              void 0 === b.__options.distance[3] &&
                (b.__options.distance[3] = b.__options.distance[1]),
              (b.__options.distance = {
                top: b.__options.distance[0],
                right: b.__options.distance[1],
                bottom: b.__options.distance[2],
                left: b.__options.distance[3],
              })),
            "string" == typeof b.__options.side)
          ) {
            var c = {
              top: "bottom",
              right: "left",
              bottom: "top",
              left: "right",
            };
            (b.__options.side = [b.__options.side, c[b.__options.side]]),
              "left" == b.__options.side[0] || "right" == b.__options.side[0]
                ? b.__options.side.push("top", "bottom")
                : b.__options.side.push("right", "left");
          }
          6 === a.tooltipster._env.IE &&
            b.__options.arrow !== !0 &&
            (b.__options.arrow = !1);
        },
        __reposition: function (b, c) {
          var d,
            e = this,
            f = e.__targetFind(c),
            g = [];
          e.__instance._$tooltip.detach();
          var h = e.__instance._$tooltip.clone(),
            i = a.tooltipster._getRuler(h),
            j = !1;
          switch (
            (a.each(["window", "document"], function (d, k) {
              var l = null;
              if (
                (e.__instance._trigger({
                  container: k,
                  helper: c,
                  satisfied: j,
                  takeTest: function (a) {
                    l = a;
                  },
                  results: g,
                  type: "positionTest",
                }),
                1 == l ||
                  (0 != l &&
                    0 == j &&
                    ("window" != k || e.__options.viewportAware)))
              )
                for (var d = 0; d < e.__options.side.length; d++) {
                  var m = { horizontal: 0, vertical: 0 },
                    n = e.__options.side[d];
                  "top" == n || "bottom" == n
                    ? (m.vertical = e.__options.distance[n])
                    : (m.horizontal = e.__options.distance[n]),
                    e.__sideChange(h, n),
                    a.each(["natural", "constrained"], function (a, d) {
                      if (
                        ((l = null),
                        e.__instance._trigger({
                          container: k,
                          event: b,
                          helper: c,
                          mode: d,
                          results: g,
                          satisfied: j,
                          side: n,
                          takeTest: function (a) {
                            l = a;
                          },
                          type: "positionTest",
                        }),
                        1 == l || (0 != l && 0 == j))
                      ) {
                        var h = {
                            container: k,
                            distance: m,
                            fits: null,
                            mode: d,
                            outerSize: null,
                            side: n,
                            size: null,
                            target: f[n],
                            whole: null,
                          },
                          o =
                            "natural" == d
                              ? i.free()
                              : i.constrain(
                                  c.geo.available[k][n].width - m.horizontal,
                                  c.geo.available[k][n].height - m.vertical
                                ),
                          p = o.measure();
                        if (
                          ((h.size = p.size),
                          (h.outerSize = {
                            height: p.size.height + m.vertical,
                            width: p.size.width + m.horizontal,
                          }),
                          "natural" == d
                            ? c.geo.available[k][n].width >=
                                h.outerSize.width &&
                              c.geo.available[k][n].height >= h.outerSize.height
                              ? (h.fits = !0)
                              : (h.fits = !1)
                            : (h.fits = p.fits),
                          "window" == k &&
                            (h.fits
                              ? "top" == n || "bottom" == n
                                ? (h.whole =
                                    c.geo.origin.windowOffset.right >=
                                      e.__options.minIntersection &&
                                    c.geo.window.size.width -
                                      c.geo.origin.windowOffset.left >=
                                      e.__options.minIntersection)
                                : (h.whole =
                                    c.geo.origin.windowOffset.bottom >=
                                      e.__options.minIntersection &&
                                    c.geo.window.size.height -
                                      c.geo.origin.windowOffset.top >=
                                      e.__options.minIntersection)
                              : (h.whole = !1)),
                          g.push(h),
                          h.whole)
                        )
                          j = !0;
                        else if (
                          "natural" == h.mode &&
                          (h.fits ||
                            h.size.width <= c.geo.available[k][n].width)
                        )
                          return !1;
                      }
                    });
                }
            }),
            e.__instance._trigger({
              edit: function (a) {
                g = a;
              },
              event: b,
              helper: c,
              results: g,
              type: "positionTested",
            }),
            g.sort(function (a, b) {
              if (a.whole && !b.whole) return -1;
              if (!a.whole && b.whole) return 1;
              if (a.whole && b.whole) {
                var c = e.__options.side.indexOf(a.side),
                  d = e.__options.side.indexOf(b.side);
                return d > c ? -1 : c > d ? 1 : "natural" == a.mode ? -1 : 1;
              }
              if (a.fits && !b.fits) return -1;
              if (!a.fits && b.fits) return 1;
              if (a.fits && b.fits) {
                var c = e.__options.side.indexOf(a.side),
                  d = e.__options.side.indexOf(b.side);
                return d > c ? -1 : c > d ? 1 : "natural" == a.mode ? -1 : 1;
              }
              return "document" == a.container &&
                "bottom" == a.side &&
                "natural" == a.mode
                ? -1
                : 1;
            }),
            (d = g[0]),
            (d.coord = {}),
            d.side)
          ) {
            case "left":
            case "right":
              d.coord.top = Math.floor(d.target - d.size.height / 2);
              break;
            case "bottom":
            case "top":
              d.coord.left = Math.floor(d.target - d.size.width / 2);
          }
          switch (d.side) {
            case "left":
              d.coord.left = c.geo.origin.windowOffset.left - d.outerSize.width;
              break;
            case "right":
              d.coord.left =
                c.geo.origin.windowOffset.right + d.distance.horizontal;
              break;
            case "top":
              d.coord.top = c.geo.origin.windowOffset.top - d.outerSize.height;
              break;
            case "bottom":
              d.coord.top =
                c.geo.origin.windowOffset.bottom + d.distance.vertical;
          }
          "window" == d.container
            ? "top" == d.side || "bottom" == d.side
              ? d.coord.left < 0
                ? c.geo.origin.windowOffset.right -
                    this.__options.minIntersection >=
                  0
                  ? (d.coord.left = 0)
                  : (d.coord.left =
                      c.geo.origin.windowOffset.right -
                      this.__options.minIntersection -
                      1)
                : d.coord.left > c.geo.window.size.width - d.size.width &&
                  (c.geo.origin.windowOffset.left +
                    this.__options.minIntersection <=
                  c.geo.window.size.width
                    ? (d.coord.left = c.geo.window.size.width - d.size.width)
                    : (d.coord.left =
                        c.geo.origin.windowOffset.left +
                        this.__options.minIntersection +
                        1 -
                        d.size.width))
              : d.coord.top < 0
              ? c.geo.origin.windowOffset.bottom -
                  this.__options.minIntersection >=
                0
                ? (d.coord.top = 0)
                : (d.coord.top =
                    c.geo.origin.windowOffset.bottom -
                    this.__options.minIntersection -
                    1)
              : d.coord.top > c.geo.window.size.height - d.size.height &&
                (c.geo.origin.windowOffset.top +
                  this.__options.minIntersection <=
                c.geo.window.size.height
                  ? (d.coord.top = c.geo.window.size.height - d.size.height)
                  : (d.coord.top =
                      c.geo.origin.windowOffset.top +
                      this.__options.minIntersection +
                      1 -
                      d.size.height))
            : (d.coord.left > c.geo.window.size.width - d.size.width &&
                (d.coord.left = c.geo.window.size.width - d.size.width),
              d.coord.left < 0 && (d.coord.left = 0)),
            e.__sideChange(h, d.side),
            (c.tooltipClone = h[0]),
            (c.tooltipParent = e.__instance.option("parent").parent[0]),
            (c.mode = d.mode),
            (c.whole = d.whole),
            (c.origin = e.__instance._$origin[0]),
            (c.tooltip = e.__instance._$tooltip[0]),
            delete d.container,
            delete d.fits,
            delete d.mode,
            delete d.outerSize,
            delete d.whole,
            (d.distance = d.distance.horizontal || d.distance.vertical);
          var k = a.extend(!0, {}, d);
          if (
            (e.__instance._trigger({
              edit: function (a) {
                d = a;
              },
              event: b,
              helper: c,
              position: k,
              type: "position",
            }),
            e.__options.functionPosition)
          ) {
            var l = e.__options.functionPosition.call(e, e.__instance, c, k);
            l && (d = l);
          }
          i.destroy();
          var m, n;
          "top" == d.side || "bottom" == d.side
            ? ((m = { prop: "left", val: d.target - d.coord.left }),
              (n = d.size.width - this.__options.minIntersection))
            : ((m = { prop: "top", val: d.target - d.coord.top }),
              (n = d.size.height - this.__options.minIntersection)),
            m.val < this.__options.minIntersection
              ? (m.val = this.__options.minIntersection)
              : m.val > n && (m.val = n);
          var o;
          (o = c.geo.origin.fixedLineage
            ? c.geo.origin.windowOffset
            : {
                left: c.geo.origin.windowOffset.left + c.geo.window.scroll.left,
                top: c.geo.origin.windowOffset.top + c.geo.window.scroll.top,
              }),
            (d.coord = {
              left: o.left + (d.coord.left - c.geo.origin.windowOffset.left),
              top: o.top + (d.coord.top - c.geo.origin.windowOffset.top),
            }),
            e.__sideChange(e.__instance._$tooltip, d.side),
            c.geo.origin.fixedLineage
              ? e.__instance._$tooltip.css("position", "fixed")
              : e.__instance._$tooltip.css("position", ""),
            e.__instance._$tooltip
              .css({
                left: d.coord.left,
                top: d.coord.top,
                height: d.size.height,
                width: d.size.width,
              })
              .find(".tooltipster-arrow")
              .css({ left: "", top: "" })
              .css(m.prop, m.val),
            e.__instance._$tooltip.appendTo(e.__instance.option("parent")),
            e.__instance._trigger({
              type: "repositioned",
              event: b,
              position: d,
            });
        },
        __sideChange: function (a, b) {
          a.removeClass("tooltipster-bottom")
            .removeClass("tooltipster-left")
            .removeClass("tooltipster-right")
            .removeClass("tooltipster-top")
            .addClass("tooltipster-" + b);
        },
        __targetFind: function (a) {
          var b = {},
            c = this.__instance._$origin[0].getClientRects();
          if (c.length > 1) {
            var d = this.__instance._$origin.css("opacity");
            1 == d &&
              (this.__instance._$origin.css("opacity", 0.99),
              (c = this.__instance._$origin[0].getClientRects()),
              this.__instance._$origin.css("opacity", 1));
          }
          if (c.length < 2)
            (b.top = Math.floor(
              a.geo.origin.windowOffset.left + a.geo.origin.size.width / 2
            )),
              (b.bottom = b.top),
              (b.left = Math.floor(
                a.geo.origin.windowOffset.top + a.geo.origin.size.height / 2
              )),
              (b.right = b.left);
          else {
            var e = c[0];
            (b.top = Math.floor(e.left + (e.right - e.left) / 2)),
              (e = c.length > 2 ? c[Math.ceil(c.length / 2) - 1] : c[0]),
              (b.right = Math.floor(e.top + (e.bottom - e.top) / 2)),
              (e = c[c.length - 1]),
              (b.bottom = Math.floor(e.left + (e.right - e.left) / 2)),
              (e =
                c.length > 2
                  ? c[Math.ceil((c.length + 1) / 2) - 1]
                  : c[c.length - 1]),
              (b.left = Math.floor(e.top + (e.bottom - e.top) / 2));
          }
          return b;
        },
      },
    }),
    a
  );
});

/*!
 * clipboard.js v1.5.12
 * https://zenorocha.github.io/clipboard.js
 *
 * Licensed MIT © Zeno Rocha
 */
!(function (t) {
  if ("object" == typeof exports && "undefined" != typeof module)
    module.exports = t();
  else if ("function" == typeof define && define.amd) define([], t);
  else {
    var e;
    (e =
      "undefined" != typeof window
        ? window
        : "undefined" != typeof global
        ? global
        : "undefined" != typeof self
        ? self
        : this),
      (e.Clipboard = t());
  }
})(function () {
  var t, e, n;
  return (function t(e, n, o) {
    function i(a, c) {
      if (!n[a]) {
        if (!e[a]) {
          var s = "function" == typeof require && require;
          if (!c && s) return s(a, !0);
          if (r) return r(a, !0);
          var l = new Error("Cannot find module '" + a + "'");
          throw ((l.code = "MODULE_NOT_FOUND"), l);
        }
        var u = (n[a] = { exports: {} });
        e[a][0].call(
          u.exports,
          function (t) {
            var n = e[a][1][t];
            return i(n ? n : t);
          },
          u,
          u.exports,
          t,
          e,
          n,
          o
        );
      }
      return n[a].exports;
    }
    for (
      var r = "function" == typeof require && require, a = 0;
      a < o.length;
      a++
    )
      i(o[a]);
    return i;
  })(
    {
      1: [
        function (t, e, n) {
          var o = t("matches-selector");
          e.exports = function (t, e, n) {
            for (var i = n ? t : t.parentNode; i && i !== document; ) {
              if (o(i, e)) return i;
              i = i.parentNode;
            }
          };
        },
        { "matches-selector": 5 },
      ],
      2: [
        function (t, e, n) {
          function o(t, e, n, o, r) {
            var a = i.apply(this, arguments);
            return (
              t.addEventListener(n, a, r),
              {
                destroy: function () {
                  t.removeEventListener(n, a, r);
                },
              }
            );
          }
          function i(t, e, n, o) {
            return function (n) {
              (n.delegateTarget = r(n.target, e, !0)),
                n.delegateTarget && o.call(t, n);
            };
          }
          var r = t("closest");
          e.exports = o;
        },
        { closest: 1 },
      ],
      3: [
        function (t, e, n) {
          (n.node = function (t) {
            return void 0 !== t && t instanceof HTMLElement && 1 === t.nodeType;
          }),
            (n.nodeList = function (t) {
              var e = Object.prototype.toString.call(t);
              return (
                void 0 !== t &&
                ("[object NodeList]" === e ||
                  "[object HTMLCollection]" === e) &&
                "length" in t &&
                (0 === t.length || n.node(t[0]))
              );
            }),
            (n.string = function (t) {
              return "string" == typeof t || t instanceof String;
            }),
            (n.fn = function (t) {
              var e = Object.prototype.toString.call(t);
              return "[object Function]" === e;
            });
        },
        {},
      ],
      4: [
        function (t, e, n) {
          function o(t, e, n) {
            if (!t && !e && !n) throw new Error("Missing required arguments");
            if (!c.string(e))
              throw new TypeError("Second argument must be a String");
            if (!c.fn(n))
              throw new TypeError("Third argument must be a Function");
            if (c.node(t)) return i(t, e, n);
            if (c.nodeList(t)) return r(t, e, n);
            if (c.string(t)) return a(t, e, n);
            throw new TypeError(
              "First argument must be a String, HTMLElement, HTMLCollection, or NodeList"
            );
          }
          function i(t, e, n) {
            return (
              t.addEventListener(e, n),
              {
                destroy: function () {
                  t.removeEventListener(e, n);
                },
              }
            );
          }
          function r(t, e, n) {
            return (
              Array.prototype.forEach.call(t, function (t) {
                t.addEventListener(e, n);
              }),
              {
                destroy: function () {
                  Array.prototype.forEach.call(t, function (t) {
                    t.removeEventListener(e, n);
                  });
                },
              }
            );
          }
          function a(t, e, n) {
            return s(document.body, t, e, n);
          }
          var c = t("./is"),
            s = t("delegate");
          e.exports = o;
        },
        { "./is": 3, delegate: 2 },
      ],
      5: [
        function (t, e, n) {
          function o(t, e) {
            if (r) return r.call(t, e);
            for (
              var n = t.parentNode.querySelectorAll(e), o = 0;
              o < n.length;
              ++o
            )
              if (n[o] == t) return !0;
            return !1;
          }
          var i = Element.prototype,
            r =
              i.matchesSelector ||
              i.webkitMatchesSelector ||
              i.mozMatchesSelector ||
              i.msMatchesSelector ||
              i.oMatchesSelector;
          e.exports = o;
        },
        {},
      ],
      6: [
        function (t, e, n) {
          function o(t) {
            var e;
            if ("INPUT" === t.nodeName || "TEXTAREA" === t.nodeName)
              t.focus(), t.setSelectionRange(0, t.value.length), (e = t.value);
            else {
              t.hasAttribute("contenteditable") && t.focus();
              var n = window.getSelection(),
                o = document.createRange();
              o.selectNodeContents(t),
                n.removeAllRanges(),
                n.addRange(o),
                (e = n.toString());
            }
            return e;
          }
          e.exports = o;
        },
        {},
      ],
      7: [
        function (t, e, n) {
          function o() {}
          (o.prototype = {
            on: function (t, e, n) {
              var o = this.e || (this.e = {});
              return (o[t] || (o[t] = [])).push({ fn: e, ctx: n }), this;
            },
            once: function (t, e, n) {
              function o() {
                i.off(t, o), e.apply(n, arguments);
              }
              var i = this;
              return (o._ = e), this.on(t, o, n);
            },
            emit: function (t) {
              var e = [].slice.call(arguments, 1),
                n = ((this.e || (this.e = {}))[t] || []).slice(),
                o = 0,
                i = n.length;
              for (o; i > o; o++) n[o].fn.apply(n[o].ctx, e);
              return this;
            },
            off: function (t, e) {
              var n = this.e || (this.e = {}),
                o = n[t],
                i = [];
              if (o && e)
                for (var r = 0, a = o.length; a > r; r++)
                  o[r].fn !== e && o[r].fn._ !== e && i.push(o[r]);
              return i.length ? (n[t] = i) : delete n[t], this;
            },
          }),
            (e.exports = o);
        },
        {},
      ],
      8: [
        function (e, n, o) {
          !(function (i, r) {
            if ("function" == typeof t && t.amd) t(["module", "select"], r);
            else if ("undefined" != typeof o) r(n, e("select"));
            else {
              var a = { exports: {} };
              r(a, i.select), (i.clipboardAction = a.exports);
            }
          })(this, function (t, e) {
            "use strict";
            function n(t) {
              return t && t.__esModule ? t : { default: t };
            }
            function o(t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            }
            var i = n(e),
              r =
                "function" == typeof Symbol &&
                "symbol" == typeof Symbol.iterator
                  ? function (t) {
                      return typeof t;
                    }
                  : function (t) {
                      return t &&
                        "function" == typeof Symbol &&
                        t.constructor === Symbol
                        ? "symbol"
                        : typeof t;
                    },
              a = (function () {
                function t(t, e) {
                  for (var n = 0; n < e.length; n++) {
                    var o = e[n];
                    (o.enumerable = o.enumerable || !1),
                      (o.configurable = !0),
                      "value" in o && (o.writable = !0),
                      Object.defineProperty(t, o.key, o);
                  }
                }
                return function (e, n, o) {
                  return n && t(e.prototype, n), o && t(e, o), e;
                };
              })(),
              c = (function () {
                function t(e) {
                  o(this, t), this.resolveOptions(e), this.initSelection();
                }
                return (
                  (t.prototype.resolveOptions = function t() {
                    var e =
                      arguments.length <= 0 || void 0 === arguments[0]
                        ? {}
                        : arguments[0];
                    (this.action = e.action),
                      (this.emitter = e.emitter),
                      (this.target = e.target),
                      (this.text = e.text),
                      (this.trigger = e.trigger),
                      (this.selectedText = "");
                  }),
                  (t.prototype.initSelection = function t() {
                    this.text
                      ? this.selectFake()
                      : this.target && this.selectTarget();
                  }),
                  (t.prototype.selectFake = function t() {
                    var e = this,
                      n = "rtl" == document.documentElement.getAttribute("dir");
                    this.removeFake(),
                      (this.fakeHandlerCallback = function () {
                        return e.removeFake();
                      }),
                      (this.fakeHandler =
                        document.body.addEventListener(
                          "click",
                          this.fakeHandlerCallback
                        ) || !0),
                      (this.fakeElem = document.createElement("textarea")),
                      (this.fakeElem.style.fontSize = "12pt"),
                      (this.fakeElem.style.border = "0"),
                      (this.fakeElem.style.padding = "0"),
                      (this.fakeElem.style.margin = "0"),
                      (this.fakeElem.style.position = "absolute"),
                      (this.fakeElem.style[n ? "right" : "left"] = "-9999px"),
                      (this.fakeElem.style.top =
                        (window.pageYOffset ||
                          document.documentElement.scrollTop) + "px"),
                      this.fakeElem.setAttribute("readonly", ""),
                      (this.fakeElem.value = this.text),
                      document.body.appendChild(this.fakeElem),
                      (this.selectedText = (0, i.default)(this.fakeElem)),
                      this.copyText();
                  }),
                  (t.prototype.removeFake = function t() {
                    this.fakeHandler &&
                      (document.body.removeEventListener(
                        "click",
                        this.fakeHandlerCallback
                      ),
                      (this.fakeHandler = null),
                      (this.fakeHandlerCallback = null)),
                      this.fakeElem &&
                        (document.body.removeChild(this.fakeElem),
                        (this.fakeElem = null));
                  }),
                  (t.prototype.selectTarget = function t() {
                    (this.selectedText = (0, i.default)(this.target)),
                      this.copyText();
                  }),
                  (t.prototype.copyText = function t() {
                    var e = void 0;
                    try {
                      e = document.execCommand(this.action);
                    } catch (n) {
                      e = !1;
                    }
                    this.handleResult(e);
                  }),
                  (t.prototype.handleResult = function t(e) {
                    e
                      ? this.emitter.emit("success", {
                          action: this.action,
                          text: this.selectedText,
                          trigger: this.trigger,
                          clearSelection: this.clearSelection.bind(this),
                        })
                      : this.emitter.emit("error", {
                          action: this.action,
                          trigger: this.trigger,
                          clearSelection: this.clearSelection.bind(this),
                        });
                  }),
                  (t.prototype.clearSelection = function t() {
                    this.target && this.target.blur(),
                      window.getSelection().removeAllRanges();
                  }),
                  (t.prototype.destroy = function t() {
                    this.removeFake();
                  }),
                  a(t, [
                    {
                      key: "action",
                      set: function t() {
                        var e =
                          arguments.length <= 0 || void 0 === arguments[0]
                            ? "copy"
                            : arguments[0];
                        if (
                          ((this._action = e),
                          "copy" !== this._action && "cut" !== this._action)
                        )
                          throw new Error(
                            'Invalid "action" value, use either "copy" or "cut"'
                          );
                      },
                      get: function t() {
                        return this._action;
                      },
                    },
                    {
                      key: "target",
                      set: function t(e) {
                        if (void 0 !== e) {
                          if (
                            !e ||
                            "object" !==
                              ("undefined" == typeof e ? "undefined" : r(e)) ||
                            1 !== e.nodeType
                          )
                            throw new Error(
                              'Invalid "target" value, use a valid Element'
                            );
                          if (
                            "copy" === this.action &&
                            e.hasAttribute("disabled")
                          )
                            throw new Error(
                              'Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute'
                            );
                          if (
                            "cut" === this.action &&
                            (e.hasAttribute("readonly") ||
                              e.hasAttribute("disabled"))
                          )
                            throw new Error(
                              'Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes'
                            );
                          this._target = e;
                        }
                      },
                      get: function t() {
                        return this._target;
                      },
                    },
                  ]),
                  t
                );
              })();
            t.exports = c;
          });
        },
        { select: 6 },
      ],
      9: [
        function (e, n, o) {
          !(function (i, r) {
            if ("function" == typeof t && t.amd)
              t(
                [
                  "module",
                  "./clipboard-action",
                  "tiny-emitter",
                  "good-listener",
                ],
                r
              );
            else if ("undefined" != typeof o)
              r(
                n,
                e("./clipboard-action"),
                e("tiny-emitter"),
                e("good-listener")
              );
            else {
              var a = { exports: {} };
              r(a, i.clipboardAction, i.tinyEmitter, i.goodListener),
                (i.clipboard = a.exports);
            }
          })(this, function (t, e, n, o) {
            "use strict";
            function i(t) {
              return t && t.__esModule ? t : { default: t };
            }
            function r(t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            }
            function a(t, e) {
              if (!t)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called"
                );
              return !e || ("object" != typeof e && "function" != typeof e)
                ? t
                : e;
            }
            function c(t, e) {
              if ("function" != typeof e && null !== e)
                throw new TypeError(
                  "Super expression must either be null or a function, not " +
                    typeof e
                );
              (t.prototype = Object.create(e && e.prototype, {
                constructor: {
                  value: t,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                e &&
                  (Object.setPrototypeOf
                    ? Object.setPrototypeOf(t, e)
                    : (t.__proto__ = e));
            }
            function s(t, e) {
              var n = "data-clipboard-" + t;
              if (e.hasAttribute(n)) return e.getAttribute(n);
            }
            var l = i(e),
              u = i(n),
              f = i(o),
              d = (function (t) {
                function e(n, o) {
                  r(this, e);
                  var i = a(this, t.call(this));
                  return i.resolveOptions(o), i.listenClick(n), i;
                }
                return (
                  c(e, t),
                  (e.prototype.resolveOptions = function t() {
                    var e =
                      arguments.length <= 0 || void 0 === arguments[0]
                        ? {}
                        : arguments[0];
                    (this.action =
                      "function" == typeof e.action
                        ? e.action
                        : this.defaultAction),
                      (this.target =
                        "function" == typeof e.target
                          ? e.target
                          : this.defaultTarget),
                      (this.text =
                        "function" == typeof e.text
                          ? e.text
                          : this.defaultText);
                  }),
                  (e.prototype.listenClick = function t(e) {
                    var n = this;
                    this.listener = (0, f.default)(e, "click", function (t) {
                      return n.onClick(t);
                    });
                  }),
                  (e.prototype.onClick = function t(e) {
                    var n = e.delegateTarget || e.currentTarget;
                    this.clipboardAction && (this.clipboardAction = null),
                      (this.clipboardAction = new l.default({
                        action: this.action(n),
                        target: this.target(n),
                        text: this.text(n),
                        trigger: n,
                        emitter: this,
                      }));
                  }),
                  (e.prototype.defaultAction = function t(e) {
                    return s("action", e);
                  }),
                  (e.prototype.defaultTarget = function t(e) {
                    var n = s("target", e);
                    return n ? document.querySelector(n) : void 0;
                  }),
                  (e.prototype.defaultText = function t(e) {
                    return s("text", e);
                  }),
                  (e.prototype.destroy = function t() {
                    this.listener.destroy(),
                      this.clipboardAction &&
                        (this.clipboardAction.destroy(),
                        (this.clipboardAction = null));
                  }),
                  e
                );
              })(u.default);
            t.exports = d;
          });
        },
        { "./clipboard-action": 8, "good-listener": 4, "tiny-emitter": 7 },
      ],
    },
    {},
    [9]
  )(9);
});

/*! flipclock 2015-08-31 */
var Base = function () {};
(Base.extend = function (a, b) {
  "use strict";
  var c = Base.prototype.extend;
  Base._prototyping = !0;
  var d = new this();
  c.call(d, a), (d.base = function () {}), delete Base._prototyping;
  var e = d.constructor,
    f = (d.constructor = function () {
      if (!Base._prototyping)
        if (this._constructing || this.constructor == f)
          (this._constructing = !0),
            e.apply(this, arguments),
            delete this._constructing;
        else if (null !== arguments[0])
          return (arguments[0].extend || c).call(arguments[0], d);
    });
  return (
    (f.ancestor = this),
    (f.extend = this.extend),
    (f.forEach = this.forEach),
    (f.implement = this.implement),
    (f.prototype = d),
    (f.toString = this.toString),
    (f.valueOf = function (a) {
      return "object" == a ? f : e.valueOf();
    }),
    c.call(f, b),
    "function" == typeof f.init && f.init(),
    f
  );
}),
  (Base.prototype = {
    extend: function (a, b) {
      if (arguments.length > 1) {
        var c = this[a];
        if (
          c &&
          "function" == typeof b &&
          (!c.valueOf || c.valueOf() != b.valueOf()) &&
          /\bbase\b/.test(b)
        ) {
          var d = b.valueOf();
          (b = function () {
            var a = this.base || Base.prototype.base;
            this.base = c;
            var b = d.apply(this, arguments);
            return (this.base = a), b;
          }),
            (b.valueOf = function (a) {
              return "object" == a ? b : d;
            }),
            (b.toString = Base.toString);
        }
        this[a] = b;
      } else if (a) {
        var e = Base.prototype.extend;
        Base._prototyping ||
          "function" == typeof this ||
          (e = this.extend || e);
        for (
          var f = { toSource: null },
            g = ["constructor", "toString", "valueOf"],
            h = Base._prototyping ? 0 : 1;
          (i = g[h++]);

        )
          a[i] != f[i] && e.call(this, i, a[i]);
        for (var i in a) f[i] || e.call(this, i, a[i]);
      }
      return this;
    },
  }),
  (Base = Base.extend(
    {
      constructor: function () {
        this.extend(arguments[0]);
      },
    },
    {
      ancestor: Object,
      version: "1.1",
      forEach: function (a, b, c) {
        for (var d in a) void 0 === this.prototype[d] && b.call(c, a[d], d, a);
      },
      implement: function () {
        for (var a = 0; a < arguments.length; a++)
          "function" == typeof arguments[a]
            ? arguments[a](this.prototype)
            : this.prototype.extend(arguments[a]);
        return this;
      },
      toString: function () {
        return String(this.valueOf());
      },
    }
  ));
var FlipClock;
!(function (a) {
  "use strict";
  (FlipClock = function (a, b, c) {
    return (
      b instanceof Object && b instanceof Date == !1 && ((c = b), (b = 0)),
      new FlipClock.Factory(a, b, c)
    );
  }),
    (FlipClock.Lang = {}),
    (FlipClock.Base = Base.extend({
      buildDate: "2014-12-12",
      version: "0.7.7",
      constructor: function (b, c) {
        "object" != typeof b && (b = {}),
          "object" != typeof c && (c = {}),
          this.setOptions(a.extend(!0, {}, b, c));
      },
      callback: function (a) {
        if ("function" == typeof a) {
          for (var b = [], c = 1; c <= arguments.length; c++)
            arguments[c] && b.push(arguments[c]);
          a.apply(this, b);
        }
      },
      log: function (a) {
        window.console && console.log && console.log(a);
      },
      getOption: function (a) {
        return this[a] ? this[a] : !1;
      },
      getOptions: function () {
        return this;
      },
      setOption: function (a, b) {
        this[a] = b;
      },
      setOptions: function (a) {
        for (var b in a) "undefined" != typeof a[b] && this.setOption(b, a[b]);
      },
    }));
})(jQuery),
  (function (a) {
    "use strict";
    FlipClock.Face = FlipClock.Base.extend({
      autoStart: !0,
      dividers: [],
      factory: !1,
      lists: [],
      constructor: function (a, b) {
        (this.dividers = []),
          (this.lists = []),
          this.base(b),
          (this.factory = a);
      },
      build: function () {
        this.autoStart && this.start();
      },
      createDivider: function (b, c, d) {
        ("boolean" != typeof c && c) || ((d = c), (c = b));
        var e = [
          '<span class="' + this.factory.classes.dot + ' top"></span>',
          '<span class="' + this.factory.classes.dot + ' bottom"></span>',
        ].join("");
        d && (e = ""), (b = this.factory.localize(b));
        var f = [
            '<span class="' +
              this.factory.classes.divider +
              " " +
              (c ? c : "").toLowerCase() +
              '">',
            '<span class="' +
              this.factory.classes.label +
              '">' +
              (b ? b : "") +
              "</span>",
            e,
            "</span>",
          ],
          g = a(f.join(""));
        return this.dividers.push(g), g;
      },
      createList: function (a, b) {
        "object" == typeof a && ((b = a), (a = 0));
        var c = new FlipClock.List(this.factory, a, b);
        return this.lists.push(c), c;
      },
      reset: function () {
        (this.factory.time = new FlipClock.Time(
          this.factory,
          this.factory.original ? Math.round(this.factory.original) : 0,
          { minimumDigits: this.factory.minimumDigits }
        )),
          this.flip(this.factory.original, !1);
      },
      appendDigitToClock: function (a) {
        a.$el.append(!1);
      },
      addDigit: function (a) {
        var b = this.createList(a, {
          classes: {
            active: this.factory.classes.active,
            before: this.factory.classes.before,
            flip: this.factory.classes.flip,
          },
        });
        this.appendDigitToClock(b);
      },
      start: function () {},
      stop: function () {},
      autoIncrement: function () {
        this.factory.countdown ? this.decrement() : this.increment();
      },
      increment: function () {
        this.factory.time.addSecond();
      },
      decrement: function () {
        0 == this.factory.time.getTimeSeconds()
          ? this.factory.stop()
          : this.factory.time.subSecond();
      },
      flip: function (b, c) {
        var d = this;
        a.each(b, function (a, b) {
          var e = d.lists[a];
          e ? (c || b == e.digit || e.play(), e.select(b)) : d.addDigit(b);
        });
      },
    });
  })(jQuery),
  (function (a) {
    "use strict";
    FlipClock.Factory = FlipClock.Base.extend({
      animationRate: 1e3,
      autoStart: !0,
      callbacks: {
        destroy: !1,
        create: !1,
        init: !1,
        interval: !1,
        start: !1,
        stop: !1,
        reset: !1,
      },
      classes: {
        active: "flip-clock-active",
        before: "flip-clock-before",
        divider: "flip-clock-divider",
        dot: "flip-clock-dot",
        label: "flip-clock-label",
        flip: "flip",
        play: "play",
        wrapper: "flip-clock-wrapper",
      },
      clockFace: "HourlyCounter",
      countdown: !1,
      defaultClockFace: "HourlyCounter",
      defaultLanguage: "english",
      $el: !1,
      face: !0,
      lang: !1,
      language: "english",
      minimumDigits: 0,
      original: !1,
      running: !1,
      time: !1,
      timer: !1,
      $wrapper: !1,
      constructor: function (b, c, d) {
        d || (d = {}),
          (this.lists = []),
          (this.running = !1),
          this.base(d),
          (this.$el = a(b).addClass(this.classes.wrapper)),
          (this.$wrapper = this.$el),
          (this.original = c instanceof Date ? c : c ? Math.round(c) : 0),
          (this.time = new FlipClock.Time(this, this.original, {
            minimumDigits: this.minimumDigits,
            animationRate: this.animationRate,
          })),
          (this.timer = new FlipClock.Timer(this, d)),
          this.loadLanguage(this.language),
          this.loadClockFace(this.clockFace, d),
          this.autoStart && this.start();
      },
      loadClockFace: function (a, b) {
        var c,
          d = "Face",
          e = !1;
        return (
          (a = a.ucfirst() + d),
          this.face.stop && (this.stop(), (e = !0)),
          this.$el.html(""),
          (this.time.minimumDigits = this.minimumDigits),
          (c = FlipClock[a]
            ? new FlipClock[a](this, b)
            : new FlipClock[this.defaultClockFace + d](this, b)),
          c.build(),
          (this.face = c),
          e && this.start(),
          this.face
        );
      },
      loadLanguage: function (a) {
        var b;
        return (
          (b = FlipClock.Lang[a.ucfirst()]
            ? FlipClock.Lang[a.ucfirst()]
            : FlipClock.Lang[a]
            ? FlipClock.Lang[a]
            : FlipClock.Lang[this.defaultLanguage]),
          (this.lang = b)
        );
      },
      localize: function (a, b) {
        var c = this.lang;
        if (!a) return null;
        var d = a.toLowerCase();
        return "object" == typeof b && (c = b), c && c[d] ? c[d] : a;
      },
      start: function (a) {
        var b = this;
        b.running || (b.countdown && !(b.countdown && b.time.time > 0))
          ? b.log("Trying to start timer when countdown already at 0")
          : (b.face.start(b.time),
            b.timer.start(function () {
              b.flip(), "function" == typeof a && a();
            }));
      },
      stop: function (a) {
        this.face.stop(), this.timer.stop(a);
        for (var b in this.lists)
          this.lists.hasOwnProperty(b) && this.lists[b].stop();
      },
      reset: function (a) {
        this.timer.reset(a), this.face.reset();
      },
      setTime: function (a) {
        (this.time.time = a), this.flip(!0);
      },
      getTime: function (a) {
        return this.time;
      },
      setCountdown: function (a) {
        var b = this.running;
        (this.countdown = a ? !0 : !1), b && (this.stop(), this.start());
      },
      flip: function (a) {
        this.face.flip(!1, a);
      },
    });
  })(jQuery),
  (function (a) {
    "use strict";
    FlipClock.List = FlipClock.Base.extend({
      digit: 0,
      classes: {
        active: "flip-clock-active",
        before: "flip-clock-before",
        flip: "flip",
      },
      factory: !1,
      $el: !1,
      $obj: !1,
      items: [],
      lastDigit: 0,
      constructor: function (a, b, c) {
        (this.factory = a),
          (this.digit = b),
          (this.lastDigit = b),
          (this.$el = this.createList()),
          (this.$obj = this.$el),
          b > 0 && this.select(b),
          this.factory.$el.append(this.$el);
      },
      select: function (a) {
        if (
          ("undefined" == typeof a ? (a = this.digit) : (this.digit = a),
          this.digit != this.lastDigit)
        ) {
          var b = this.$el
            .find("." + this.classes.before)
            .removeClass(this.classes.before);
          this.$el
            .find("." + this.classes.active)
            .removeClass(this.classes.active)
            .addClass(this.classes.before),
            this.appendListItem(this.classes.active, this.digit),
            b.remove(),
            (this.lastDigit = this.digit);
        }
      },
      play: function () {
        this.$el.addClass(this.factory.classes.play);
      },
      stop: function () {
        var a = this;
        setTimeout(function () {
          a.$el.removeClass(a.factory.classes.play);
        }, this.factory.timer.interval);
      },
      createListItem: function (a, b) {
        return [
          '<li class="' + (a ? a : "") + '">',
          '<a href="#">',
          '<div class="up">',
          '<div class="shadow"></div>',
          '<div class="inn">' + (b ? b : "") + "</div>",
          "</div>",
          '<div class="down">',
          '<div class="shadow"></div>',
          '<div class="inn">' + (b ? b : "") + "</div>",
          "</div>",
          "</a>",
          "</li>",
        ].join("");
      },
      appendListItem: function (a, b) {
        var c = this.createListItem(a, b);
        this.$el.append(c);
      },
      createList: function () {
        var b = this.getPrevDigit() ? this.getPrevDigit() : this.digit,
          c = a(
            [
              '<ul class="' +
                this.classes.flip +
                " " +
                (this.factory.running ? this.factory.classes.play : "") +
                '">',
              this.createListItem(this.classes.before, b),
              this.createListItem(this.classes.active, this.digit),
              "</ul>",
            ].join("")
          );
        return c;
      },
      getNextDigit: function () {
        return 9 == this.digit ? 0 : this.digit + 1;
      },
      getPrevDigit: function () {
        return 0 == this.digit ? 9 : this.digit - 1;
      },
    });
  })(jQuery),
  (function (a) {
    "use strict";
    (String.prototype.ucfirst = function () {
      return this.substr(0, 1).toUpperCase() + this.substr(1);
    }),
      (a.fn.FlipClock = function (b, c) {
        return new FlipClock(a(this), b, c);
      }),
      (a.fn.flipClock = function (b, c) {
        return a.fn.FlipClock(b, c);
      });
  })(jQuery),
  (function (a) {
    "use strict";
    FlipClock.Time = FlipClock.Base.extend({
      time: 0,
      factory: !1,
      minimumDigits: 0,
      constructor: function (a, b, c) {
        "object" != typeof c && (c = {}),
          c.minimumDigits || (c.minimumDigits = a.minimumDigits),
          this.base(c),
          (this.factory = a),
          b && (this.time = b);
      },
      convertDigitsToArray: function (a) {
        var b = [];
        a = a.toString();
        for (var c = 0; c < a.length; c++) a[c].match(/^\d*$/g) && b.push(a[c]);
        return b;
      },
      digit: function (a) {
        var b = this.toString(),
          c = b.length;
        return b[c - a] ? b[c - a] : !1;
      },
      digitize: function (b) {
        var c = [];
        if (
          (a.each(b, function (a, b) {
            (b = b.toString()), 1 == b.length && (b = "0" + b);
            for (var d = 0; d < b.length; d++) c.push(b.charAt(d));
          }),
          c.length > this.minimumDigits && (this.minimumDigits = c.length),
          this.minimumDigits > c.length)
        )
          for (var d = c.length; d < this.minimumDigits; d++) c.unshift("0");
        return c;
      },
      getDateObject: function () {
        return this.time instanceof Date
          ? this.time
          : new Date(new Date().getTime() + 1e3 * this.getTimeSeconds());
      },
      getDayCounter: function (a) {
        var b = [this.getDays(), this.getHours(!0), this.getMinutes(!0)];
        return a && b.push(this.getSeconds(!0)), this.digitize(b);
      },
      getDays: function (a) {
        var b = this.getTimeSeconds() / 60 / 60 / 24;
        return a && (b %= 7), Math.floor(b);
      },
      getHourCounter: function () {
        var a = this.digitize([
          this.getHours(),
          this.getMinutes(!0),
          this.getSeconds(!0),
        ]);
        return a;
      },
      getHourly: function () {
        return this.getHourCounter();
      },
      getHours: function (a) {
        var b = this.getTimeSeconds() / 60 / 60;
        return a && (b %= 24), Math.floor(b);
      },
      getMilitaryTime: function (a, b) {
        "undefined" == typeof b && (b = !0), a || (a = this.getDateObject());
        var c = [a.getHours(), a.getMinutes()];
        return b === !0 && c.push(a.getSeconds()), this.digitize(c);
      },
      getMinutes: function (a) {
        var b = this.getTimeSeconds() / 60;
        return a && (b %= 60), Math.floor(b);
      },
      getMinuteCounter: function () {
        var a = this.digitize([this.getMinutes(), this.getSeconds(!0)]);
        return a;
      },
      getTimeSeconds: function (a) {
        return (
          a || (a = new Date()),
          this.time instanceof Date
            ? this.factory.countdown
              ? Math.max(this.time.getTime() / 1e3 - a.getTime() / 1e3, 0)
              : a.getTime() / 1e3 - this.time.getTime() / 1e3
            : this.time
        );
      },
      getTime: function (a, b) {
        "undefined" == typeof b && (b = !0),
          a || (a = this.getDateObject()),
          console.log(a);
        var c = a.getHours(),
          d = [c > 12 ? c - 12 : 0 === c ? 12 : c, a.getMinutes()];
        return b === !0 && d.push(a.getSeconds()), this.digitize(d);
      },
      getSeconds: function (a) {
        var b = this.getTimeSeconds();
        return a && (60 == b ? (b = 0) : (b %= 60)), Math.ceil(b);
      },
      getWeeks: function (a) {
        var b = this.getTimeSeconds() / 60 / 60 / 24 / 7;
        return a && (b %= 52), Math.floor(b);
      },
      removeLeadingZeros: function (b, c) {
        var d = 0,
          e = [];
        return (
          a.each(c, function (a, f) {
            b > a ? (d += parseInt(c[a], 10)) : e.push(c[a]);
          }),
          0 === d ? e : c
        );
      },
      addSeconds: function (a) {
        this.time instanceof Date
          ? this.time.setSeconds(this.time.getSeconds() + a)
          : (this.time += a);
      },
      addSecond: function () {
        this.addSeconds(1);
      },
      subSeconds: function (a) {
        this.time instanceof Date
          ? this.time.setSeconds(this.time.getSeconds() - a)
          : (this.time -= a);
      },
      subSecond: function () {
        this.subSeconds(1);
      },
      toString: function () {
        return this.getTimeSeconds().toString();
      },
    });
  })(jQuery),
  (function (a) {
    "use strict";
    FlipClock.Timer = FlipClock.Base.extend({
      callbacks: {
        destroy: !1,
        create: !1,
        init: !1,
        interval: !1,
        start: !1,
        stop: !1,
        reset: !1,
      },
      count: 0,
      factory: !1,
      interval: 1e3,
      animationRate: 1e3,
      constructor: function (a, b) {
        this.base(b),
          (this.factory = a),
          this.callback(this.callbacks.init),
          this.callback(this.callbacks.create);
      },
      getElapsed: function () {
        return this.count * this.interval;
      },
      getElapsedTime: function () {
        return new Date(this.time + this.getElapsed());
      },
      reset: function (a) {
        clearInterval(this.timer),
          (this.count = 0),
          this._setInterval(a),
          this.callback(this.callbacks.reset);
      },
      start: function (a) {
        (this.factory.running = !0),
          this._createTimer(a),
          this.callback(this.callbacks.start);
      },
      stop: function (a) {
        (this.factory.running = !1),
          this._clearInterval(a),
          this.callback(this.callbacks.stop),
          this.callback(a);
      },
      _clearInterval: function () {
        clearInterval(this.timer);
      },
      _createTimer: function (a) {
        this._setInterval(a);
      },
      _destroyTimer: function (a) {
        this._clearInterval(),
          (this.timer = !1),
          this.callback(a),
          this.callback(this.callbacks.destroy);
      },
      _interval: function (a) {
        this.callback(this.callbacks.interval), this.callback(a), this.count++;
      },
      _setInterval: function (a) {
        var b = this;
        b._interval(a),
          (b.timer = setInterval(function () {
            b._interval(a);
          }, this.interval));
      },
    });
  })(jQuery),
  (function (a) {
    FlipClock.TwentyFourHourClockFace = FlipClock.Face.extend({
      constructor: function (a, b) {
        this.base(a, b);
      },
      build: function (b) {
        var c = this,
          d = this.factory.$el.find("ul");
        this.factory.time.time ||
          ((this.factory.original = new Date()),
          (this.factory.time = new FlipClock.Time(
            this.factory,
            this.factory.original
          )));
        var b = b ? b : this.factory.time.getMilitaryTime(!1, this.showSeconds);
        b.length > d.length &&
          a.each(b, function (a, b) {
            c.createList(b);
          }),
          this.createDivider(),
          this.createDivider(),
          a(this.dividers[0]).insertBefore(
            this.lists[this.lists.length - 2].$el
          ),
          a(this.dividers[1]).insertBefore(
            this.lists[this.lists.length - 4].$el
          ),
          this.base();
      },
      flip: function (a, b) {
        this.autoIncrement(),
          (a = a ? a : this.factory.time.getMilitaryTime(!1, this.showSeconds)),
          this.base(a, b);
      },
    });
  })(jQuery),
  (function (a) {
    FlipClock.CounterFace = FlipClock.Face.extend({
      shouldAutoIncrement: !1,
      constructor: function (a, b) {
        "object" != typeof b && (b = {}),
          (a.autoStart = b.autoStart ? !0 : !1),
          b.autoStart && (this.shouldAutoIncrement = !0),
          (a.increment = function () {
            (a.countdown = !1), a.setTime(a.getTime().getTimeSeconds() + 1);
          }),
          (a.decrement = function () {
            a.countdown = !0;
            var b = a.getTime().getTimeSeconds();
            b > 0 && a.setTime(b - 1);
          }),
          (a.setValue = function (b) {
            a.setTime(b);
          }),
          (a.setCounter = function (b) {
            a.setTime(b);
          }),
          this.base(a, b);
      },
      build: function () {
        var b = this,
          c = this.factory.$el.find("ul"),
          d = this.factory.getTime().digitize([this.factory.getTime().time]);
        d.length > c.length &&
          a.each(d, function (a, c) {
            var d = b.createList(c);
            d.select(c);
          }),
          a.each(this.lists, function (a, b) {
            b.play();
          }),
          this.base();
      },
      flip: function (a, b) {
        this.shouldAutoIncrement && this.autoIncrement(),
          a ||
            (a = this.factory
              .getTime()
              .digitize([this.factory.getTime().time])),
          this.base(a, b);
      },
      reset: function () {
        (this.factory.time = new FlipClock.Time(
          this.factory,
          this.factory.original ? Math.round(this.factory.original) : 0
        )),
          this.flip();
      },
    });
  })(jQuery),
  (function (a) {
    FlipClock.DailyCounterFace = FlipClock.Face.extend({
      showSeconds: !0,
      constructor: function (a, b) {
        this.base(a, b);
      },
      build: function (b) {
        var c = this,
          d = this.factory.$el.find("ul"),
          e = 0;
        (b = b ? b : this.factory.time.getDayCounter(this.showSeconds)),
          b.length > d.length &&
            a.each(b, function (a, b) {
              c.createList(b);
            }),
          this.showSeconds
            ? a(this.createDivider("Seconds")).insertBefore(
                this.lists[this.lists.length - 2].$el
              )
            : (e = 2),
          a(this.createDivider("Minutes")).insertBefore(
            this.lists[this.lists.length - 4 + e].$el
          ),
          a(this.createDivider("Hours")).insertBefore(
            this.lists[this.lists.length - 6 + e].$el
          ),
          a(this.createDivider("Days", !0)).insertBefore(this.lists[0].$el),
          this.base();
      },
      flip: function (a, b) {
        a || (a = this.factory.time.getDayCounter(this.showSeconds)),
          this.autoIncrement(),
          this.base(a, b);
      },
    });
  })(jQuery),
  (function (a) {
    FlipClock.HourlyCounterFace = FlipClock.Face.extend({
      constructor: function (a, b) {
        this.base(a, b);
      },
      build: function (b, c) {
        var d = this,
          e = this.factory.$el.find("ul");
        (c = c ? c : this.factory.time.getHourCounter()),
          c.length > e.length &&
            a.each(c, function (a, b) {
              d.createList(b);
            }),
          a(this.createDivider("Seconds")).insertBefore(
            this.lists[this.lists.length - 2].$el
          ),
          a(this.createDivider("Minutes")).insertBefore(
            this.lists[this.lists.length - 4].$el
          ),
          b ||
            a(this.createDivider("Hours", !0)).insertBefore(this.lists[0].$el),
          this.base();
      },
      flip: function (a, b) {
        a || (a = this.factory.time.getHourCounter()),
          this.autoIncrement(),
          this.base(a, b);
      },
      appendDigitToClock: function (a) {
        this.base(a), this.dividers[0].insertAfter(this.dividers[0].next());
      },
    });
  })(jQuery),
  (function (a) {
    FlipClock.MinuteCounterFace = FlipClock.HourlyCounterFace.extend({
      clearExcessDigits: !1,
      constructor: function (a, b) {
        this.base(a, b);
      },
      build: function () {
        this.base(!0, this.factory.time.getMinuteCounter());
      },
      flip: function (a, b) {
        a || (a = this.factory.time.getMinuteCounter()), this.base(a, b);
      },
    });
  })(jQuery),
  (function (a) {
    FlipClock.TwelveHourClockFace = FlipClock.TwentyFourHourClockFace.extend({
      meridium: !1,
      meridiumText: "AM",
      build: function () {
        var b = this.factory.time.getTime(!1, this.showSeconds);
        this.base(b),
          (this.meridiumText = this.getMeridium()),
          (this.meridium = a(
            [
              '<ul class="flip-clock-meridium">',
              "<li>",
              '<a href="#">' + this.meridiumText + "</a>",
              "</li>",
              "</ul>",
            ].join("")
          )),
          this.meridium.insertAfter(this.lists[this.lists.length - 1].$el);
      },
      flip: function (a, b) {
        this.meridiumText != this.getMeridium() &&
          ((this.meridiumText = this.getMeridium()),
          this.meridium.find("a").html(this.meridiumText)),
          this.base(this.factory.time.getTime(!1, this.showSeconds), b);
      },
      getMeridium: function () {
        return new Date().getHours() >= 12 ? "PM" : "AM";
      },
      isPM: function () {
        return "PM" == this.getMeridium() ? !0 : !1;
      },
      isAM: function () {
        return "AM" == this.getMeridium() ? !0 : !1;
      },
    });
  })(jQuery),
  (function (a) {
    (FlipClock.Lang.Arabic = {
      years: "سنوات",
      months: "شهور",
      days: "أيام",
      hours: "ساعات",
      minutes: "دقائق",
      seconds: "ثواني",
    }),
      (FlipClock.Lang.ar = FlipClock.Lang.Arabic),
      (FlipClock.Lang["ar-ar"] = FlipClock.Lang.Arabic),
      (FlipClock.Lang.arabic = FlipClock.Lang.Arabic);
  })(jQuery),
  (function (a) {
    (FlipClock.Lang.Danish = {
      years: "År",
      months: "Måneder",
      days: "Dage",
      hours: "Timer",
      minutes: "Minutter",
      seconds: "Sekunder",
    }),
      (FlipClock.Lang.da = FlipClock.Lang.Danish),
      (FlipClock.Lang["da-dk"] = FlipClock.Lang.Danish),
      (FlipClock.Lang.danish = FlipClock.Lang.Danish);
  })(jQuery),
  (function (a) {
    (FlipClock.Lang.German = {
      years: "Jahre",
      months: "Monate",
      days: "Tage",
      hours: "Stunden",
      minutes: "Minuten",
      seconds: "Sekunden",
    }),
      (FlipClock.Lang.de = FlipClock.Lang.German),
      (FlipClock.Lang["de-de"] = FlipClock.Lang.German),
      (FlipClock.Lang.german = FlipClock.Lang.German);
  })(jQuery),
  (function (a) {
    (FlipClock.Lang.English = {
      years: "Years",
      months: "Months",
      days: "Days",
      hours: "Hours",
      minutes: "Minutes",
      seconds: "Seconds",
    }),
      (FlipClock.Lang.en = FlipClock.Lang.English),
      (FlipClock.Lang["en-us"] = FlipClock.Lang.English),
      (FlipClock.Lang.english = FlipClock.Lang.English);
  })(jQuery),
  (function (a) {
    (FlipClock.Lang.Spanish = {
      years: "Años",
      months: "Meses",
      days: "Días",
      hours: "Horas",
      minutes: "Minutos",
      seconds: "Segundos",
    }),
      (FlipClock.Lang.es = FlipClock.Lang.Spanish),
      (FlipClock.Lang["es-es"] = FlipClock.Lang.Spanish),
      (FlipClock.Lang.spanish = FlipClock.Lang.Spanish);
  })(jQuery),
  (function (a) {
    (FlipClock.Lang.Finnish = {
      years: "Vuotta",
      months: "Kuukautta",
      days: "Päivää",
      hours: "Tuntia",
      minutes: "Minuuttia",
      seconds: "Sekuntia",
    }),
      (FlipClock.Lang.fi = FlipClock.Lang.Finnish),
      (FlipClock.Lang["fi-fi"] = FlipClock.Lang.Finnish),
      (FlipClock.Lang.finnish = FlipClock.Lang.Finnish);
  })(jQuery),
  (function (a) {
    (FlipClock.Lang.French = {
      years: "Ans",
      months: "Mois",
      days: "Jours",
      hours: "Heures",
      minutes: "Minutes",
      seconds: "Secondes",
    }),
      (FlipClock.Lang.fr = FlipClock.Lang.French),
      (FlipClock.Lang["fr-ca"] = FlipClock.Lang.French),
      (FlipClock.Lang.french = FlipClock.Lang.French);
  })(jQuery),
  (function (a) {
    (FlipClock.Lang.Italian = {
      years: "Anni",
      months: "Mesi",
      days: "Giorni",
      hours: "Ore",
      minutes: "Minuti",
      seconds: "Secondi",
    }),
      (FlipClock.Lang.it = FlipClock.Lang.Italian),
      (FlipClock.Lang["it-it"] = FlipClock.Lang.Italian),
      (FlipClock.Lang.italian = FlipClock.Lang.Italian);
  })(jQuery),
  (function (a) {
    (FlipClock.Lang.Latvian = {
      years: "Gadi",
      months: "Mēneši",
      days: "Dienas",
      hours: "Stundas",
      minutes: "Minūtes",
      seconds: "Sekundes",
    }),
      (FlipClock.Lang.lv = FlipClock.Lang.Latvian),
      (FlipClock.Lang["lv-lv"] = FlipClock.Lang.Latvian),
      (FlipClock.Lang.latvian = FlipClock.Lang.Latvian);
  })(jQuery),
  (function (a) {
    (FlipClock.Lang.Dutch = {
      years: "Jaren",
      months: "Maanden",
      days: "Dagen",
      hours: "Uren",
      minutes: "Minuten",
      seconds: "Seconden",
    }),
      (FlipClock.Lang.nl = FlipClock.Lang.Dutch),
      (FlipClock.Lang["nl-be"] = FlipClock.Lang.Dutch),
      (FlipClock.Lang.dutch = FlipClock.Lang.Dutch);
  })(jQuery),
  (function (a) {
    (FlipClock.Lang.Norwegian = {
      years: "År",
      months: "Måneder",
      days: "Dager",
      hours: "Timer",
      minutes: "Minutter",
      seconds: "Sekunder",
    }),
      (FlipClock.Lang.no = FlipClock.Lang.Norwegian),
      (FlipClock.Lang.nb = FlipClock.Lang.Norwegian),
      (FlipClock.Lang["no-nb"] = FlipClock.Lang.Norwegian),
      (FlipClock.Lang.norwegian = FlipClock.Lang.Norwegian);
  })(jQuery),
  (function (a) {
    (FlipClock.Lang.Portuguese = {
      years: "Anos",
      months: "Meses",
      days: "Dias",
      hours: "Horas",
      minutes: "Minutos",
      seconds: "Segundos",
    }),
      (FlipClock.Lang.pt = FlipClock.Lang.Portuguese),
      (FlipClock.Lang["pt-br"] = FlipClock.Lang.Portuguese),
      (FlipClock.Lang.portuguese = FlipClock.Lang.Portuguese);
  })(jQuery),
  (function (a) {
    (FlipClock.Lang.Russian = {
      years: "лет",
      months: "месяцев",
      days: "дней",
      hours: "часов",
      minutes: "минут",
      seconds: "секунд",
    }),
      (FlipClock.Lang.ru = FlipClock.Lang.Russian),
      (FlipClock.Lang["ru-ru"] = FlipClock.Lang.Russian),
      (FlipClock.Lang.russian = FlipClock.Lang.Russian);
  })(jQuery),
  (function (a) {
    (FlipClock.Lang.Swedish = {
      years: "År",
      months: "Månader",
      days: "Dagar",
      hours: "Timmar",
      minutes: "Minuter",
      seconds: "Sekunder",
    }),
      (FlipClock.Lang.sv = FlipClock.Lang.Swedish),
      (FlipClock.Lang["sv-se"] = FlipClock.Lang.Swedish),
      (FlipClock.Lang.swedish = FlipClock.Lang.Swedish);
  })(jQuery),
  (function (a) {
    (FlipClock.Lang.Chinese = {
      years: "年",
      months: "月",
      days: "日",
      hours: "时",
      minutes: "分",
      seconds: "秒",
    }),
      (FlipClock.Lang.zh = FlipClock.Lang.Chinese),
      (FlipClock.Lang["zh-cn"] = FlipClock.Lang.Chinese),
      (FlipClock.Lang.chinese = FlipClock.Lang.Chinese);
  })(jQuery);

/*
 * Pause jQuery plugin v0.1
 *
 * Copyright 2010 by Tobia Conforto <tobia.conforto@gmail.com>
 *
 * Based on Pause-resume-animation jQuery plugin by Joe Weitzel
 *
 * This program is free software; you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation; either version 2 of the License, or(at your option)
 * any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE. See the GNU General Public License for
 * more details.
 *
 * You should have received a copy of the GNU General Public License along with
 * this program; if not, write to the Free Software Foundation, Inc., 51
 * Franklin Street, Fifth Floor, Boston, MA 02110-1301, USA.
 */
(function () {
  var e = jQuery,
    f = "jQuery.pause",
    d = 1,
    b = e.fn.animate,
    a = {};
  function c() {
    return new Date().getTime();
  }
  e.fn.animate = function (k, h, j, i) {
    var g = e.speed(h, j, i);
    g.complete = g.old;
    return this.each(function () {
      if (!this[f]) {
        this[f] = d++;
      }
      var l = e.extend({}, g);
      b.apply(e(this), [k, e.extend({}, l)]);
      a[this[f]] = { run: true, prop: k, opt: l, start: c(), done: 0 };
    });
  };
  e.fn.pause = function () {
    return this.each(function () {
      if (!this[f]) {
        this[f] = d++;
      }
      var g = a[this[f]];
      if (g && g.run) {
        g.done += c() - g.start;
        if (g.done > g.opt.duration) {
          delete a[this[f]];
        } else {
          e(this).stop();
          g.run = false;
        }
      }
    });
  };
  e.fn.resume = function () {
    return this.each(function () {
      if (!this[f]) {
        this[f] = d++;
      }
      var g = a[this[f]];
      if (g && !g.run) {
        g.opt.duration -= g.done;
        g.done = 0;
        g.run = true;
        g.start = c();
        b.apply(e(this), [g.prop, e.extend({}, g.opt)]);
      }
    });
  };
})();

/**
 * jQuery.marquee - scrolling text like old marquee element
 * @author Aamir Afridi - aamirafridi(at)gmail(dot)com / http://aamirafridi.com/jquery/jquery-marquee-plugin
 */
(function ($) {
  $.fn.marquee = function (options) {
    return this.each(function () {
      var o = $.extend({}, $.fn.marquee.defaults, options),
        $this = $(this),
        $marqueeWrapper,
        containerWidth,
        animationCss,
        verticalDir,
        elWidth,
        loopCount = 3,
        playState = "animation-play-state",
        css3AnimationIsSupported = !1,
        _prefixedEvent = function (element, type, callback) {
          var pfx = ["webkit", "moz", "MS", "o", ""];
          for (var p = 0; p < pfx.length; p++) {
            if (!pfx[p]) type = type.toLowerCase();
            element.addEventListener(pfx[p] + type, callback, !1);
          }
        },
        _objToString = function (obj) {
          var tabjson = [];
          for (var p in obj) {
            if (obj.hasOwnProperty(p)) {
              tabjson.push(p + ":" + obj[p]);
            }
          }
          tabjson.push();
          return "{" + tabjson.join(",") + "}";
        },
        _startAnimationWithDelay = function () {
          $this.timer = setTimeout(animate, o.delayBeforeStart);
        },
        methods = {
          pause: function () {
            if (css3AnimationIsSupported && o.allowCss3Support) {
              $marqueeWrapper.css(playState, "paused");
            } else {
              if ($.fn.pause) {
                $marqueeWrapper.pause();
              }
            }
            $this.data("runningStatus", "paused");
            $this.trigger("paused");
          },
          resume: function () {
            if (css3AnimationIsSupported && o.allowCss3Support) {
              $marqueeWrapper.css(playState, "running");
            } else {
              if ($.fn.resume) {
                $marqueeWrapper.resume();
              }
            }
            $this.data("runningStatus", "resumed");
            $this.trigger("resumed");
          },
          toggle: function () {
            methods[
              $this.data("runningStatus") == "resumed" ? "pause" : "resume"
            ]();
          },
          destroy: function () {
            clearTimeout($this.timer);
            $this.find("*").addBack().off();
            $this.html($this.find(".js-marquee:first").html());
          },
        };
      if (typeof options === "string") {
        if ($.isFunction(methods[options])) {
          if (!$marqueeWrapper) {
            $marqueeWrapper = $this.find(".js-marquee-wrapper");
          }
          if ($this.data("css3AnimationIsSupported") === !0) {
            css3AnimationIsSupported = !0;
          }
          methods[options]();
        }
        return;
      }
      var dataAttributes = {},
        attr;
      $.each(o, function (key, value) {
        attr = $this.attr("data-" + key);
        if (typeof attr !== "undefined") {
          switch (attr) {
            case "true":
              attr = !0;
              break;
            case "false":
              attr = !1;
              break;
          }
          o[key] = attr;
        }
      });
      if (o.speed) {
        o.duration = (parseInt($this.width(), 10) / o.speed) * 1000;
      }
      verticalDir = o.direction == "up" || o.direction == "down";
      o.gap = o.duplicated ? parseInt(o.gap) : 0;
      $this.wrapInner('<div class="js-marquee"></div>');
      var $el = $this
        .find(".js-marquee")
        .css({ "margin-right": o.gap, float: "left" });
      if (o.duplicated) {
        $el.clone(!0).appendTo($this);
      }
      $this.wrapInner(
        '<div style="width:100000px" class="js-marquee-wrapper"></div>'
      );
      $marqueeWrapper = $this.find(".js-marquee-wrapper");
      if (verticalDir) {
        var containerHeight = $this.height();
        $marqueeWrapper.removeAttr("style");
        $this.height(containerHeight);
        $this
          .find(".js-marquee")
          .css({ float: "none", "margin-bottom": o.gap, "margin-right": 0 });
        if (o.duplicated)
          $this.find(".js-marquee:last").css({ "margin-bottom": 0 });
        var elHeight = $this.find(".js-marquee:first").height() + o.gap;
        if (o.startVisible && !o.duplicated) {
          o._completeDuration =
            ((parseInt(elHeight, 10) + parseInt(containerHeight, 10)) /
              parseInt(containerHeight, 10)) *
            o.duration;
          o.duration =
            (parseInt(elHeight, 10) / parseInt(containerHeight, 10)) *
            o.duration;
        } else {
          o.duration =
            ((parseInt(elHeight, 10) + parseInt(containerHeight, 10)) /
              parseInt(containerHeight, 10)) *
            o.duration;
        }
      } else {
        elWidth = $this.find(".js-marquee:first").width() + o.gap;
        containerWidth = $this.width();
        if (o.startVisible && !o.duplicated) {
          o._completeDuration =
            ((parseInt(elWidth, 10) + parseInt(containerWidth, 10)) /
              parseInt(containerWidth, 10)) *
            o.duration;
          o.duration =
            (parseInt(elWidth, 10) / parseInt(containerWidth, 10)) * o.duration;
        } else {
          o.duration =
            ((parseInt(elWidth, 10) + parseInt(containerWidth, 10)) /
              parseInt(containerWidth, 10)) *
            o.duration;
        }
      }
      if (o.duplicated) {
        o.duration = o.duration / 2;
      }
      if (o.allowCss3Support) {
        var elm = document.body || document.createElement("div"),
          animationName =
            "marqueeAnimation-" + Math.floor(Math.random() * 10000000),
          domPrefixes = "Webkit Moz O ms Khtml".split(" "),
          animationString = "animation",
          animationCss3Str = "",
          keyframeString = "";
        if (elm.style.animation !== undefined) {
          keyframeString = "@keyframes " + animationName + " ";
          css3AnimationIsSupported = !0;
        }
        if (css3AnimationIsSupported === !1) {
          for (var i = 0; i < domPrefixes.length; i++) {
            if (elm.style[domPrefixes[i] + "AnimationName"] !== undefined) {
              var prefix = "-" + domPrefixes[i].toLowerCase() + "-";
              animationString = prefix + animationString;
              playState = prefix + playState;
              keyframeString =
                "@" + prefix + "keyframes " + animationName + " ";
              css3AnimationIsSupported = !0;
              break;
            }
          }
        }
        if (css3AnimationIsSupported) {
          animationCss3Str =
            animationName +
            " " +
            o.duration / 1000 +
            "s " +
            o.delayBeforeStart / 1000 +
            "s infinite " +
            o.css3easing;
          $this.data("css3AnimationIsSupported", !0);
        }
      }
      var _rePositionVertically = function () {
          $marqueeWrapper.css(
            "transform",
            "translateY(" +
              (o.direction == "up"
                ? containerHeight + "px"
                : "-" + elHeight + "px") +
              ")"
          );
        },
        _rePositionHorizontally = function () {
          $marqueeWrapper.css(
            "transform",
            "translateX(" +
              (o.direction == "left"
                ? containerWidth + "px"
                : "-" + elWidth + "px") +
              ")"
          );
        };
      if (o.duplicated) {
        if (verticalDir) {
          if (o.startVisible) {
            $marqueeWrapper.css("transform", "translateY(0)");
          } else {
            $marqueeWrapper.css(
              "transform",
              "translateY(" +
                (o.direction == "up"
                  ? containerHeight + "px"
                  : "-" + (elHeight * 2 - o.gap) + "px") +
                ")"
            );
          }
        } else {
          if (o.startVisible) {
            $marqueeWrapper.css("transform", "translateX(0)");
          } else {
            $marqueeWrapper.css(
              "transform",
              "translateX(" +
                (o.direction == "left"
                  ? containerWidth + "px"
                  : "-" + (elWidth * 2 - o.gap) + "px") +
                ")"
            );
          }
        }
        if (!o.startVisible) {
          loopCount = 1;
        }
      } else if (o.startVisible) {
        loopCount = 2;
      } else {
        if (verticalDir) {
          _rePositionVertically();
        } else {
          _rePositionHorizontally();
        }
      }
      var animate = function () {
        if (o.duplicated) {
          if (loopCount === 1) {
            o._originalDuration = o.duration;
            if (verticalDir) {
              o.duration =
                o.direction == "up"
                  ? o.duration + containerHeight / (elHeight / o.duration)
                  : o.duration * 2;
            } else {
              o.duration =
                o.direction == "left"
                  ? o.duration + containerWidth / (elWidth / o.duration)
                  : o.duration * 2;
            }
            if (animationCss3Str) {
              animationCss3Str =
                animationName +
                " " +
                o.duration / 1000 +
                "s " +
                o.delayBeforeStart / 1000 +
                "s " +
                o.css3easing;
            }
            loopCount++;
          } else if (loopCount === 2) {
            o.duration = o._originalDuration;
            if (animationCss3Str) {
              animationName = animationName + "0";
              keyframeString = $.trim(keyframeString) + "0 ";
              animationCss3Str =
                animationName +
                " " +
                o.duration / 1000 +
                "s 0s infinite " +
                o.css3easing;
            }
            loopCount++;
          }
        }
        if (verticalDir) {
          if (o.duplicated) {
            if (loopCount > 2) {
              $marqueeWrapper.css(
                "transform",
                "translateY(" +
                  (o.direction == "up" ? 0 : "-" + elHeight + "px") +
                  ")"
              );
            }
            animationCss = {
              transform:
                "translateY(" +
                (o.direction == "up" ? "-" + elHeight + "px" : 0) +
                ")",
            };
          } else if (o.startVisible) {
            if (loopCount === 2) {
              if (animationCss3Str) {
                animationCss3Str =
                  animationName +
                  " " +
                  o.duration / 1000 +
                  "s " +
                  o.delayBeforeStart / 1000 +
                  "s " +
                  o.css3easing;
              }
              animationCss = {
                transform:
                  "translateY(" +
                  (o.direction == "up"
                    ? "-" + elHeight + "px"
                    : containerHeight + "px") +
                  ")",
              };
              loopCount++;
            } else if (loopCount === 3) {
              o.duration = o._completeDuration;
              if (animationCss3Str) {
                animationName = animationName + "0";
                keyframeString = $.trim(keyframeString) + "0 ";
                animationCss3Str =
                  animationName +
                  " " +
                  o.duration / 1000 +
                  "s 0s infinite " +
                  o.css3easing;
              }
              _rePositionVertically();
            }
          } else {
            _rePositionVertically();
            animationCss = {
              transform:
                "translateY(" +
                (o.direction == "up"
                  ? "-" + $marqueeWrapper.height() + "px"
                  : containerHeight + "px") +
                ")",
            };
          }
        } else {
          if (o.duplicated) {
            if (loopCount > 2) {
              $marqueeWrapper.css(
                "transform",
                "translateX(" +
                  (o.direction == "left" ? 0 : "-" + elWidth + "px") +
                  ")"
              );
            }
            animationCss = {
              transform:
                "translateX(" +
                (o.direction == "left" ? "-" + elWidth + "px" : 0) +
                ")",
            };
          } else if (o.startVisible) {
            if (loopCount === 2) {
              if (animationCss3Str) {
                animationCss3Str =
                  animationName +
                  " " +
                  o.duration / 1000 +
                  "s " +
                  o.delayBeforeStart / 1000 +
                  "s " +
                  o.css3easing;
              }
              animationCss = {
                transform:
                  "translateX(" +
                  (o.direction == "left"
                    ? "-" + elWidth + "px"
                    : containerWidth + "px") +
                  ")",
              };
              loopCount++;
            } else if (loopCount === 3) {
              o.duration = o._completeDuration;
              if (animationCss3Str) {
                animationName = animationName + "0";
                keyframeString = $.trim(keyframeString) + "0 ";
                animationCss3Str =
                  animationName +
                  " " +
                  o.duration / 1000 +
                  "s 0s infinite " +
                  o.css3easing;
              }
              _rePositionHorizontally();
            }
          } else {
            _rePositionHorizontally();
            animationCss = {
              transform:
                "translateX(" +
                (o.direction == "left"
                  ? "-" + elWidth + "px"
                  : containerWidth + "px") +
                ")",
            };
          }
        }
        $this.trigger("beforeStarting");
        if (css3AnimationIsSupported) {
          $marqueeWrapper.css(animationString, animationCss3Str);
          var keyframeCss =
              keyframeString + " { 100%  " + _objToString(animationCss) + "}",
            $styles = $marqueeWrapper.find("style");
          if ($styles.length !== 0) {
            $styles.filter(":last").html(keyframeCss);
          } else {
            $("head").append("<style>" + keyframeCss + "</style>");
          }
          _prefixedEvent($marqueeWrapper[0], "AnimationIteration", function () {
            $this.trigger("finished");
          });
          _prefixedEvent($marqueeWrapper[0], "AnimationEnd", function () {
            animate();
            $this.trigger("finished");
          });
        } else {
          $marqueeWrapper.animate(
            animationCss,
            o.duration,
            o.easing,
            function () {
              $this.trigger("finished");
              if (o.pauseOnCycle) {
                _startAnimationWithDelay();
              } else {
                animate();
              }
            }
          );
        }
        $this.data("runningStatus", "resumed");
      };
      $this.on("pause", methods.pause);
      $this.on("resume", methods.resume);
      if (o.pauseOnHover) {
        $this.on("mouseenter", methods.pause);
        $this.on("mouseleave", methods.resume);
      }
      if (css3AnimationIsSupported && o.allowCss3Support) {
        animate();
      } else {
        _startAnimationWithDelay();
      }
    });
  };
  $.fn.marquee.defaults = {
    allowCss3Support: !0,
    css3easing: "linear",
    easing: "linear",
    delayBeforeStart: 1000,
    direction: "left",
    duplicated: !1,
    duration: 5000,
    speed: 0,
    gap: 20,
    pauseOnCycle: !1,
    pauseOnHover: !1,
    startVisible: !1,
  };
})(jQuery);

/*
 countdown.js v2.6.0 http://countdownjs.org
 Copyright (c)2006-2014 Stephen M. McKamey.
 Licensed under The MIT License.
*/
var module,
  countdown = (function (v) {
    function A(a, b) {
      var c = a.getTime();
      a.setMonth(a.getMonth() + b);
      return Math.round((a.getTime() - c) / 864e5);
    }
    function w(a) {
      var b = a.getTime(),
        c = new Date(b);
      c.setMonth(a.getMonth() + 1);
      return Math.round((c.getTime() - b) / 864e5);
    }
    function x(a, b) {
      b =
        b instanceof Date || (null !== b && isFinite(b))
          ? new Date(+b)
          : new Date();
      if (!a) return b;
      var c = +a.value || 0;
      if (c) return b.setTime(b.getTime() + c), b;
      (c = +a.milliseconds || 0) && b.setMilliseconds(b.getMilliseconds() + c);
      (c = +a.seconds || 0) && b.setSeconds(b.getSeconds() + c);
      (c = +a.minutes || 0) && b.setMinutes(b.getMinutes() + c);
      (c = +a.hours || 0) && b.setHours(b.getHours() + c);
      (c = +a.weeks || 0) && (c *= 7);
      (c += +a.days || 0) && b.setDate(b.getDate() + c);
      (c = +a.months || 0) && b.setMonth(b.getMonth() + c);
      (c = +a.millennia || 0) && (c *= 10);
      (c += +a.centuries || 0) && (c *= 10);
      (c += +a.decades || 0) && (c *= 10);
      (c += +a.years || 0) && b.setFullYear(b.getFullYear() + c);
      return b;
    }
    function D(a, b) {
      return y(a) + (1 === a ? p[b] : q[b]);
    }
    function n() {}
    function k(a, b, c, e, l, d) {
      0 <= a[c] && ((b += a[c]), delete a[c]);
      b /= l;
      if (1 >= b + 1) return 0;
      if (0 <= a[e]) {
        a[e] = +(a[e] + b).toFixed(d);
        switch (e) {
          case "seconds":
            if (60 !== a.seconds || isNaN(a.minutes)) break;
            a.minutes++;
            a.seconds = 0;
          case "minutes":
            if (60 !== a.minutes || isNaN(a.hours)) break;
            a.hours++;
            a.minutes = 0;
          case "hours":
            if (24 !== a.hours || isNaN(a.days)) break;
            a.days++;
            a.hours = 0;
          case "days":
            if (7 !== a.days || isNaN(a.weeks)) break;
            a.weeks++;
            a.days = 0;
          case "weeks":
            if (a.weeks !== w(a.refMonth) / 7 || isNaN(a.months)) break;
            a.months++;
            a.weeks = 0;
          case "months":
            if (12 !== a.months || isNaN(a.years)) break;
            a.years++;
            a.months = 0;
          case "years":
            if (10 !== a.years || isNaN(a.decades)) break;
            a.decades++;
            a.years = 0;
          case "decades":
            if (10 !== a.decades || isNaN(a.centuries)) break;
            a.centuries++;
            a.decades = 0;
          case "centuries":
            if (10 !== a.centuries || isNaN(a.millennia)) break;
            a.millennia++;
            a.centuries = 0;
        }
        return 0;
      }
      return b;
    }
    function B(a, b, c, e, l, d) {
      var f = new Date();
      a.start = b = b || f;
      a.end = c = c || f;
      a.units = e;
      a.value = c.getTime() - b.getTime();
      0 > a.value && ((f = c), (c = b), (b = f));
      a.refMonth = new Date(b.getFullYear(), b.getMonth(), 15, 12, 0, 0);
      try {
        a.millennia = 0;
        a.centuries = 0;
        a.decades = 0;
        a.years = c.getFullYear() - b.getFullYear();
        a.months = c.getMonth() - b.getMonth();
        a.weeks = 0;
        a.days = c.getDate() - b.getDate();
        a.hours = c.getHours() - b.getHours();
        a.minutes = c.getMinutes() - b.getMinutes();
        a.seconds = c.getSeconds() - b.getSeconds();
        a.milliseconds = c.getMilliseconds() - b.getMilliseconds();
        var g;
        0 > a.milliseconds
          ? ((g = s(-a.milliseconds / 1e3)),
            (a.seconds -= g),
            (a.milliseconds += 1e3 * g))
          : 1e3 <= a.milliseconds &&
            ((a.seconds += m(a.milliseconds / 1e3)), (a.milliseconds %= 1e3));
        0 > a.seconds
          ? ((g = s(-a.seconds / 60)), (a.minutes -= g), (a.seconds += 60 * g))
          : 60 <= a.seconds &&
            ((a.minutes += m(a.seconds / 60)), (a.seconds %= 60));
        0 > a.minutes
          ? ((g = s(-a.minutes / 60)), (a.hours -= g), (a.minutes += 60 * g))
          : 60 <= a.minutes &&
            ((a.hours += m(a.minutes / 60)), (a.minutes %= 60));
        0 > a.hours
          ? ((g = s(-a.hours / 24)), (a.days -= g), (a.hours += 24 * g))
          : 24 <= a.hours && ((a.days += m(a.hours / 24)), (a.hours %= 24));
        for (; 0 > a.days; ) a.months--, (a.days += A(a.refMonth, 1));
        7 <= a.days && ((a.weeks += m(a.days / 7)), (a.days %= 7));
        0 > a.months
          ? ((g = s(-a.months / 12)), (a.years -= g), (a.months += 12 * g))
          : 12 <= a.months && ((a.years += m(a.months / 12)), (a.months %= 12));
        10 <= a.years &&
          ((a.decades += m(a.years / 10)),
          (a.years %= 10),
          10 <= a.decades &&
            ((a.centuries += m(a.decades / 10)),
            (a.decades %= 10),
            10 <= a.centuries &&
              ((a.millennia += m(a.centuries / 10)), (a.centuries %= 10))));
        b = 0;
        !(e & 1024) || b >= l
          ? ((a.centuries += 10 * a.millennia), delete a.millennia)
          : a.millennia && b++;
        !(e & 512) || b >= l
          ? ((a.decades += 10 * a.centuries), delete a.centuries)
          : a.centuries && b++;
        !(e & 256) || b >= l
          ? ((a.years += 10 * a.decades), delete a.decades)
          : a.decades && b++;
        !(e & 128) || b >= l
          ? ((a.months += 12 * a.years), delete a.years)
          : a.years && b++;
        !(e & 64) || b >= l
          ? (a.months && (a.days += A(a.refMonth, a.months)),
            delete a.months,
            7 <= a.days && ((a.weeks += m(a.days / 7)), (a.days %= 7)))
          : a.months && b++;
        !(e & 32) || b >= l
          ? ((a.days += 7 * a.weeks), delete a.weeks)
          : a.weeks && b++;
        !(e & 16) || b >= l
          ? ((a.hours += 24 * a.days), delete a.days)
          : a.days && b++;
        !(e & 8) || b >= l
          ? ((a.minutes += 60 * a.hours), delete a.hours)
          : a.hours && b++;
        !(e & 4) || b >= l
          ? ((a.seconds += 60 * a.minutes), delete a.minutes)
          : a.minutes && b++;
        !(e & 2) || b >= l
          ? ((a.milliseconds += 1e3 * a.seconds), delete a.seconds)
          : a.seconds && b++;
        if (!(e & 1) || b >= l) {
          var h = k(a, 0, "milliseconds", "seconds", 1e3, d);
          if (
            h &&
            (h = k(a, h, "seconds", "minutes", 60, d)) &&
            (h = k(a, h, "minutes", "hours", 60, d)) &&
            (h = k(a, h, "hours", "days", 24, d)) &&
            (h = k(a, h, "days", "weeks", 7, d)) &&
            (h = k(a, h, "weeks", "months", w(a.refMonth) / 7, d))
          ) {
            e = h;
            var n,
              p = a.refMonth,
              q = p.getTime(),
              r = new Date(q);
            r.setFullYear(p.getFullYear() + 1);
            n = Math.round((r.getTime() - q) / 864e5);
            if ((h = k(a, e, "months", "years", n / w(a.refMonth), d)))
              if ((h = k(a, h, "years", "decades", 10, d)))
                if ((h = k(a, h, "decades", "centuries", 10, d)))
                  if ((h = k(a, h, "centuries", "millennia", 10, d)))
                    throw Error("Fractional unit overflow");
          }
        }
      } finally {
        delete a.refMonth;
      }
      return a;
    }
    function d(a, b, c, e, d) {
      var f;
      c = +c || 222;
      e = 0 < e ? e : NaN;
      d = 0 < d ? (20 > d ? Math.round(d) : 20) : 0;
      var k = null;
      "function" === typeof a
        ? ((f = a), (a = null))
        : a instanceof Date ||
          (null !== a && isFinite(a)
            ? (a = new Date(+a))
            : ("object" === typeof k && (k = a), (a = null)));
      var g = null;
      "function" === typeof b
        ? ((f = b), (b = null))
        : b instanceof Date ||
          (null !== b && isFinite(b)
            ? (b = new Date(+b))
            : ("object" === typeof b && (g = b), (b = null)));
      k && (a = x(k, b));
      g && (b = x(g, a));
      if (!a && !b) return new n();
      if (!f) return B(new n(), a, b, c, e, d);
      var k =
          c & 1
            ? 1e3 / 30
            : c & 2
            ? 1e3
            : c & 4
            ? 6e4
            : c & 8
            ? 36e5
            : c & 16
            ? 864e5
            : 6048e5,
        h,
        g = function () {
          f(B(new n(), a, b, c, e, d), h);
        };
      g();
      return (h = setInterval(g, k));
    }
    var s = Math.ceil,
      m = Math.floor,
      p,
      q,
      r,
      t,
      u,
      f,
      y,
      z;
    n.prototype.toString = function (a) {
      var b = z(this),
        c = b.length;
      if (!c) return a ? "" + a : u;
      if (1 === c) return b[0];
      a = r + b.pop();
      return b.join(t) + a;
    };
    n.prototype.toHTML = function (a, b) {
      a = a || "span";
      var c = z(this),
        e = c.length;
      if (!e)
        return (b = b || u)
          ? "\x3c" + a + "\x3e" + b + "\x3c/" + a + "\x3e"
          : b;
      for (var d = 0; d < e; d++)
        c[d] = "\x3c" + a + "\x3e" + c[d] + "\x3c/" + a + "\x3e";
      if (1 === e) return c[0];
      e = r + c.pop();
      return c.join(t) + e;
    };
    n.prototype.addTo = function (a) {
      return x(this, a);
    };
    z = function (a) {
      var b = [],
        c = a.millennia;
      c && b.push(f(c, 10));
      (c = a.centuries) && b.push(f(c, 9));
      (c = a.decades) && b.push(f(c, 8));
      (c = a.years) && b.push(f(c, 7));
      (c = a.months) && b.push(f(c, 6));
      (c = a.weeks) && b.push(f(c, 5));
      (c = a.days) && b.push(f(c, 4));
      (c = a.hours) && b.push(f(c, 3));
      (c = a.minutes) && b.push(f(c, 2));
      (c = a.seconds) && b.push(f(c, 1));
      (c = a.milliseconds) && b.push(f(c, 0));
      return b;
    };
    d.MILLISECONDS = 1;
    d.SECONDS = 2;
    d.MINUTES = 4;
    d.HOURS = 8;
    d.DAYS = 16;
    d.WEEKS = 32;
    d.MONTHS = 64;
    d.YEARS = 128;
    d.DECADES = 256;
    d.CENTURIES = 512;
    d.MILLENNIA = 1024;
    d.DEFAULTS = 222;
    d.ALL = 2047;
    var E = (d.setFormat = function (a) {
        if (a) {
          if ("singular" in a || "plural" in a) {
            var b = a.singular || [];
            b.split && (b = b.split("|"));
            var c = a.plural || [];
            c.split && (c = c.split("|"));
            for (var d = 0; 10 >= d; d++)
              (p[d] = b[d] || p[d]), (q[d] = c[d] || q[d]);
          }
          "string" === typeof a.last && (r = a.last);
          "string" === typeof a.delim && (t = a.delim);
          "string" === typeof a.empty && (u = a.empty);
          "function" === typeof a.formatNumber && (y = a.formatNumber);
          "function" === typeof a.formatter && (f = a.formatter);
        }
      }),
      C = (d.resetFormat = function () {
        p =
          " millisecond; second; minute; hour; day; week; month; year; decade; century; millennium".split(
            ";"
          );
        q =
          " milliseconds; seconds; minutes; hours; days; weeks; months; years; decades; centuries; millennia".split(
            ";"
          );
        r = " and ";
        t = ", ";
        u = "";
        y = function (a) {
          return a;
        };
        f = D;
      });
    d.setLabels = function (a, b, c, d, f, k, m) {
      E({
        singular: a,
        plural: b,
        last: c,
        delim: d,
        empty: f,
        formatNumber: k,
        formatter: m,
      });
    };
    d.resetLabels = C;
    C();
    v && v.exports
      ? (v.exports = d)
      : "function" === typeof window.define &&
        "undefined" !== typeof window.define.amd &&
        window.define("countdown", [], function () {
          return d;
        });
    return d;
  })(module);

/*!
	Modaal - accessible modals - v0.4.4
	by Humaan, for all humans.
	http://humaan.com
 */
!(function (a) {
  function t(a) {
    var t = {},
      o = !1;
    a.attr("data-modaal-type") &&
      ((o = !0), (t.type = a.attr("data-modaal-type"))),
      a.attr("data-modaal-content-source") &&
        ((o = !0), (t.content_source = a.attr("data-modaal-content-source"))),
      a.attr("data-modaal-animation") &&
        ((o = !0), (t.animation = a.attr("data-modaal-animation"))),
      a.attr("data-modaal-animation-speed") &&
        ((o = !0), (t.animation_speed = a.attr("data-modaal-animation-speed"))),
      a.attr("data-modaal-after-callback-delay") &&
        ((o = !0),
        (t.after_callback_delay = a.attr("data-modaal-after-callback-delay"))),
      a.attr("data-modaal-is-locked") &&
        ((o = !0), (t.is_locked = "true" === a.attr("data-modaal-is-locked"))),
      a.attr("data-modaal-hide-close") &&
        ((o = !0),
        (t.hide_close = "true" === a.attr("data-modaal-hide-close"))),
      a.attr("data-modaal-background") &&
        ((o = !0), (t.background = a.attr("data-modaal-background"))),
      a.attr("data-modaal-overlay-opacity") &&
        ((o = !0), (t.overlay_opacity = a.attr("data-modaal-overlay-opacity"))),
      a.attr("data-modaal-overlay-close") &&
        ((o = !0),
        (t.overlay_close = "false" !== a.attr("data-modaal-overlay-close"))),
      a.attr("data-modaal-accessible-title") &&
        ((o = !0),
        (t.accessible_title = a.attr("data-modaal-accessible-title"))),
      a.attr("data-modaal-start-open") &&
        ((o = !0),
        (t.start_open = "true" === a.attr("data-modaal-start-open"))),
      a.attr("data-modaal-fullscreen") &&
        ((o = !0),
        (t.fullscreen = "true" === a.attr("data-modaal-fullscreen"))),
      a.attr("data-modaal-custom-class") &&
        ((o = !0), (t.custom_class = a.attr("data-modaal-custom-class"))),
      a.attr("data-modaal-close-text") &&
        ((o = !0), (t.close_text = a.attr("data-modaal-close-text"))),
      a.attr("data-modaal-close-aria-label") &&
        ((o = !0),
        (t.close_aria_label = a.attr("data-modaal-close-aria-label"))),
      a.attr("data-modaal-background-scroll") &&
        ((o = !0),
        (t.background_scroll =
          "true" === a.attr("data-modaal-background-scroll"))),
      a.attr("data-modaal-width") &&
        ((o = !0), (t.width = parseInt(a.attr("data-modaal-width")))),
      a.attr("data-modaal-height") &&
        ((o = !0), (t.height = parseInt(a.attr("data-modaal-height")))),
      a.attr("data-modaal-confirm-button-text") &&
        ((o = !0),
        (t.confirm_button_text = a.attr("data-modaal-confirm-button-text"))),
      a.attr("data-modaal-confirm-cancel-button-text") &&
        ((o = !0),
        (t.confirm_cancel_button_text = a.attr(
          "data-modaal-confirm-cancel-button-text"
        ))),
      a.attr("data-modaal-confirm-title") &&
        ((o = !0), (t.confirm_title = a.attr("data-modaal-confirm-title"))),
      a.attr("data-modaal-confirm-content") &&
        ((o = !0), (t.confirm_content = a.attr("data-modaal-confirm-content"))),
      a.attr("data-modaal-gallery-active-class") &&
        ((o = !0),
        (t.gallery_active_class = a.attr("data-modaal-gallery-active-class"))),
      a.attr("data-modaal-loading-content") &&
        ((o = !0), (t.loading_content = a.attr("data-modaal-loading-content"))),
      a.attr("data-modaal-loading-class") &&
        ((o = !0), (t.loading_class = a.attr("data-modaal-loading-class"))),
      a.attr("data-modaal-ajax-error-class") &&
        ((o = !0),
        (t.ajax_error_class = a.attr("data-modaal-ajax-error-class"))),
      a.attr("data-modaal-instagram-id") &&
        ((o = !0), (t.instagram_id = a.attr("data-modaal-instagram-id"))),
      o && a.modaal(t);
  }
  var o = {
      init: function (t, o) {
        var e = this;
        if (
          ((e.dom = a("body")),
          (e.$elem = a(o)),
          (e.options = a.extend({}, a.fn.modaal.options, e.$elem.data(), t)),
          (e.xhr = null),
          (e.scope = {
            is_open: !1,
            id:
              "modaal_" +
              new Date().getTime() +
              Math.random().toString(16).substring(2),
            source: e.options.content_source
              ? e.options.content_source
              : e.$elem.attr("href"),
          }),
          e.$elem.attr("data-modaal-scope", e.scope.id),
          (e.private_options = { active_class: "is_active" }),
          (e.lastFocus = null),
          e.options.is_locked ||
          "confirm" == e.options.type ||
          e.options.hide_close
            ? (e.scope.close_btn = "")
            : (e.scope.close_btn =
                '<button type="button" class="modaal-close" id="modaal-close" aria-label="' +
                e.options.close_aria_label +
                '"><span>' +
                e.options.close_text +
                "</span></button>"),
          "none" === e.options.animation &&
            ((e.options.animation_speed = 0),
            (e.options.after_callback_delay = 0)),
          a(o).on("click.Modaal", function (a) {
            a.preventDefault(), e.create_modaal(e, a);
          }),
          !0 === e.options.outer_controls)
        )
          var i = "outer";
        else var i = "inner";
        (e.scope.prev_btn =
          '<button type="button" class="modaal-gallery-control modaal-gallery-prev modaal-gallery-prev-' +
          i +
          '" id="modaal-gallery-prev" aria-label="Previous image (use left arrow to change)"><span>Previous Image</span></button>'),
          (e.scope.next_btn =
            '<button type="button" class="modaal-gallery-control modaal-gallery-next modaal-gallery-next-' +
            i +
            '" id="modaal-gallery-next" aria-label="Next image (use right arrow to change)"><span>Next Image</span></button>'),
          !0 === e.options.start_open && e.create_modaal(e);
      },
      create_modaal: function (a, t) {
        var o,
          a = this;
        if (
          ((a.lastFocus = a.$elem),
          !1 !== a.options.should_open &&
            ("function" != typeof a.options.should_open ||
              !1 !== a.options.should_open()))
        ) {
          switch ((a.options.before_open.call(a, t), a.options.type)) {
            case "inline":
              a.create_basic();
              break;
            case "ajax":
              (o = a.options.source(a.$elem, a.scope.source)), a.fetch_ajax(o);
              break;
            case "confirm":
              (a.options.is_locked = !0), a.create_confirm();
              break;
            case "image":
              a.create_image();
              break;
            case "iframe":
              (o = a.options.source(a.$elem, a.scope.source)),
                a.create_iframe(o);
              break;
            case "video":
              a.create_video(a.scope.source);
              break;
            case "instagram":
              a.create_instagram();
          }
          a.watch_events();
        }
      },
      watch_events: function () {
        var t = this;
        t.dom.off("click.Modaal keyup.Modaal keydown.Modaal"),
          t.dom.on("keydown.Modaal", function (o) {
            var e = o.keyCode,
              i = o.target;
            9 == e &&
              t.scope.is_open &&
              (a.contains(document.getElementById(t.scope.id), i) ||
                a("#" + t.scope.id)
                  .find('*[tabindex="0"]')
                  .focus());
          }),
          t.dom.on("keyup.Modaal", function (o) {
            var e = o.keyCode,
              i = o.target;
            return (
              o.shiftKey &&
                9 == o.keyCode &&
                t.scope.is_open &&
                (a.contains(document.getElementById(t.scope.id), i) ||
                  a("#" + t.scope.id)
                    .find(".modaal-close")
                    .focus()),
              !t.options.is_locked && 27 == e && t.scope.is_open
                ? !a(document.activeElement).is(
                    "input:not(:checkbox):not(:radio)"
                  ) && void t.modaal_close()
                : "image" == t.options.type
                ? (37 == e &&
                    t.scope.is_open &&
                    !a("#" + t.scope.id + " .modaal-gallery-prev").hasClass(
                      "is_hidden"
                    ) &&
                    t.gallery_update("prev"),
                  void (
                    39 == e &&
                    t.scope.is_open &&
                    !a("#" + t.scope.id + " .modaal-gallery-next").hasClass(
                      "is_hidden"
                    ) &&
                    t.gallery_update("next")
                  ))
                : void 0
            );
          }),
          t.dom.on("click.Modaal", function (o) {
            var e = a(o.target);
            if (
              !t.options.is_locked &&
              ((t.options.overlay_close && e.is(".modaal-inner-wrapper")) ||
                e.is(".modaal-close") ||
                e.closest(".modaal-close").length)
            )
              return void t.modaal_close();
            if (e.is(".modaal-confirm-btn"))
              return (
                e.is(".modaal-ok") &&
                  t.options.confirm_callback.call(t, t.lastFocus),
                e.is(".modaal-cancel") &&
                  t.options.confirm_cancel_callback.call(t, t.lastFocus),
                void t.modaal_close()
              );
            if (e.is(".modaal-gallery-control")) {
              if (e.hasClass("is_hidden")) return;
              return (
                e.is(".modaal-gallery-prev") && t.gallery_update("prev"),
                void (e.is(".modaal-gallery-next") && t.gallery_update("next"))
              );
            }
          });
      },
      build_modal: function (t) {
        var o = this,
          e = "";
        "instagram" == o.options.type && (e = " modaal-instagram");
        var i,
          l =
            "video" == o.options.type ? "modaal-video-wrap" : "modaal-content";
        switch (o.options.animation) {
          case "fade":
            i = " modaal-start_fade";
            break;
          case "slide-down":
            i = " modaal-start_slidedown";
            break;
          default:
            i = " modaal-start_none";
        }
        var n = "";
        o.options.fullscreen && (n = " modaal-fullscreen"),
          ("" === o.options.custom_class &&
            void 0 === o.options.custom_class) ||
            (o.options.custom_class = " " + o.options.custom_class);
        var s = "";
        o.options.width &&
        o.options.height &&
        "number" == typeof o.options.width &&
        "number" == typeof o.options.height
          ? (s =
              ' style="max-width:' +
              o.options.width +
              "px;height:" +
              o.options.height +
              'px;overflow:auto;"')
          : o.options.width && "number" == typeof o.options.width
          ? (s = ' style="max-width:' + o.options.width + 'px;"')
          : o.options.height &&
            "number" == typeof o.options.height &&
            (s = ' style="height:' + o.options.height + 'px;overflow:auto;"'),
          ("image" == o.options.type ||
            "video" == o.options.type ||
            "instagram" == o.options.type ||
            o.options.fullscreen) &&
            (s = "");
        var d = "";
        o.is_touch() && (d = ' style="cursor:pointer;"');
        var r =
          '<div class="modaal-wrapper modaal-' +
          o.options.type +
          i +
          e +
          n +
          o.options.custom_class +
          '" id="' +
          o.scope.id +
          '"><div class="modaal-outer-wrapper"><div class="modaal-inner-wrapper"' +
          d +
          ">";
        "video" != o.options.type &&
          (r += '<div class="modaal-container"' + s + ">"),
          (r +=
            '<div class="' +
            l +
            ' modaal-focus" aria-hidden="false" aria-label="' +
            o.options.accessible_title +
            " - " +
            o.options.close_aria_label +
            '" role="dialog">'),
          "inline" == o.options.type
            ? (r +=
                '<div class="modaal-content-container" role="document"></div>')
            : (r += t),
          (r += "</div>" + o.scope.close_btn),
          "video" != o.options.type && (r += "</div>"),
          (r += "</div>"),
          "image" == o.options.type &&
            !0 === o.options.outer_controls &&
            (r += o.scope.prev_btn + o.scope.next_btn),
          (r += "</div></div>"),
          a("#" + o.scope.id + "_overlay").length < 1 && o.dom.append(r),
          "inline" == o.options.type &&
            t.appendTo("#" + o.scope.id + " .modaal-content-container"),
          o.modaal_overlay("show");
      },
      create_basic: function () {
        var t = this,
          o = a(t.scope.source),
          e = "";
        o.length
          ? ((e = o.contents().detach()), o.empty())
          : (e =
              "Content could not be loaded. Please check the source and try again."),
          t.build_modal(e);
      },
      create_instagram: function () {
        var t = this,
          o = t.options.instagram_id,
          e = "",
          i =
            "Instagram photo couldn't be loaded, please check the embed code and try again.";
        if (
          (t.build_modal(
            '<div class="modaal-content-container' +
              ("" != t.options.loading_class
                ? " " + t.options.loading_class
                : "") +
              '">' +
              t.options.loading_content +
              "</div>"
          ),
          "" != o && null !== o && void 0 !== o)
        ) {
          var l =
            "https://api.instagram.com/oembed?url=http://instagr.am/p/" +
            o +
            "/";
          a.ajax({
            url: l,
            dataType: "jsonp",
            cache: !1,
            success: function (o) {
              t.dom.append(
                '<div id="temp-ig" style="width:0;height:0;overflow:hidden;">' +
                  o.html +
                  "</div>"
              ),
                t.dom.attr("data-igloaded")
                  ? window.instgrm.Embeds.process()
                  : t.dom.attr("data-igloaded", "true");
              var e = "#" + t.scope.id + " .modaal-content-container";
              a(e).length > 0 &&
                setTimeout(function () {
                  a("#temp-ig").contents().clone().appendTo(e),
                    a("#temp-ig").remove();
                }, 1e3);
            },
            error: function () {
              e = i;
              var o = a("#" + t.scope.id + " .modaal-content-container");
              o.length > 0 &&
                (o
                  .removeClass(t.options.loading_class)
                  .addClass(t.options.ajax_error_class),
                o.html(e));
            },
          });
        } else e = i;
        return !1;
      },
      fetch_ajax: function (t) {
        var o = this;
        null == o.options.accessible_title &&
          (o.options.accessible_title = "Dialog Window"),
          null !== o.xhr && (o.xhr.abort(), (o.xhr = null)),
          o.build_modal(
            '<div class="modaal-content-container' +
              ("" != o.options.loading_class
                ? " " + o.options.loading_class
                : "") +
              '">' +
              o.options.loading_content +
              "</div>"
          ),
          (o.xhr = a.ajax(t, {
            success: function (t) {
              var e = a("#" + o.scope.id).find(".modaal-content-container");
              e.length > 0 &&
                (e.removeClass(o.options.loading_class),
                e.html(t),
                o.options.ajax_success.call(o, e));
            },
            error: function (t) {
              if ("abort" != t.statusText) {
                var e = a("#" + o.scope.id + " .modaal-content-container");
                e.length > 0 &&
                  (e
                    .removeClass(o.options.loading_class)
                    .addClass(o.options.ajax_error_class),
                  e.html(
                    "Content could not be loaded. Please check the source and try again."
                  ));
              }
            },
          }));
      },
      create_confirm: function () {
        var a,
          t = this;
        (a =
          '<div class="modaal-content-container"><h1 id="modaal-title">' +
          t.options.confirm_title +
          '</h1><div class="modaal-confirm-content">' +
          t.options.confirm_content +
          '</div><div class="modaal-confirm-wrap"><button type="button" class="modaal-confirm-btn modaal-ok" aria-label="Confirm">' +
          t.options.confirm_button_text +
          '</button><button type="button" class="modaal-confirm-btn modaal-cancel" aria-label="Cancel">' +
          t.options.confirm_cancel_button_text +
          "</button></div></div></div>"),
          t.build_modal(a);
      },
      create_image: function () {
        var t,
          o,
          e = this,
          i = "";
        if (e.$elem.is("[data-group]") || e.$elem.is("[rel]")) {
          var l = e.$elem.is("[data-group]"),
            n = l ? e.$elem.attr("data-group") : e.$elem.attr("rel"),
            s = a(l ? '[data-group="' + n + '"]' : '[rel="' + n + '"]');
          s.removeAttr("data-gallery-active", "is_active"),
            e.$elem.attr("data-gallery-active", "is_active"),
            (o = s.length - 1);
          var d = [];
          (i = '<div class="modaal-gallery-item-wrap">'),
            s.each(function (t, o) {
              var e = "",
                i = "",
                l = "",
                n = !1,
                s = !1,
                r = o.getAttribute("data-modaal-desc"),
                c = o.getAttribute("data-gallery-active");
              a(o).attr("data-modaal-content-source")
                ? (e = a(o).attr("data-modaal-content-source"))
                : a(o).attr("href")
                ? (e = a(o).attr("href"))
                : a(o).attr("src")
                ? (e = a(o).attr("src"))
                : ((e =
                    "trigger requires href or data-modaal-content-source attribute"),
                  (s = !0)),
                "" != r && null !== r && void 0 !== r
                  ? ((i = r),
                    (l =
                      '<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image ' +
                      (t + 1) +
                      " - </span>" +
                      r.replace(/</g, "&lt;").replace(/>/g, "&gt;") +
                      "</div>"))
                  : (l =
                      '<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image ' +
                      (t + 1) +
                      "</span></div>"),
                c && (n = !0);
              var m = {
                url: e,
                alt: i,
                rawdesc: r,
                desc: l,
                active: n,
                src_error: s,
              };
              d.push(m);
            });
          for (var r = 0; r < d.length; r++) {
            var c = "",
              m = d[r].rawdesc
                ? "Image: " + d[r].rawdesc
                : "Image " + r + " no description";
            d[r].active && (c = " " + e.private_options.active_class);
            var p = d[r].src_error
              ? d[r].url
              : '<img src="' + d[r].url + '" alt=" " style="width:100%">';
            i +=
              '<div class="modaal-gallery-item gallery-item-' +
              r +
              c +
              '" aria-label="' +
              m +
              '">' +
              p +
              d[r].desc +
              "</div>";
          }
          (i += "</div>"),
            1 != e.options.outer_controls &&
              (i += e.scope.prev_btn + e.scope.next_btn);
        } else {
          var u,
            _ = !1;
          e.$elem.attr("data-modaal-content-source")
            ? (u = e.$elem.attr("data-modaal-content-source"))
            : e.$elem.attr("href")
            ? (u = e.$elem.attr("href"))
            : e.$elem.attr("src")
            ? (u = e.$elem.attr("src"))
            : ((u =
                "trigger requires href or data-modaal-content-source attribute"),
              (_ = !0));
          var v = "",
            f = "",
            m = "";
          e.$elem.attr("data-modaal-desc")
            ? ((m = e.$elem.attr("data-modaal-desc")),
              (v = e.$elem.attr("data-modaal-desc")),
              (f =
                '<div class="modaal-gallery-label"><span class="modaal-accessible-hide">Image - </span>' +
                v.replace(/</g, "&lt;").replace(/>/g, "&gt;") +
                "</div>"))
            : (m = "Image with no description");
          var p = _ ? u : '<img src="' + u + '" alt=" " style="width:100%">';
          i =
            '<div class="modaal-gallery-item is_active" aria-label="' +
            m +
            '">' +
            p +
            f +
            "</div>";
        }
        (t = i),
          e.build_modal(t),
          a(".modaal-gallery-item.is_active").is(".gallery-item-0") &&
            a(".modaal-gallery-prev").hide(),
          a(".modaal-gallery-item.is_active").is(".gallery-item-" + o) &&
            a(".modaal-gallery-next").hide();
      },
      gallery_update: function (t) {
        var o = this,
          e = a("#" + o.scope.id),
          i = e.find(".modaal-gallery-item"),
          l = i.length - 1;
        if (0 == l) return !1;
        var n = e.find(".modaal-gallery-prev"),
          s = e.find(".modaal-gallery-next"),
          d = 0,
          r = 0,
          c = e.find(".modaal-gallery-item." + o.private_options.active_class),
          m =
            "next" == t
              ? c.next(".modaal-gallery-item")
              : c.prev(".modaal-gallery-item");
        return (
          o.options.before_image_change.call(o, c, m),
          ("prev" != t || !e.find(".gallery-item-0").hasClass("is_active")) &&
            ("next" != t ||
              !e.find(".gallery-item-" + l).hasClass("is_active")) &&
            void c.stop().animate({ opacity: 0 }, 250, function () {
              m.addClass("is_next").css({
                position: "absolute",
                display: "block",
                opacity: 0,
              });
              var t = a(document).width(),
                i = t > 1140 ? 280 : 50;
              (d = e.find(".modaal-gallery-item.is_next").width()),
                (r = e.find(".modaal-gallery-item.is_next").height());
              var p = e
                  .find(".modaal-gallery-item.is_next img")
                  .prop("naturalWidth"),
                u = e
                  .find(".modaal-gallery-item.is_next img")
                  .prop("naturalHeight");
              p > t - i
                ? ((d = t - i),
                  e.find(".modaal-gallery-item.is_next").css({ width: d }),
                  e.find(".modaal-gallery-item.is_next img").css({ width: d }),
                  (r = e
                    .find(".modaal-gallery-item.is_next")
                    .find("img")
                    .height()))
                : ((d = p), (r = u)),
                e
                  .find(".modaal-gallery-item-wrap")
                  .stop()
                  .animate({ width: d, height: r }, 250, function () {
                    c
                      .removeClass(
                        o.private_options.active_class +
                          " " +
                          o.options.gallery_active_class
                      )
                      .removeAttr("style"),
                      c.find("img").removeAttr("style"),
                      m
                        .addClass(
                          o.private_options.active_class +
                            " " +
                            o.options.gallery_active_class
                        )
                        .removeClass("is_next")
                        .css("position", ""),
                      m.stop().animate({ opacity: 1 }, 250, function () {
                        a(this).removeAttr("style").css({ width: "100%" }),
                          a(this).find("img").css("width", "100%"),
                          e
                            .find(".modaal-gallery-item-wrap")
                            .removeAttr("style"),
                          o.options.after_image_change.call(o, m);
                      }),
                      e.find(".modaal-gallery-item").removeAttr("tabindex"),
                      e
                        .find(
                          ".modaal-gallery-item." +
                            o.private_options.active_class
                        )
                        .attr("tabindex", "0")
                        .focus(),
                      e
                        .find(
                          ".modaal-gallery-item." +
                            o.private_options.active_class
                        )
                        .is(".gallery-item-0")
                        ? n.stop().animate({ opacity: 0 }, 150, function () {
                            a(this).hide();
                          })
                        : n
                            .stop()
                            .css({
                              display: "block",
                              opacity: n.css("opacity"),
                            })
                            .animate({ opacity: 1 }, 150),
                      e
                        .find(
                          ".modaal-gallery-item." +
                            o.private_options.active_class
                        )
                        .is(".gallery-item-" + l)
                        ? s.stop().animate({ opacity: 0 }, 150, function () {
                            a(this).hide();
                          })
                        : s
                            .stop()
                            .css({
                              display: "block",
                              opacity: n.css("opacity"),
                            })
                            .animate({ opacity: 1 }, 150);
                  });
            })
        );
      },
      create_video: function (a) {
        var t,
          o = this;
        (t =
          '<iframe src="' +
          a +
          '" class="modaal-video-frame" frameborder="0" allowfullscreen></iframe>'),
          o.build_modal('<div class="modaal-video-container">' + t + "</div>");
      },
      create_iframe: function (a) {
        var t,
          o = this;
        (t =
          null !== o.options.width ||
          void 0 !== o.options.width ||
          null !== o.options.height ||
          void 0 !== o.options.height
            ? '<iframe src="' +
              a +
              '" class="modaal-iframe-elem" frameborder="0" allowfullscreen></iframe>'
            : '<div class="modaal-content-container">Please specify a width and height for your iframe</div>'),
          o.build_modal(t);
      },
      modaal_open: function () {
        var t = this,
          o = a("#" + t.scope.id),
          e = t.options.animation;
        "none" === e &&
          (o.removeClass("modaal-start_none"), t.options.after_open.call(t, o)),
          "fade" === e && o.removeClass("modaal-start_fade"),
          "slide-down" === e && o.removeClass("modaal-start_slide_down");
        var i = o;
        a(".modaal-wrapper *[tabindex=0]").removeAttr("tabindex"),
          (i =
            "image" == t.options.type
              ? a("#" + t.scope.id).find(
                  ".modaal-gallery-item." + t.private_options.active_class
                )
              : o.find(".modaal-iframe-elem").length
              ? o.find(".modaal-iframe-elem")
              : o.find(".modaal-video-wrap").length
              ? o.find(".modaal-video-wrap")
              : o.find(".modaal-focus")),
          i.attr("tabindex", "0").focus(),
          "none" !== e &&
            setTimeout(function () {
              t.options.after_open.call(t, o);
            }, t.options.after_callback_delay);
      },
      modaal_close: function () {
        var t = this,
          o = a("#" + t.scope.id);
        t.options.before_close.call(t, o),
          null !== t.xhr && (t.xhr.abort(), (t.xhr = null)),
          "none" === t.options.animation && o.addClass("modaal-start_none"),
          "fade" === t.options.animation && o.addClass("modaal-start_fade"),
          "slide-down" === t.options.animation &&
            o.addClass("modaal-start_slide_down"),
          setTimeout(function () {
            "inline" == t.options.type &&
              a("#" + t.scope.id + " .modaal-content-container")
                .contents()
                .detach()
                .appendTo(t.scope.source),
              o.remove(),
              t.options.after_close.call(t),
              (t.scope.is_open = !1);
          }, t.options.after_callback_delay),
          t.modaal_overlay("hide"),
          null != t.lastFocus && t.lastFocus.focus();
      },
      modaal_overlay: function (t) {
        var o = this;
        "show" == t
          ? ((o.scope.is_open = !0),
            o.options.background_scroll || o.dom.addClass("modaal-noscroll"),
            a("#" + o.scope.id + "_overlay").length < 1 &&
              o.dom.append(
                '<div class="modaal-overlay" id="' +
                  o.scope.id +
                  '_overlay"></div>'
              ),
            a("#" + o.scope.id + "_overlay")
              .css("background", o.options.background)
              .stop()
              .animate(
                { opacity: o.options.overlay_opacity },
                o.options.animation_speed,
                function () {
                  o.modaal_open();
                }
              ))
          : "hide" == t &&
            a("#" + o.scope.id + "_overlay")
              .stop()
              .animate({ opacity: 0 }, o.options.animation_speed, function () {
                a(this).remove(), o.dom.removeClass("modaal-noscroll");
              });
      },
      is_touch: function () {
        return "ontouchstart" in window || navigator.maxTouchPoints;
      },
    },
    e = [];
  (a.fn.modaal = function (t) {
    return this.each(function (i) {
      var l = a(this).data("modaal");
      if (l) {
        if ("string" == typeof t)
          switch (t) {
            case "open":
              l.create_modaal(l);
              break;
            case "close":
              l.modaal_close();
          }
      } else {
        var n = Object.create(o);
        n.init(t, this),
          a.data(this, "modaal", n),
          e.push({ element: a(this).attr("class"), options: t });
      }
    });
  }),
    (a.fn.modaal.options = {
      type: "inline",
      content_source: null,
      animation: "fade",
      animation_speed: 300,
      after_callback_delay: 350,
      is_locked: !1,
      hide_close: !1,
      background: "#000",
      overlay_opacity: "0.8",
      overlay_close: !0,
      accessible_title: "Dialog Window",
      start_open: !1,
      fullscreen: !1,
      custom_class: "",
      background_scroll: !1,
      should_open: !0,
      close_text: "Close",
      close_aria_label: "Close (Press escape to close)",
      width: null,
      height: null,
      before_open: function () {},
      after_open: function () {},
      before_close: function () {},
      after_close: function () {},
      source: function (a, t) {
        return t;
      },
      confirm_button_text: "Confirm",
      confirm_cancel_button_text: "Cancel",
      confirm_title: "Confirm Title",
      confirm_content:
        "<p>This is the default confirm dialog content. Replace me through the options</p>",
      confirm_callback: function () {},
      confirm_cancel_callback: function () {},
      gallery_active_class: "gallery_active_item",
      outer_controls: !1,
      before_image_change: function (a, t) {},
      after_image_change: function (a) {},
      loading_content:
        '<div class="modaal-loading-spinner"><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div>',
      loading_class: "is_loading",
      ajax_error_class: "modaal-error",
      ajax_success: function () {},
      instagram_id: null,
    }),
    a(function () {
      var o = a(".modaal");
      o.length &&
        o.each(function () {
          t(a(this));
        });
      var i = new MutationObserver(function (o) {
          o.forEach(function (o) {
            if (o.addedNodes && o.addedNodes.length > 0) {
              [].some.call(o.addedNodes, function (o) {
                var i = a(o);
                (i.is("a") || i.is("button")) &&
                  (i.hasClass("modaal")
                    ? t(i)
                    : e.forEach(function (t) {
                        if (t.element == i.attr("class"))
                          return a(i).modaal(t.options), !1;
                      }));
              });
            }
          });
        }),
        l = { subtree: !0, attributes: !0, childList: !0, characterData: !0 };
      setTimeout(function () {
        i.observe(document.body, l);
      }, 500);
    });
})(jQuery, window, document);
